import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDropzone } from "react-dropzone";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import {
  View,
  Box,
  Button,
  Center,
  CloseIcon,
  Divider,
  FlatList,
  HStack,
  Image,
  Input,
  Modal,
  Pressable,
  ScrollView,
  Text,
  Tooltip,
  VStack,
  Spinner,
  Heading,
} from "native-base";
import {
  AddIcon,
  AddPhotoIcon,
  BugReportIcon,
  DeleteIcon,
  EditIcon,
  FeatureRequestIcon,
  FeedbackIcon,
  MoreHorizontalIcon,
  Profile,
  ViewIcon,
  GroupChatIcon,
} from "../../assets/icons/icon-assets";
import helping from "../../assets/images/helping.png";
import inform from "../../assets/images/inform.png";
import suspend from "../../assets/images/unsuspend.png";
import * as AV from "../../AVCore/AVCore";
import { AVEntity } from "../../AVCore/AVEntity";
import { Media } from "../../AVCore/Media";
import { Server } from "../../Platform/Server";
import settings from "../../Platform/settings.json";
import { Loc } from "../../App/Loc";
import {
  setEntitydata,
  setEntityToken,
  setUser,
} from "../../Redux/Actions/userActions";
import { useWindowDimension } from "../../Utility/WindowDimensions";
import AVBody from "../../components/common/AVBody";
import {
  AVButtonRoundInvert,
  AVButtonRoundedFull,
} from "../../components/common/AVButtons";
import AVCancel from "../../components/common/AVCancel";
import PreviewAlbums from "../../components/common/PreviewAlbums";
import { PageLoader } from "../../components/loaders";
import PlayersCard from "../../components/teams/PlayersCard";
import ParticipantsCard from "../../components/teams/ParticipantsCard";
import StaffsCard from "../../components/teams/StaffsCard";
import Createalbumpopup from "../Home/Createalbumpopup";
import AVInputtext from "../../components/AVInputtext";
import TabHeader from "../../components/common/TabHeader";
import AVCreateEventModal from "../../components/common/AVCreateEventModal";
import ProfileHeader from "../../components/common/ProfileHeader";
import RenderSeriesEvents from "../Events/RenderSeriesEvents";
import AVCreateTeam from "../../components/common/AVCreateTeam";
import AVPersonaModal from "../../components/common/AVPersonModal";
import AVConfirmationModal from "../../components/common/AVConfirmationModal";
import CustomToast from "../../Hooks/useCustomToast";
import AVComDropdonwn from "../../components/common/AVComDropdown";
import useConvoChat from "../../Hooks/useConvoChat";
import _ from "lodash";
import {
  getAllNonRepeatingEvents,
  getEvent,
  getSeriesItem,
} from "../../Utility/utils";
import ErrorHandlerPopup from "../../components/common/ErrorHandlerPopup";
import Offline from "react-offline";
import AVFeedsProfile from "../Feeds/AVFeedsProfile";
import EntityProfilePic from "../../components/common/EntityProfilePic";
import { AVFeeCollection } from "../../components/common/EntityTabs/AVFeeCollection";
import { AVFeeCollectAbout } from "../../components/common/EntityTabs/AVFeeCollectAbout";
import { AVFeeCollectMembers } from "../../components/common/EntityTabs/AVFeeCollectMembers";
import { AVCardList } from "../../components/common/EntityTabs/AVCardList";
import AVConfirmLinkPopup from "../../components/common/AVConfirmLinkPopup";
import "driver.js/dist/driver.css";
import { driver } from "driver.js";

type FlowType =
  | "teamMember"
  | "teamSeasonPlayer"
  | "clubMember"
  | "clubTermMember"
  | "eliteClubMember"
  | "schoolStaff"
  | "schoolYearStudent"
  | "groupMember"
  | "classStudent"
  | "gradClassStudent"
  | "organizationEmployee"
  | "neighborhoodNeighbors"
  | "communityMember"
  | "performancePlayer"
  | null;

type ValidFlow = Exclude<FlowType, null>;
const flowKeyMap: Record<ValidFlow, string> = {
  teamMember: "showTeamMemberTour",
  teamSeasonPlayer: "showTeamSeasonPlayerTour",
  clubMember: "showClubMemberTour",
  clubTermMember: "showClubTermMemberTour",
  eliteClubMember: "showEliteClubMemberTour",
  schoolStaff: "showSchoolStaffTour",
  schoolYearStudent: "showSchoolYearStudentTour",
  groupMember: "showGroupMemberTour",
  classStudent: "showClassStudentTour",
  gradClassStudent: "showGradClassStudentTour",
  organizationEmployee: "showOrganizationEmployeeTour",
  neighborhoodNeighbors: "showNeighborhoodNeighborsTour",
  communityMember: "showCommunityMemberTour",
  performancePlayer: "showPerformancePlayerTour",
};

const flows: ValidFlow[] = [
  "teamMember",
  "teamSeasonPlayer",
  "clubMember",
  "clubTermMember",
  "eliteClubMember",
  "schoolStaff",
  "schoolYearStudent",
  "groupMember",
  "classStudent",
  "gradClassStudent",
  "organizationEmployee",
  "neighborhoodNeighbors",
  "communityMember",
  "performancePlayer",
];

const Teams = (props: any) => {
  const params = useParams();
  const location: any = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const type = params?.type;
  let viewTeam = location?.state?.team;
  const seriesId: any =
    params?.seriesId !== "undefined" && params?.seriesId !== undefined
      ? params?.seriesId
      : null;
  const orgFK = location?.state?.orgFK;
  const teamType = location?.state?.teamType;
  const Feedbacktype = useMemo(
    () => location?.state?.type,
    [location?.state?.type],
  );
  const FeedBackId = location?.state?.team?.id;
  const region = params?.region;
  const EntityId = params?.entityId;
  const currentUser: any = useSelector(
    (state: RootStateOrAny) => state?.user?.user[0],
  );
  const entitydatalist = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );
  let userconvo: any = useSelector(
    (state: RootStateOrAny) => state.convo.convo[0],
  );
  const entityToken = useSelector(
    (state: RootStateOrAny) => state?.user.entityToken,
  );
  const rightRef: any = useRef(null);
  const [helptext, sethelptext] = useState<any>();
  const [helptype, sethelptype] = useState<any>();
  const [staffemail, setstaffemail] = useState("");
  const [staffphone, setstaffphone] = useState("");
  const [staffpic, setstaffpic] = useState<any>("");
  const [albumlist, setalbumlist] = useState<any>([]);
  const [filesList, setfilesList] = useState([]);
  const [isDocumentPage, setIsDocumentPage] = useState(false);
  const [isCreate, setIsCreate] = useState(location?.state?.isCreate);
  const [isUpdate, setIsUpdate] = useState(true);
  const [isLoader, setLoader] = useState(false);
  const [isShowEdit, setIsShowEdit] = useState<any>(false);
  const [isEditEntireSeries, setIsEditEntireSeries] = useState<any>(false);
  const [showAddProfileModal, setShowAddProfileModal] = useState(false);
  const [isPlayer, setIsPlayer] = useState(true);
  const [isStaff, setIsStaff] = useState(false);
  const [isParticipant, setIsParticipant] = useState(false);
  const [showAddEventsModal, setShowAddEventsModal] = useState(false);
  const [memberList, setmemberList] = useState<any>([]);
  const [GroupList, setGroupList] = useState<any>([]);
  const [orgList, setOrgList] = useState<any>([]);
  const [playersList, setPlayersList] = useState<any>([]);
  const [participantList, setIsParticipantList] = useState<any>();
  const [staffList, setStaffList] = useState<any>([]);
  const [Editstaffitem, setEditstaffitem] = useState<any>();
  const [eventsList, setEventsList] = useState<any>([]);
  const [leagueTeamFK, setLeagueTeamFK] = useState<any>();
  const [isMascotLoader, setMascotLoader] = useState(false);
  const [teamName, setteamName] = useState(
    location?.state?.searchInput ? location?.state?.searchInput : "",
  );
  const [links, setLinks] = useState("");
  const [intro, setIntro] = useState("");
  const [activity, setActivity] = useState();
  const [activityType, setActivityType] = useState(null);
  const [playerName, setPlayerName] = useState("");
  const [playerEmailAddress, setPlayerEmailAddress] = useState("");
  const [playerPhone, setPlayerPhone] = useState("");
  const [staffName, setStaffName] = useState("");
  const [staffEmailAddress, setStaffEmailAddress] = useState("");
  const [staffPhone, setStaffPhone] = useState("");
  const [isTeamsPage, setIsTeamsPage] = useState(true);
  const [isGroup, setIsGroup] = useState(false);
  const [isOrganization, setIsOrganization] = useState(false);
  const [seriesEventsList, setSeriesEventsList] = useState([]);
  const [isFeebackGroup, setIsFeedBackGroup] = useState(false);
  const [isPlayerPage, setIsPlayerPage] = useState(false);
  const [isStaffPage, setIsStaffPage] = useState(false);
  const [isSeasonPage, setIsSeasonPage] = useState(false);
  const [isEventPage, setIsEventPage] = useState(false);
  const [isPhotoPage, setIsPhotoPage] = useState(false);
  const [isOccurencePage, setIsOccurencePage] = useState(false);
  const [pageLoader, setPageLoader] = useState(true);
  const [isPicLoader, setIsPicLoader] = useState(false);
  const [isMembersPage, setIsMembersPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMyFavourite, setMyFavourite] = useState(
    currentUser?.favs?.filter((x) => x?.id === viewTeam?.id)[0] ? true : false,
  );
  const [isHuddleData, setIshuddleData] = useState();
  const [checkvalue, setcheckvalue] = useState(true);
  const [checkvaluedata, setcheckvaluedata] = useState<any>("");
  const [profile, setProfile] = useState<any>({
    background: null,
    pic: null,
    thumb: null,
    gallery: null,
    previousPic: null,
    text: null,
    color: null,
  });
  const [repeatWeek, setRepeatWeek] = useState<any>();
  const [filteredResults, setfilteredResults] = useState<any>([]);
  const [isAdminView, setIsAdminView] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const pathName = window.location.pathname;
  const [showTempList, setshowTempList] = useState([]);
  const [staffRole, setStaffRole] = useState<any>("");
  const [locationaddress, setlocationaddress] = useState<any>([]);
  const [googlemap, setgooglemap] = useState();
  const [isActive, setIsActive] = useState(false);
  const [isActiveRole, setIsActiveRole] = useState(false);
  const [activityRole, setActivityRole] = useState(null);
  const [isFollowing, setIsFollowing] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  const user = useSelector((state: RootStateOrAny) => state?.user?.user[0]);
  const userfeeds = useSelector(
    (state: RootStateOrAny) => state.feeds.feeds[0],
  );
  const [isStaffentity, setisStaffentity] = useState(false);
  const [isMemberEntity, setisMemberEntity] = useState(false);
  const [isPlayerEntity, setisPlayerEntity] = useState(false);
  const [showFileuploadModal, setshowFileuploadModal] = useState(false);
  const [contactList, setcontactList] = useState<any>();
  const [error, setError] = useState<any>(null);
  const dimensions = useWindowDimension();
  const mobile = dimensions?.width < 600 || false;
  const [visible, setVisible] = useState(false);
  const [datas, setdatas] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [isSuspended, setIsSuspended] = useState(false);
  const [isStaffEdit, setIsStaffEdit] = useState(false);
  const [isDropDown, setIsDropDown] = useState<boolean>(false);
  const [isShowPayPopup, setIsShowPayPopup] = useState(false);
  const isMobile = dimensions?.width <= 500 || false;
  const isLMobile = dimensions?.width <= 767 || false;
  const isTab = dimensions?.width <= 1300 || false;
  const [typeevent, settypeevent] = useState("Social");
  const [isEditPlayerDetails, setIsEditPlayerDetails] = useState(false);
  const [menu, setmenu] = useState<any>("");
  const [newname, setnewname] = useState<any>();
  const [newmail, setnewmail] = useState<any>();
  const [newPhone, setNewPhone] = useState<any>();
  const [newParentName, setNewParentName] = useState<any>();
  const [newParentEmail, setNewParentEmail] = useState<any>();
  const [newParentPhone, setNewParentPhone] = useState<any>();
  const [isHomePage, setIsHomePage] = useState(false);
  const [isshowteamsList, setisshowteamsList] = useState<any>();
  const [fixedWidth, setFixedWidth] = useState<any>();
  const [showFields, setShowFields] = useState(false);
  const [updateField, setIsUpdateField] = useState(false);
  const [fieldName, setIsFieldName] = useState("");
  const [datafield, setIsDataField] = useState<any>([]);
  const [siteField, setSiteField] = useState<any>();
  const [isActives, setIsActives] = useState(false);
  const [isGame, setIsGame] = useState(false);
  const [isPractice, setIsPractice] = useState(false);
  const [mapField, setIsMapField] = useState();
  const [isFieldsName, setIsFieldsName] = useState();
  const [staffReq, setIsStaffReq] = useState<any>(false);
  const [childOrgReq, setIsChildOrgReq] = useState(false);
  const [StaffDesc, setIsStaffDesc] = useState("");
  const [justi, setJusti] = useState("");
  const [childOrgOne, setChildOrg] = useState("");
  const [selctChildOrg, SetSelctChildOrg] = useState<any>();
  const [chiledorgId, setChildorgId] = useState<any>("");
  const [isDropList, setIsDropList] = useState(false);
  const [isparticipantspage, setisparticipantspage] = useState(false);
  const [isResourses, setisResourses] = useState(false);
  const [weather, setweather] = useState<any>();
  const [weatherURL, setweatherURL] = useState<any>();
  const [status, setStatus] = useState("All");
  const [resoursesList, setresoursesList] = useState<any>([]);
  const [editresourses, seteditresourses] = useState(false);
  const [Owner, setOwner] = useState(null);
  const [showAddResourceModal, setshowAddResourceModal] = useState(false);
  const [showResourceModal, setshowResourceModal] = useState(false);
  const [description, setdescription] = useState<any>("");
  const [quantity, setquantity] = useState<any>(1);
  const [isSearchPart, setIsSearchPart] = useState(true);
  const [assienTeammember, setassienTeammember] = useState("");
  const [note, setnote] = useState<any>("");
  const [deleteresourses, setdeleteresourses] = useState();
  const [isImagePopup, setIsImagePopup] = useState(false);
  const [siteMap, setSiteMap] = useState<any>();
  const [isOpen, setIsOpen] = useState(false);
  var target: any = AV.AVEntity.getFk(leagueTeamFK);
  var sourceFK: any = AV.AVEntity.getFk(currentUser);
  const [isFilesView, setisFilesView] = useState(true);
  const [isConfirmDelete, setisConfirmDelete] = useState(false);
  const [Confirmationtext, setConfirmationtext] = useState("Are you sure ?");
  const [selectType, setselectType] = useState<any>();
  const [itemSelect, setItemSelect] = useState<any>("");
  const [isOngoingOrFuture, setIsOngoingOrFuture] = useState(false);
  const [isEntireSeriesAvailable, setIsEntireSeriesAvailable] = useState(false);
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const [isTeam, setIsTeam] = useState(false);
  const [searchTypes, setSearchTypes] = useState("");
  const [showCreateNewPage, setShowCreateNewPage] = useState<any>(false);
  const [createType, setCreateType] = useState<any>("");
  const [passEntity, setPassEntity] = useState<any>("");
  const [isOrgOpen, setOrgOpen] = useState(false);
  const [filteredParticipantList, setFilteredParticipantList] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [singleImage, setSingleImage] = useState();
  const [allImages, setShowAllImage] = useState<any>([]);
  const [restoreRefresh, setRestoreRefresh] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [isOpenConvo, setIsOpenConvo] = useState(false);
  const { handleSendSingleChat } = useConvoChat();
  const [isRotate, setIsRotate] = useState(false);
  const [isShowEditOccurence, setIsShowEditOccurence] = useState(false);
  const [isShowEditEntireSeries, setIsShowEditEntireSeries] = useState(false);
  const [isConvoData, setIsConvoData] = useState("");
  const [isMemberTab, setIsMemberTab] = useState<any>("");
  const [showunauthorizedDetails, setshowunauthorizedDetails] = useState(false);

  // Events Tab
  const [allEventData, setEventData] = useState<any>([]);
  const [allEvents, setAllEvents] = useState<any>([]);
  const [filteredEvents, setFilteredEvents] = useState<any>([]);
  const [eventType, setEventType] = useState(Loc.currentLang.menu.current);
  const [isCalendarView, setIsCalenderView] = useState(true);
  const currentItem = seriesId
    ? leagueTeamFK?.seriesEvents?.find((se) => se.id === seriesId)
    : null;
  const [seriesEvent, setSeriesEvent] = useState(
    currentItem?.id ? currentItem : location?.state?.series,
  );
  const [isLoadingEvent, setIsLoadingEvent] = useState(false);

  // Huddles Tab
  const [isHuddlePage, setIsHuddlePage] = useState(false);
  const convoKeyMap: Record<string, string> = {
    S: "sConvo",
    M: "mConvo",
    P: "pConvo",
    N: "nConvo",
    W: "wConvo",
    X: "xConvo",
    Y: "yConvo",
    A: "aConvo",
  };
  const checkConvoExitorNot = (type: string) => {
    const key = convoKeyMap[type];
    return key ? leagueTeamFK?.[key] : "";
  };

  // Fee Collection
  const [isCollectAboutPage, setIsCollectAboutPage] = useState(false);
  const [isFeeCollectionPage, setIsFeeCollectionPage] = useState(false);
  const [isCollectMembersPage, setIsCollectMembersPage] = useState(false);

  // School Entity
  const [isSchoolTeamsPage, setIsSchoolTeamsPage] = useState(false);
  const [isSchoolYearsPage, setIsSchoolYearsPage] = useState(false);
  const [isSchoolAlumniPage, setIsSchoolAlumniPage] = useState(false);
  const [isSchoolGradClassPage, setIsSchoolGradClassPage] = useState(false);
  const [isSchoolAlumniGradClassPage, setIsSchoolAlumniGradClassPage] =
    useState(false);
  const [isSchoolYearOrgPage, setIsSchoolYearOrgPage] = useState(false);
  const [isSchoolYearGradClassPage, setIsSchoolYearGradClassPage] =
    useState(false);
  const [schoolYearOrgList, setSchoolYearOrgList] = useState<AV.ILink[]>([]);
  const [isSchoolYearsOrgTabOption, setIsSchoolYearsOrgTabOption] =
    useState(false);

  const [clickedUrl, setClickedUrl] = useState("");
  const [showConfirmLinkPopup, setShowConfirmLinkPopup] = useState(false);

  // Tour Guide
  const [onboardingStep, setOnboardingStep] = useState<number>(0);
  const [onboardingFlow, setOnboardingFlow] = useState<FlowType>(null);

  const addPlayerBtnRef = useRef<HTMLDivElement | null>(null);

  const clearCurrentTourFlow = () => {
    if (!onboardingFlow) return;

    const key = flowKeyMap[onboardingFlow];
    localStorage.removeItem(key);

    setOnboardingFlow(null);
    setOnboardingStep(0);
  };

  useEffect(() => {
    if (!onboardingFlow) return;
    if (
      (onboardingFlow === "teamMember" ||
        onboardingFlow === "clubMember" ||
        onboardingFlow === "eliteClubMember" ||
        onboardingFlow === "schoolStaff") &&
      onboardingStep !== 3
    )
      return;
    if (
      (onboardingFlow === "teamSeasonPlayer" ||
        onboardingFlow === "performancePlayer" ||
        onboardingFlow === "clubTermMember" ||
        onboardingFlow === "schoolYearStudent" ||
        onboardingFlow === "groupMember" ||
        onboardingFlow === "classStudent" ||
        onboardingFlow === "gradClassStudent" ||
        onboardingFlow === "organizationEmployee" ||
        onboardingFlow === "neighborhoodNeighbors" ||
        onboardingFlow === "communityMember") &&
      onboardingStep !== 2
    )
      return;
    if (
      onboardingFlow === "teamMember" ||
      onboardingFlow === "clubMember" ||
      onboardingFlow === "eliteClubMember" ||
      onboardingFlow === "schoolStaff"
    )
      return;
    if (
      (onboardingFlow === "teamSeasonPlayer" ||
        onboardingFlow === "performancePlayer" ||
        onboardingFlow === "clubTermMember" ||
        onboardingFlow === "schoolYearStudent" ||
        onboardingFlow === "groupMember" ||
        onboardingFlow === "classStudent" ||
        onboardingFlow === "gradClassStudent" ||
        onboardingFlow === "organizationEmployee" ||
        onboardingFlow === "neighborhoodNeighbors" ||
        onboardingFlow === "communityMember") &&
      !addPlayerBtnRef.current
    )
      return;

    let element: HTMLDivElement | null = null;
    let roleText = "";
    let stepTitle = "";

    switch (onboardingFlow) {
      case "teamSeasonPlayer":
      case "performancePlayer":
      case "clubTermMember":
      case "groupMember":
      case "performancePlayer":
        element = addPlayerBtnRef.current;
        roleText =
          onboardingFlow === "clubTermMember" ||
          onboardingFlow === "groupMember"
            ? Loc.currentLang.inviteTourGuide.members
            : Loc.currentLang.inviteTourGuide.players;
        stepTitle = Loc.currentLang.inviteTourGuide.step3_2;
        break;

      case "schoolYearStudent":
      case "classStudent":
      case "gradClassStudent":
        element = addPlayerBtnRef.current;
        roleText = Loc.currentLang.inviteTourGuide.students;
        stepTitle = Loc.currentLang.inviteTourGuide.step3_2;
        break;

      default:
        return;
    }

    if (!element) return;

    const tour = driver({
      showProgress: false,
      allowClose: true,
      overlayClickBehavior: () => {},
      showButtons: [],
      onCloseClick: () => {
        tour.destroy();
        clearCurrentTourFlow();
      },
      steps: [
        {
          element,
          popover: {
            title: stepTitle,
            description: `${Loc.currentLang.inviteTourGuide.clickPlus} ${roleText}.`,
            side: "left",
            align: "center",
          },
        },
      ],
      onPopoverRender: (popover) => {
        const footer = popover.wrapper.querySelector(
          ".driver-popover-footer",
        ) as HTMLElement;
        if (!footer) return;

        footer.innerHTML = "";
        footer.style.display = "flex";
        footer.style.justifyContent = "space-between";

        const skip = document.createElement("button");
        skip.innerText = Loc.currentLang.inviteTourGuide.skip;
        skip.className = "tour-btn-secondary";
        skip.onclick = () => {
          tour.destroy();
          clearCurrentTourFlow();
        };

        const right = document.createElement("div");
        right.style.display = "flex";
        right.style.gap = "8px";

        const prev = document.createElement("button");
        prev.innerText = Loc.currentLang.inviteTourGuide.previous;
        prev.className = "tour-btn-secondary";
        prev.onclick = () => {
          tour.destroy();
          setOnboardingStep(
            onboardingFlow === "teamSeasonPlayer" ||
              onboardingFlow === "performancePlayer" ||
              onboardingFlow === "clubTermMember" ||
              onboardingFlow === "schoolYearStudent" ||
              onboardingFlow === "groupMember" ||
              onboardingFlow === "classStudent" ||
              onboardingFlow === "gradClassStudent"
              ? 1
              : 0,
          );
        };

        const next = document.createElement("button");
        next.innerText = Loc.currentLang.inviteTourGuide.next;
        next.className = "tour-btn-primary";
        next.onclick = () => {
          tour.destroy();
          handleProfileType(
            onboardingFlow === "teamSeasonPlayer" ||
              onboardingFlow === "performancePlayer" ||
              onboardingFlow === "clubTermMember" ||
              onboardingFlow === "schoolYearStudent" ||
              onboardingFlow === "classStudent" ||
              onboardingFlow === "gradClassStudent"
              ? "Player"
              : "",
          );
          setOnboardingStep(
            onboardingFlow === "teamSeasonPlayer" ||
              onboardingFlow === "performancePlayer" ||
              onboardingFlow === "clubTermMember" ||
              onboardingFlow === "schoolYearStudent" ||
              onboardingFlow === "classStudent" ||
              onboardingFlow === "gradClassStudent"
              ? 3
              : 0,
          );
        };

        right.append(prev, next);
        footer.append(skip, right);
      },
    });

    setTimeout(() => tour.drive(), 100);
  }, [onboardingFlow, onboardingStep]);

  const fetchAllEvents = async () => {
    try {
      if (leagueTeamFK === undefined || allEvents?.length > 0) {
        return false;
      }

      setIsLoadingEvent(true);
      let ownedEvents = leagueTeamFK?.ownedEvents;
      let nonRepeatingEvents = ownedEvents?.filter(
        (event) => !event?.events || event?.events.length === 0,
      );
      let repeatingEvents = ownedEvents?.filter(
        (event) => event?.events && event?.events.length > 0,
      );

      let allRepeatingEvents: any = [];

      for (const event of repeatingEvents) {
        let repeatedEvents: any = await getSeriesItem(event, currentUser);
        allRepeatingEvents.push(...repeatedEvents);
      }
      let allNonRepeatingEvents: any = [];

      for (const event of nonRepeatingEvents) {
        let nonRepeatedEvents: any = await getAllNonRepeatingEvents(event);
        allNonRepeatingEvents.push(...nonRepeatedEvents);
      }

      let allEventList = [...allNonRepeatingEvents, ...allRepeatingEvents].sort(
        (a, b) => new Date(a.start).getTime() - new Date(b.start).getTime(),
      );
      setSeriesEventsList(allRepeatingEvents);
      setEventData(allEventList);
      setAllEvents(allEventList);
      setEventType(Loc.currentLang.menu.current);
      setFilteredEvents(
        allEventList.filter(
          (e) => new Date(e.start).getTime() >= new Date().getTime(),
        ),
      );
      setIsLoadingEvent(false);
      //HandleCurrent();
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  useEffect(() => {
    console.log("useEffect2");
    fetchAllEvents();
  }, [isCalendarView, isEventPage]);

  //Reload
  const handleOnline = () => {
    window.location.href = window.location.origin;
    window.location.reload();
  };

  // Add event listener for online event
  window.addEventListener("online", handleOnline);

  //Remove staff
  const handleRemoveStaff = async (item) => {
    setcontactList(contactList?.filter((x) => x !== item));
  };

  //Styling
  const customSelectStyle = {
    maxHeight: "40px", // Set your desired height here
    width: "230px",
  };

  const customSelectStyleeeess = {
    maxHeight: "32px", // Set your desired height here
  };

  //Restore account
  const HandleRestoreAccount = () => {
    setisConfirmDelete(true);
    setConfirmationtext(
      Loc.currentLang.menu.areYouSureYouWantToRestoreYourAccount,
    );
    setItemSelect(leagueTeamFK);
    setselectType("RestoreAccount");
  };

  const handleRestore = async () => {
    setLoader(true);

    if (leagueTeamFK?.status === "Deleted") {
      await AV.AVEntity.unDelete(leagueTeamFK);
      leagueTeamFK.status = "";
      entitydatalist[
        entitydatalist.indexOf(
          entitydatalist?.find((x) => x?.id === leagueTeamFK?.id),
        )
      ] = leagueTeamFK;
      dispatch(setEntitydata(entitydatalist));
      let Index = user?.orgs?.findIndex((x) => x?.id === leagueTeamFK?.id);
      if (Index !== -1) {
        user.orgs[Index].hidden = "";
        dispatch(setUser(user));
      }
    } else await AV.AVEntity.unSuspend(leagueTeamFK);
    setLoader(false);
    setisConfirmDelete(false);
    setRestoreRefresh(!restoreRefresh);
  };

  const handleConfirmToggleSilence = (item) => {
    const isSilenced = currentUser?.silenced?.some((x) => x?.id === item?.id);
    setisConfirmDelete(true);
    setConfirmationtext(
      isSilenced
        ? Loc.currentLang.menu.areYouSurewantToUnSilence
        : Loc.currentLang.menu.areYouSurewantToSilence,
    );
    setItemSelect(item);
    setselectType("ToggleSilence");
  };

  const handleToggleSilence = async () => {
    if (!itemSelect || !itemSelect.id) return;

    try {
      setLoader(true);
      const isSilenced = currentUser?.silenced?.some(
        (x) => x?.id === itemSelect.id,
      );

      if (isSilenced) {
        await AV.AVEntity.UnSilence(sourceFK, itemSelect);
      } else {
        await AV.AVEntity.silence(sourceFK, itemSelect);
      }

      const userUpdate = await AV.Person.getSelf();
      if (userUpdate?.id) {
        dispatch(setUser(userUpdate));
      }
    } catch (error) {
      console.error("Silence action failed:", error);
    } finally {
      setLoader(false);
      setIsOpen(!isOpen);
      setselectType("");
      setisConfirmDelete(false);
      setConfirmationtext("");
      setItemSelect("");
    }
  };

  //Remove Participant
  const RemoveParticiapnt = async () => {
    setLoader(true);
    let occurId =
      leagueTeamFK?.series && leagueTeamFK?.id !== leagueTeamFK?.series
        ? leagueTeamFK?.id
        : null;
    if (leagueTeamFK?.series && leagueTeamFK?.id !== leagueTeamFK?.series) {
      let fk = {
        id: leagueTeamFK?.series,
        pk: leagueTeamFK?.pk,
        region: leagueTeamFK?.region,
        type: leagueTeamFK?.type,
      };
      let removeStaff: any = await AV.Event.removeParticipant(
        fk,
        itemSelect,
        occurId,
      );
      if (removeStaff !== null) {
        //setLeagueTeamFK(removeStaff);

        if (removeStaff.seriesEvents?.some((x) => x.id === seriesId)) {
          const seriesParticipants =
            removeStaff.seriesEvents.find((x) => x.id === seriesId)
              ?.participants || [];
          const allParticipants = [
            ...removeStaff.participants,
            ...seriesParticipants,
          ];

          setIsParticipantList(allParticipants);
          setFilteredParticipantList(removeStaff.participants);
        }

        const isAdminOrStaff =
          removeStaff?.status == "Canceled"
            ? false
            : removeStaff?.participants?.some(
                (x) =>
                  x?.id === user?.id &&
                  (x?.linkType === "Owner" || x?.linkType === "Staff"),
              );
        setIsAdminView(isAdminOrStaff);
      }
    } else {
      if (
        leagueTeamFK?.eventType === "Meeting" ||
        leagueTeamFK?.eventType === "Practice"
      ) {
        occurId = isEditEntireSeries
          ? null
          : seriesId !== "undefined" && seriesId !== undefined
            ? seriesId
            : null;
        occurId =
          leagueTeamFK?.participants?.findIndex(
            (x) => x?.id === itemSelect?.id,
          ) === 1
            ? null
            : occurId;
      }

      let removeStaff: any = await AV.Event.removeParticipant(
        AVEntity.getFk(leagueTeamFK),
        itemSelect,
        occurId,
      );
      if (removeStaff !== null) {
        setLeagueTeamFK(removeStaff);
        setIsParticipantList(removeStaff?.participants);
        setFilteredParticipantList(removeStaff?.participants);
        const isAdminOrStaff =
          removeStaff?.status == "Canceled"
            ? false
            : removeStaff?.participants?.some(
                (x) =>
                  x?.id === user?.id &&
                  (x?.linkType === "Owner" || x?.linkType === "Staff"),
              );
        setIsAdminView(isAdminOrStaff);

        if (leagueTeamFK?.type === "Event") {
          setIsParticipantList(
            participantList?.filter((x) => x?.id !== itemSelect?.id),
          );
          setFilteredParticipantList(
            participantList?.filter((x) => x?.id !== itemSelect?.id),
          );
        }
      }
    }
    setLoader(false);
    setisConfirmDelete(false);
  };

  //Search
  const searchPlayerItems = async (searchValue) => {
    setcheckvalue(true);
    setcheckvaluedata("");
    setIsSearchPart(true);
    if (searchValue == "") {
      setPlayerName(searchValue);
      setassienTeammember(searchValue);
      setfilteredResults([]);
    } else {
      if (!showAddResourceModal) {
        const searchfollowerdata = await AV.Person.localSearch(searchValue);
        setfilteredResults(
          searchfollowerdata.filter((x) => x.type == "Person"),
        );
        setPlayerName(searchValue);
      } else {
        const searchparticipantsdata = participantList?.filter((l) =>
          l.title?.toLowerCase().includes(searchValue.toLowerCase()),
        );
        setfilteredResults(searchparticipantsdata);
        setassienTeammember(searchValue);
      }
    }
  };

  //HandlePlayerName
  const handlePlayerName = (item: any) => {
    setassienTeammember(item?.title);
    setPlayerName(item.title);
    setcheckvaluedata(item);
    setcheckvalue(false);
    setfilteredResults([]);
  };

  //Remove Resoruce
  const handleRemoveResourcePopup = (item) => {
    setisConfirmDelete(true);
    setItemSelect(item);
    setConfirmationtext(
      Loc.currentLang.confirmationText.areYouSureYouWantToRemoveThisItem,
    );
    setselectType("RemoveResource");
  };

  const handleRemoveResourses = async () => {
    setLoader(true);

    let occurId =
      leagueTeamFK?.series && leagueTeamFK?.id !== leagueTeamFK?.series
        ? leagueTeamFK?.id
        : null;
    if (
      leagueTeamFK?.eventType === "Meeting" ||
      leagueTeamFK?.eventType === "Practice"
    ) {
      occurId = isEditEntireSeries
        ? null
        : seriesId !== "undefined" && seriesId !== undefined
          ? seriesId
          : null;
      const resourceFound = leagueTeamFK?.resources?.some(
        (x) => x?.resourceId === itemSelect?.resourceId,
      );
      occurId = resourceFound ? null : occurId;
    }

    var val: any = await AV.Event.removeResource(
      AVEntity.getFk(leagueTeamFK),
      itemSelect?.id || itemSelect?.resourceId ? itemSelect : deleteresourses,
      occurId,
    );
    if (val) {
      setLeagueTeamFK(val);
      setresoursesList(val?.resources);

      if (
        leagueTeamFK?.eventType === "Meeting" ||
        leagueTeamFK?.eventType === "Practice"
      ) {
        const mainResources = val.resources || [];
        const seriesEventResources =
          val.seriesEvents?.find((x) => x.id === occurId)?.resources || [];

        // Combine and remove duplicates by resourceId
        const mergedResources = [
          ...mainResources,
          ...seriesEventResources.filter(
            (seriesRes) =>
              !mainResources.some(
                (mainRes) => mainRes.resourceId === seriesRes.resourceId,
              ),
          ),
        ];

        setresoursesList(mergedResources);
      }
    }

    setshowAddResourceModal(false);
    seteditresourses(false);
    setdescription("");
    setnote("");
    setassienTeammember("");
    setquantity("");
    setcheckvalue(true);
    setcheckvaluedata("");
    setLoader(false);
    setItemSelect("");
    setselectType("");
    setConfirmationtext("");
    setisConfirmDelete(false);
  };

  //Add Resource
  const handleAddResources = async () => {
    if (
      deleteresourses === undefined &&
      assienTeammember?.length > 0 &&
      (checkvaluedata === undefined ||
        checkvaluedata?.length === 0 ||
        checkvaluedata?.id?.length === 0)
    ) {
      setError(Loc.currentLang.feeCollect.memberValidation);
      return;
    }

    setLoader(true);
    // Helper to merge meeting resources
    const mergeMeetingResources = (eventVal: any, isSeries: any) => {
      isSeries = isSeries === null ? seriesId : isSeries;
      const mainResources = eventVal.resources || [];
      const seriesEventResources =
        eventVal.seriesEvents?.find((x: any) => x.id === isSeries)?.resources ||
        [];

      // Combine and remove duplicates by resourceId
      return [
        ...mainResources,
        ...seriesEventResources.filter(
          (seriesRes: any) =>
            !mainResources.some(
              (mainRes: any) => mainRes.resourceId === seriesRes.resourceId,
            ),
        ),
      ];
    };

    if (!editresourses) {
      // ADD resource
      let eventResources: AV.IEventResource = {
        quantity: Number(quantity),
        notes: note,
        resource: description,
        resourceId: Server.generateUUID(),
        id: checkvaluedata?.id,
        pk: checkvaluedata?.pk,
        region: checkvaluedata?.region,
        type: checkvaluedata?.type,
        thumb: checkvaluedata?.thumb,
        title: checkvaluedata?.title,
        background: checkvaluedata?.background,
      };

      let isSeries = isEditEntireSeries
        ? null
        : seriesId !== "undefined" && seriesId !== undefined
          ? seriesId
          : null;

      let fk = leagueTeamFK;
      if (!isEditEntireSeries && leagueTeamFK.series) {
        fk = {
          id: leagueTeamFK.series,
          fk: leagueTeamFK.series.slice(-4),
          region: leagueTeamFK.region,
          type: leagueTeamFK.type,
        };
      }

      const val: any = await AV.Event.addResource(
        AVEntity.getFk(fk),
        eventResources,
        isSeries,
      );

      if (val) {
        setLeagueTeamFK(val);

        if (
          leagueTeamFK?.eventType === "Meeting" ||
          leagueTeamFK?.eventType === "Practice"
        ) {
          setresoursesList(mergeMeetingResources(val, isSeries));
        } else {
          setresoursesList(val?.resources);
        }

        entitydatalist[
          entitydatalist.indexOf(entitydatalist?.find((x) => x?.id === val?.id))
        ] = val;
        dispatch(setEntitydata(entitydatalist));
      }
    } else {
      // EDIT resource
      let Editvalue: any = deleteresourses;
      Editvalue.quantity = Number(quantity);
      Editvalue.notes = note;
      Editvalue.resource = description;

      if (checkvaluedata) {
        Editvalue.id = checkvaluedata?.id;
        Editvalue.pk = checkvaluedata?.pk;
        Editvalue.title = checkvaluedata?.title;
        Editvalue.region = checkvaluedata?.region;
        Editvalue.type = checkvaluedata?.type;
        Editvalue.thumb = checkvaluedata?.thumb;
        Editvalue.background = checkvaluedata?.background;
      }

      const selectedEvent = entitydatalist?.find(
        (x) => x.id === leagueTeamFK.id,
      );
      let isSeries = isEditEntireSeries
        ? null
        : seriesId && seriesId !== "undefined"
          ? seriesId
          : null;

      if (selectedEvent && leagueTeamFK?.eventType === "Meeting") {
        const isResourcePresent = selectedEvent.resources?.some(
          (resource) => resource.id === Editvalue.id,
        );
        if (isResourcePresent) {
          isSeries = null;
        }
      }

      let fk = {
        id: leagueTeamFK?.series ? leagueTeamFK.series : leagueTeamFK.id,
        pk: leagueTeamFK?.series
          ? leagueTeamFK.series.slice(-4)
          : leagueTeamFK.id.slice(-4),
        region: leagueTeamFK.region,
        type: leagueTeamFK.type,
      };
      fk = leagueTeamFK.series ? fk : leagueTeamFK;

      const Editval: any = await AV.Event.updateResource(
        fk,
        Editvalue,
        isSeries,
      );

      if (Editval?.id) {
        setLeagueTeamFK(Editval);

        if (
          leagueTeamFK?.eventType === "Meeting" ||
          leagueTeamFK?.eventType === "Practice"
        ) {
          setresoursesList(mergeMeetingResources(Editval, isSeries));
        } else {
          setresoursesList(Editval?.resources);
        }

        entitydatalist[
          entitydatalist.indexOf(
            entitydatalist?.find((x) => x?.id === Editval?.id),
          )
        ] = Editval;
        dispatch(setEntitydata(entitydatalist));
      }

      seteditresourses(false);
    }

    // Reset fields
    setError("");
    setLoader(false);
    setshowAddResourceModal(false);
    setdescription("");
    setnote("");
    setassienTeammember("");
    setquantity("");
    setcheckvalue(true);
    setcheckvaluedata("");
  };

  //Edit Profile Resource
  const handleEditProfileType = async (item) => {
    setshowResourceModal(false);
    setdeleteresourses(item);
    setshowAddResourceModal(true);
    seteditresourses(true);
    setIsPlayer(false);
    setShowAddProfileModal(false);
    setdescription(item?.resource);
    setquantity(item?.quantity);
    setnote(item?.notes);
    if (participantList?.filter((x) => x?.id === item?.id)?.length > 0) {
      setassienTeammember(
        participantList?.filter((x) => x?.id === item?.id)[0]?.title,
      );
    } else {
      setassienTeammember("");
    }
  };

  // View Profile Resource
  const handleShowResourcePopup = async (item) => {
    setshowResourceModal(true);
    setshowAddResourceModal(true);
    seteditresourses(false);
    setIsPlayer(false);
    setShowAddProfileModal(false);
    setdescription(item?.resource);
    setquantity(item?.quantity);
    setnote(item?.notes);
    if (participantList?.filter((x) => x?.id === item?.id)?.length > 0) {
      setassienTeammember(
        participantList?.filter((x) => x?.id === item?.id)[0]?.title,
      );
    } else {
      setassienTeammember("");
    }
  };

  const handleAddResourcePopup = async () => {
    setshowAddResourceModal(true);
    setshowResourceModal(false);
    setdescription("");
    setquantity(1);
    searchPlayerItems("");
    setnote("");
  };

  const handleCancelItem = async () => {
    setError("");
    setshowResourceModal(false);
    setshowAddResourceModal(false);
    seteditresourses(false);
  };

  //Update Staff
  const handleUpdateStaff = async (item) => {
    let item1 = leagueTeamFK?.roles?.filter((x) => x?.name === staffRole)[0];
    menu.role = item1;
    if (newname?.trim()?.length > 0) menu.name = newname;
    if (newmail?.trim()?.length > 0) menu.email = newmail;
    if (newPhone?.trim()?.length > 0) menu.phone = newPhone;
    if (newParentName?.trim()?.length > 0) menu.parentName = newParentName;
    if (newParentEmail?.trim()?.length > 0) menu.parentEmail = newParentEmail;
    if (newParentPhone?.trim()?.length > 0) menu.parentPhone = newParentPhone;
    setmenu(menu);
    contactList[contactList.indexOf(item)] = menu;
    setcontactList(contactList);
    setmenu("");
    setIsEditPlayerDetails(false);
    setnewname("");
    setnewmail("");
    setNewPhone("");
    setNewParentName("");
    setNewParentEmail("");
    setNewParentPhone("");
  };

  //Addcontactlist
  const handleAddContactList = async () => {
    setIsLoading(true);
    setIsEditPlayerDetails(false);
    if (isStaffPage) {
      for (var i = 0; i < contactList.length; i++) {
        if (!contactList[i]?.role) contactList[i].role = leagueTeamFK?.roles[0];
      }
      let val = await AV.OrgBase.addStaffs(
        AV.AVEntity.getFk(leagueTeamFK),
        contactList,
      );
      if (val) setStaffList(val?.staff);
    } else if (isMembersPage) {
      let member: any = await AV.AVEntity.addMembers(
        AV.AVEntity.getFk(leagueTeamFK),
        contactList,
      );
    } else if (isPlayer) {
      let players: any = await AV.Team.addPlayers(
        AV.AVEntity.getFk(leagueTeamFK),
        contactList,
      );
      if (players) {
        setPlayersList(players?.players);
      }
    } else if (isParticipant) {
      let seriesId: any =
        params?.seriesId !== "undefined" && params?.seriesId !== undefined
          ? params?.seriesId
          : null;
      seriesId =
        !isEditEntireSeries &&
        leagueTeamFK.series?.trim()?.length > 0 &&
        seriesId?.trim()?.length > 0 &&
        seriesId
          ? seriesId
          : null;
      let occurId = leagueTeamFK?.eventType === "Social" ? null : seriesId;

      for (let i = 0; i < contactList?.length; i++) {
        const contact = contactList[i];

        let players: any = await AV.Event.addParticipant(
          AV.AVEntity.getFk(leagueTeamFK),
          {
            title: contact.name,
            email: contact.email,
          },
          occurId,
        );

        if (players) {
          if (occurId !== null) {
            let seriesEvent = players?.seriesEvents.find(
              (x) => x.id == occurId,
            );
            let AllParticipant: any = [
              ...seriesEvent?.participants,
              ...players?.participants,
            ];
            AllParticipant = _.uniqBy(AllParticipant, "id");

            // To sort the array so that items with linkType === 'Owner' or linkType === 'Staff' come first
            AllParticipant = AllParticipant?.sort((a, b) => {
              const getRank = (type) => {
                if (type === "Owner") return 0;
                if (type === "Staff") return 1;
                return 2; // for Participant or any other
              };
              return getRank(a.linkType) - getRank(b.linkType);
            });

            //setPlayersList(AllParticipant);
            //let tempstaff : any = showTempList;
            //tempstaff.push(seriesEvent?.participants[seriesEvent?.participants?.length - 1]);
            //setshowTempList(tempstaff);
            setStatus("All");
            setIsParticipantList(AllParticipant);
            setFilteredParticipantList(AllParticipant);
            //setEntity(players);
            //entitydatalist[entitydatalist.indexOf(entitydatalist?.find(x => x?.id === addpartcipants?.id))] = addpartcipants;
            //dispatch(setEntitydata(entitydatalist));
          } else {
            setStatus("All");
            setIsParticipantList(players?.participants);
            setFilteredParticipantList(players?.participants);
          }
        }
      }
    }
    setIsLoading(false);
    setshowFileuploadModal(false);
    setShowAddProfileModal(false);
  };

  //Layout
  React.useLayoutEffect(() => {
    if (rightRef.current) {
      setFixedWidth(rightRef.current.offsetWidth - 2);
    }
  }, [[dimensions.width]]);

  //GetMedia
  const getMedia = async (file?: any) => {
    let iMedia = await Media.saveFiles(
      AV.Media.getFormData(file),
      leagueTeamFK?.region ? leagueTeamFK?.region : currentUser?.region,
    );

    if (!iMedia || iMedia.length === 0) return;

    // Get uploaded link
    const srclink = AV.Media.getURL(iMedia[0]);
    if (!srclink) return;

    // Set metadata before saving
    iMedia[0].parent = AV.AVBase.getFk(leagueTeamFK ?? currentUser);
    //iMedia[0].linkURL = srclink;

    // Save uploaded media
    await AV.Media.saveMedia(iMedia);

    setLoader(false);
    setIsPicLoader(false);
    setMascotLoader(false);

    return iMedia[0];
  };

  //Participant Filter
  const PariticipantFilter = ({ statusKey, Type, SetType, Name, length }) => {
    return (
      <Button
        borderRadius={"19px"}
        height={"36px"}
        paddingLeft={"24px"}
        paddingRight={"24px"}
        bgColor={Type === statusKey ? "#2FA3BE" : ""}
        onPress={() => {
          SetType(statusKey);
        }}
      >
        <HStack space={1}>
          <Text
            color={Type === statusKey ? "white" : "rgba(0,0,0,0.6)"}
            fontWeight={400}
            fontSize={"16px"}
          >
            {Name}
          </Text>
          <Text
            color={Type === statusKey ? "white" : "rgba(0,0,0,0.6)"}
            fontWeight={400}
            fontSize={"16px"}
          >
            ({length})
          </Text>
        </HStack>
      </Button>
    );
  };

  const HandleRemoveplayers = (item) => {
    setisConfirmDelete(true);
    setConfirmationtext(
      leagueTeamFK?.subType == "Class"
        ? "Are You Sure? You Want to Delete Your Students"
        : "Are You Sure? You Want to Delete Your Player",
    );
    setItemSelect(item);
    setselectType("DeletePlayer");
  };

  const handleRemoveplayers = async () => {
    setLoader(true);
    let LeagueTeam: any = await AV.Team.removePlayer(
      AVEntity.getFk(leagueTeamFK),
      { id: itemSelect.id, pk: itemSelect.pk, type: "Person" },
    );
    if (LeagueTeam !== null) {
      setPlayersList(LeagueTeam?.players);
      setLeagueTeamFK(LeagueTeam);
    }
    setLoader(false);
    setisConfirmDelete(false);
  };

  const HandleConfirmRemoveSchoolOrgs = (type, item) => {
    setItemSelect(item);
    setselectType(type);
    setisConfirmDelete(true);
    setConfirmationtext(Loc.currentLang.menu.deleteItemConfirmText);
  };

  const HandleRemoveSchoolOrgs = async () => {
    try {
      setLoader(true);

      if (selectType === "RemoveSchoolSeason") {
        const removeSeason: any = await AV.Team.removeSeason(
          AVEntity.getFk(leagueTeamFK),
          itemSelect,
        );

        if (removeSeason) {
          setLeagueTeamFK(removeSeason);

          if (isSchoolGradClassPage) {
            // Remove GradClass from SchoolYear
            const yearEntity =
              leagueTeamFK?.childOrgs?.filter((x) => x.type === "SchoolYear") ||
              [];

            if (yearEntity.length > 0) {
              await AV.Club.removeGradClassFromYear(
                AV.AVEntity.getFk(yearEntity[0]),
                AV.AVEntity.getFk(itemSelect),
              );
            }
          } else if (isOrganization) {
            setOrgList([]);
            setSchoolYearOrgList(
              removeSeason.childOrgs?.filter((x) => x.type !== "Collect"),
            );
          }
        }
      } else if (
        isSchoolYearGradClassPage &&
        selectType === "RemoveSchoolGradClass"
      ) {
        const org: any = await AV.Club.removeGradClassFromYear(
          AV.AVEntity.getFk(leagueTeamFK),
          itemSelect,
        );

        if (org) {
          setLeagueTeamFK(org);
        }
      }
    } catch (error) {
      console.error("Error removing school org:", error);
    } finally {
      setLoader(false);
      setIsOpen(false);
      setItemSelect("");
      setselectType("");
      setisConfirmDelete(false);
    }
  };

  const handleCreateEvent = (eventType) => {
    handleEventType(eventType);
    settypeevent(eventType);
    setlocationaddress([]);
    setIsActives(!isActives);
    setIsGame(eventType === "Game");
  };

  const handleCreateOrg = (type: string) => {
    setShowCreateNewPage(true);
    setCreateType(type);
    setPassEntity(leagueTeamFK);
    setIsOrganization(false);
    setIsActives(false);
  };

  const HandleCreateGroup = () => {
    setShowCreateNewPage(true);
    setCreateType("Group");
    setPassEntity(leagueTeamFK);
    setIsOrganization(false);
    setIsActives(!isActives);
  };

  const HandleTeamorg = () => {
    setShowCreateNewPage(true);
    setCreateType("Team");
    setPassEntity(leagueTeamFK);
    setIsOrganization(false);
    setIsActives(!isActives);
  };

  const HandleClubOrg = () => {
    setShowCreateNewPage(true);
    setCreateType("Club");
    setPassEntity(leagueTeamFK);
    setIsOrganization(false);
    setIsActives(!isActives);
  };

  const HandleClassOrg = () => {
    setShowCreateNewPage(true);
    setCreateType("Class");
    setPassEntity(leagueTeamFK);
    setIsOrganization(false);
    setIsActives(!isActives);
  };

  const HandleGradOrg = () => {
    setShowCreateNewPage(true);
    setCreateType("GradClass");
    setIsOrganization(false);
    setPassEntity(leagueTeamFK);
    setIsActives(!isActives);
  };

  const HandleOrg = () => {
    setShowCreateNewPage(true);
    setCreateType("Organization");
    setIsOrganization(false);
    setPassEntity(leagueTeamFK);
    setIsActives(!isActives);
  };

  const HandleCreateSchoolChilds = (type: string) => {
    setShowCreateNewPage(true);
    setCreateType(type);
    setPassEntity(leagueTeamFK);
    setIsSchoolTeamsPage(false);
    setIsActives(!isActives);
  };

  const dropdownComEventValues = [
    {
      id: 1,
      name: Loc.currentLang.menu.group,
      flag: allEventData,
      fn: HandleCreateGroup,
    },
    ...(leagueTeamFK?.subType == "GradClass" || leagueTeamFK?.subType == "Term"
      ? [
          {
            id: 1,
            name: Loc.currentLang.menu.team,
            flag: allEventData,
            fn: HandleTeamorg,
          },
        ]
      : []),
    ...(leagueTeamFK?.subType == "GradClass"
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.club,
            flag: allEventData,
            fn: HandleClubOrg,
          },
        ]
      : []),
  ];

  const dropdownComOrgValues = [
    ...(leagueTeamFK?.type == "Organization" ||
    leagueTeamFK?.type == "Neighborhood" ||
    leagueTeamFK?.type == "Community" ||
    leagueTeamFK?.type == "School" ||
    leagueTeamFK?.type == "Club"
      ? [
          {
            id: 1,
            name: Loc.currentLang.menu.team,
            flag: allEventData,
            fn: HandleTeamorg,
          },
        ]
      : []),
    ...(leagueTeamFK?.type == "Organization" ||
    leagueTeamFK?.type == "Neighborhood" ||
    leagueTeamFK?.type == "Community" ||
    leagueTeamFK?.type == "School" ||
    leagueTeamFK?.type == "Club"
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.club,
            flag: allEventData,
            fn: HandleClubOrg,
          },
        ]
      : []),
    ...(leagueTeamFK?.type !== "Organization" &&
    leagueTeamFK?.type !== "Neighborhood" &&
    leagueTeamFK?.type !== "Community" &&
    leagueTeamFK?.type == "School" &&
    leagueTeamFK?.type !== "Club"
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.classes,
            flag: allEventData,
            fn: HandleClassOrg,
          },
        ]
      : []),
    ...(leagueTeamFK?.type !== "Organization" &&
    leagueTeamFK?.type !== "Neighborhood" &&
    leagueTeamFK?.type !== "Community" &&
    leagueTeamFK?.type == "School" &&
    leagueTeamFK?.type !== "Club"
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.graduatingClass,
            flag: allEventData,
            fn: HandleGradOrg,
          },
        ]
      : []),
    ...(leagueTeamFK?.type == "Organization"
      ? [
          {
            id: 5,
            name: Loc.currentLang.menu.organization,
            flag: allEventData,
            fn: HandleOrg,
          },
        ]
      : []),
    ...(leagueTeamFK?.type == "Community" ||
    leagueTeamFK?.type == "Organization" ||
    leagueTeamFK?.type == "School" ||
    leagueTeamFK?.type == "Club" ||
    leagueTeamFK?.type == "Neighborhood"
      ? [
          {
            id: 5,
            name: Loc.currentLang.menu.group,
            flag: allEventData,
            fn: HandleCreateGroup,
          },
        ]
      : []),
  ];

  const dropdownSchlTeamsValues = [
    ...[
      {
        id: 1,
        name: Loc.currentLang.menu.team,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Team"),
      },
    ],
    ...[
      {
        id: 2,
        name: Loc.currentLang.menu.club,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Club"),
      },
    ],
    ...[
      {
        id: 3,
        name: Loc.currentLang.menu.group,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Group"),
      },
    ],
  ];

  const dropdownSchlYearsOrgValues = [
    ...[
      {
        id: 1,
        name: Loc.currentLang.menu.department ?? "Department",
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Department"),
      },
    ],
    ...[
      {
        id: 2,
        name: Loc.currentLang.menu.class,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Class"),
      },
    ],
    ...[
      {
        id: 3,
        name: Loc.currentLang.menu.group,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Group"),
      },
    ],
    ...[
      {
        id: 4,
        name: Loc.currentLang.menu.team,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Team"),
      },
    ],
  ];

  const dropdownSchlDeptValues = [
    ...[
      {
        id: 1,
        name: Loc.currentLang.menu.group,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Group"),
      },
    ],
    ...[
      {
        id: 2,
        name: Loc.currentLang.menu.class,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Class"),
      },
    ],
    ...[
      {
        id: 3,
        name: Loc.currentLang.menu.club,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Club"),
      },
    ],
  ];

  //HandleUpload
  const handleUpload = useCallback(async (e) => {
    e.id = e.series ? e.series : e.id;
    let Team = await AV.AVEntity.save(e);
    if (Team) {
      setLeagueTeamFK(Team);
      setalbumlist(Team?.albums);
      let oldvalueOrgs = currentUser.orgs.filter((a) => a.id == Team?.id);
      if (oldvalueOrgs?.length > 0) {
        currentUser.orgs[currentUser.orgs.indexOf(oldvalueOrgs[0])] = Team;
        dispatch(setUser(currentUser));
      }
      let oldvalueOwned = currentUser.ownedEvents.filter(
        (a) => a.id == Team?.id,
      );
      if (oldvalueOwned?.length > 0) {
        currentUser.ownedEvents[
          currentUser.ownedEvents.indexOf(oldvalueOwned[0])
        ] = Team;
        dispatch(setUser(currentUser));
      }
      let oldvalueEvent = currentUser.events.filter((a) => a.id == Team?.id);
      if (oldvalueEvent?.length > 0) {
        let status = oldvalueEvent[0]?.status
          ? oldvalueEvent[0]?.status
          : "RSVP";
        currentUser.events[currentUser.events.indexOf(oldvalueEvent[0])] = Team;
        let Index = currentUser.events.findIndex((a) => a.id == Team?.id);
        if (Index !== -1) {
          currentUser.events[Index].status = status;
        }
        dispatch(setUser(currentUser));
      }

      let Index = entitydatalist?.findIndex((x) => x?.id == Team?.id);
      if (Index !== -1) {
        entitydatalist[Index] = Team;
        dispatch(setEntitydata(entitydatalist));
      }
    }
  }, []);

  //Edit Profile
  const {
    getRootProps: getStaffProfilePicFile,
    getInputProps: getStaffProfileInputProps,
  } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles: any) => {
      if (
        acceptedFiles?.filter((x) => x?.type.startsWith("image")) &&
        acceptedFiles?.length > 0
      ) {
        setIsPicLoader(true);
        getMedia(acceptedFiles).then((res) => {
          Editstaffitem.linkPic = res;
          setstaffpic(AV.Media.getURL(res));
        });
      } else {
        let clientError = { message: "Invalid file type" };
        CustomToast({ clientError });
        return;
      }
    },
  });

  const handleStaffRole = (e) => {
    e.preventDefault();
    setStaffRole(e.target.value);
  };

  const HandleRemoveMembers = (item) => {
    setisConfirmDelete(true);
    setConfirmationtext(
      Loc.currentLang.confirmationText.areYouSureYouWanttoDeleteYourMember,
    );
    setItemSelect(item);
    setselectType("DeleteMember");
  };

  const handleDeleteMember = async () => {
    setLoader(true);
    let removeMember = await AV.OrgBase.removeMember(
      AVEntity.getFk(leagueTeamFK),
      {
        id: itemSelect.id,
        pk: itemSelect.pk,
        type: "Person",
      },
    );
    if (removeMember !== null) {
      setLeagueTeamFK(removeMember);
    }
    setLoader(false);
    setisConfirmDelete(false);
  };

  const handleRemoveGroup = (item) => {
    setisConfirmDelete(true);
    setConfirmationtext("Are You Sure? You Want to Delete Your group");
    setItemSelect(item);
    setselectType("DeleteGroup");
  };

  const handleDeleteGroup = async () => {
    setLoader(true);
    let removeSeason: any = await AV.Team.removeSeason(
      AVEntity.getFk(leagueTeamFK),
      itemSelect,
    );
    if (removeSeason !== null) {
      setLeagueTeamFK(removeSeason);
      if (isOrganization) {
        setOrgList(
          removeSeason?.childOrgs?.filter(
            (x: any) => x?.type !== "Channel" && x?.type !== "Collect",
          ),
        );
      } else {
        setGroupList(
          removeSeason?.childOrgs?.filter((x: any) => x?.type == "Group"),
        );
      }
    }

    setLoader(false);
    setisConfirmDelete(false);
  };

  const handleRemove = async (type, item: any) => {
    if (type === "Season") {
      setIsLoading(true);
      let removeSeason: any = await AV.Team.removeSeason(
        AVEntity.getFk(leagueTeamFK),
        item,
      );
      if (removeSeason !== null) {
        setLeagueTeamFK(removeSeason);
        if (isOrganization) {
          setOrgList(
            removeSeason?.childOrgs?.filter(
              (x: any) => x?.type !== "Channel" && x?.type !== "Collect",
            ),
          );
        } else {
          setGroupList(
            removeSeason?.childOrgs?.filter((x: any) => x?.type == "Group"),
          );
        }
      }
    } else if (type === "Member") {
      setIsLoading(true);
      let removeMember: any = await AV.OrgBase.removeMember(
        AVEntity.getFk(leagueTeamFK),
        {
          id: item.id,
          pk: item.pk,
          type: "Person",
        },
      );
      if (removeMember !== null) {
        setLeagueTeamFK(removeMember);
      }
      setIsLoading(false);
    } else {
      setIsLoading(true);
      let removeStaff = await AV.OrgBase.removeStaff(
        AVEntity.getFk(leagueTeamFK),
        {
          id: item.id,
          pk: item.pk,
          type: "Person",
          role: item.role,
        },
      );
      if (removeStaff) {
        setLeagueTeamFK(removeStaff);
        setStaffList(removeStaff?.staff);
      }
    }
    setIsLoading(false);
    setIsOpen(!isOpen);
  };

  const handleProfileType = async (type) => {
    if (type === "Player") {
      setIsPlayer(true);
      setIsStaff(false);
      setIsMember(false);
      setIsTeam(false);
      setIsParticipant(false);
    } else if (type == "Member") {
      setIsStaff(false);
      setIsPlayer(false);
      setIsMember(true);
      setIsTeam(false);
      setIsParticipant(false);
    } else if (type == "Participant") {
      setIsStaff(false);
      setIsPlayer(false);
      setIsMember(false);
      setIsTeam(false);
      setIsParticipant(true);
    } else if (type == "Group") {
      setIsStaff(false);
      setSearchTypes(
        leagueTeamFK?.type == "Group" && leagueTeamFK?.subType == undefined
          ? Loc.currentLang.menu.subGroup
          : Loc.currentLang.menu.group,
      );
      setIsPlayer(false);
      setIsMember(false);
      setIsParticipant(false);
      setIsTeam(true);
    } else if (type == "Organization" || type == "Teams" || type == "Years") {
      setIsStaff(false);
      setSearchTypes(Loc.currentLang.menu.organization);
      setIsPlayer(false);
      setIsMember(false);
      setIsParticipant(false);
      setIsTeam(true);
      setOrgOpen(false);
    } else {
      setIsPlayer(false);
      setIsMember(false);
      setIsStaff(true);
      setIsTeam(false);
      setIsParticipant(false);
    }
    setPlayerName("");
    setPlayerEmailAddress("");
    setPlayerPhone("");
    setStaffName("");
    setcheckvalue(true);
    setStaffEmailAddress("");
    setStaffPhone("");
    setfilteredResults([]);
    setActivityRole(null);
    setError(null);
    setStaffRole("");
    setshowTempList([]);
    setShowAddProfileModal(true);
  };

  const handleEditStaff = async (item) => {
    if (staffemail) {
      if (!emailRegex.test(staffemail)) {
        let clientError = { message: "Invalid Email" };
        CustomToast({ clientError });
        return;
      }
    }
    setIsLoading(true);
    setError("");
    let staff: AV.IStaff = item;
    let role: AV.IRole = staff?.role;
    staff.phone = staffphone;
    staff.email = staffemail;
    //staff.linkPic = staffpic;
    role.name = staffRole;
    let staffedit = await AV.OrgBase.updateStaff(
      AVEntity.getFk(leagueTeamFK),
      staff,
    );
    if (staffedit) {
      setStaffList(staffedit?.staff);
    }
    setIsStaffEdit(false);
    setIsLoading(false);
  };

  const handleupdatelocationfield = (e) => {
    setIsMapField(e.target.value.name);
    setIsFieldsName(e.target.value);
  };

  const searchOrgs = async (val: string) => {
    setIsDropList(true);
    setChildOrg(val);

    SetSelctChildOrg(
      user?.orgs?.filter(
        (x) =>
          x?.type !== "Channel" &&
          ((x?.target?.title &&
            x.target.title
              .toLocaleLowerCase()
              .includes(val.toLocaleLowerCase())) ||
            (x?.title &&
              x.title.toLocaleLowerCase().includes(val.toLocaleLowerCase())) ||
            (x?.data &&
              x.data.toLocaleLowerCase().includes(val.toLocaleLowerCase()))),
      ),
    );
  };

  const handlestaffandorgReq = async () => {
    setLoader(true);
    if (staffReq) {
      target.linkType = "StaffRequest";
      target.data = StaffDesc;
      let resp = await AV.Person.makeRequest(sourceFK, target);
    } else {
      let orgsourceFK: any = AV.AVEntity.getFk(chiledorgId);
      target.linkType = "OrgParent";
      target.data = justi;
      let resp1 = await AV.Person.makeRequest(orgsourceFK, target);
    }
    setLoader(false);
    setIsStaffDesc("");
    setIsStaffReq(false);
    setChildOrg("");
    setJusti("");
    setIsChildOrgReq(false);
  };

  //Menu Function
  const resetAllPages = () => {
    setIsTeamsPage(false);
    setIsSeasonPage(false);
    setIsEventPage(false);
    setIsStaffPage(false);
    setIsHuddlePage(false);
    setIsMembersPage(false);
    setIsPhotoPage(false);
    setIsDocumentPage(false);
    setIsPlayerPage(false);
    setIsGroup(false);
    setIsHomePage(false);
    setisResourses(false);
    setisparticipantspage(false);
    setIsDropDown(false);
    setIsFeedBackGroup(false);
    setIsOrganization(false);
    setIsSchoolTeamsPage(false);
    setIsSchoolYearsPage(false);
    setIsSchoolAlumniPage(false);
    setIsSchoolGradClassPage(false);
    setIsSchoolAlumniGradClassPage(false);
    setIsSchoolYearOrgPage(false);
    setIsSchoolYearGradClassPage(false);
    setIsOccurencePage(false);
    setIsFeeCollectionPage(false);
    setIsCollectAboutPage(false);
    setIsCollectMembersPage(false);
  };

  const handleHomeClick = async () => {
    resetAllPages();
    setIsTeamsPage(true);
    handleHelpText();
  };

  const handleSeasonClick = async () => {
    resetAllPages();
    setIsSeasonPage(true);
    //handleHelpText();
  };

  const handleEventsClick = async () => {
    resetAllPages();
    setIsEventPage(true);
    handleHelpText();
  };

  const handleStaffClick = async () => {
    resetAllPages();
    setIsStaffPage(true);
    handleHelpText();
  };

  const handleHuddlesClick = async () => {
    resetAllPages();
    setIsHuddlePage(true);
    //handleHelpText();
  };

  const handleMembersClick = async () => {
    resetAllPages();
    setIsMembersPage(true);
    handleHelpText();
  };

  const handleAblumClick = async () => {
    resetAllPages();
    setIsPhotoPage(true);
    handleHelpText();
  };

  const handleFileClick = async () => {
    resetAllPages();
    setIsDocumentPage(true);
    handleHelpText();
  };

  const handleOccurenceClick = async () => {
    resetAllPages();
    setIsOccurencePage(true);
    //setSeriesEventsList(leagueTeamFK?.seriesEvents);
    handleHelpText();
  };

  const handlePlayersClick = async () => {
    resetAllPages();
    setIsPlayerPage(true);
    handleHelpText();
  };

  const handleGroupClick = async () => {
    resetAllPages();
    setIsGroup(true);
    handleHelpText();
  };

  const handleOrganizationClick = async () => {
    resetAllPages();
    setIsOrganization(true);
    if (leagueTeamFK?.type === "SchoolYear") {
      setIsSchoolYearOrgPage(true);
    }
    handleHelpText();
  };

  const handleParicipantsClick = async () => {
    resetAllPages();
    setisparticipantspage(true);
    //setFilteredParticipantList(leagueTeamFK?.participants);
    handleHelpText();
    setAllStatus();
  };

  const handleResourcesClick = async () => {
    resetAllPages();
    setisResourses(true);
    //setresoursesList(leagueTeamFK?.resources);
    handleHelpText();
  };

  const handleSchoolTeamsClick = async () => {
    resetAllPages();
    setIsSchoolTeamsPage(true);
    handleHelpText();
  };

  const handleSchoolYearsClick = async () => {
    resetAllPages();
    setIsSchoolYearsPage(true);
    //handleHelpText();
  };

  const handleSchoolAlumniClick = async () => {
    resetAllPages();
    setIsSchoolAlumniPage(true);
    //handleHelpText();
  };

  const handleSchoolGradClassClick = async () => {
    resetAllPages();
    setIsSchoolGradClassPage(true);
    //handleHelpText();
  };

  const handleSchoolAlumniGradClassClick = async () => {
    resetAllPages();
    setIsSchoolAlumniGradClassPage(true);
    //handleHelpText();
  };

  const handleSchoolYearGradClassClick = async () => {
    resetAllPages();
    setIsSchoolYearGradClassPage(true);
    //handleHelpText();
  };

  const handleFeeCollectionClick = async () => {
    resetAllPages();
    setIsFeeCollectionPage(true);
    //handleHelpText();
  };

  const handleCollectAboutClick = async () => {
    resetAllPages();
    setIsCollectAboutPage(true);
    //handleHelpText();
  };

  const handleCollectMembersClick = async () => {
    resetAllPages();
    setIsCollectMembersPage(true);
    //handleHelpText();
  };

  //Tab Menu
  const showHuddlesMenu =
    isAdminView ||
    (currentUser?.orgs?.some(
      (org) =>
        org.type === "Channel" &&
        leagueTeamFK?.childOrgs?.some(
          (child) => child.type === "Channel" && child.id === org.id,
        ),
    ) ??
      false);

  const TeamsMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.ownedEvents?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.events,
            flag: isEventPage,
            fn: handleEventsClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) =>
        x?.type !== "Group" && x?.type !== "Channel" && x?.type !== "Collect",
    )?.length > 0
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.seasons,
            flag: isSeasonPage,
            fn: handleSeasonClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.childOrgs?.filter((x) => x?.type == "Group")?.length >
      0 || isAdminView
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.organization,
            flag: isGroup,
            fn: handleGroupClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 5,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 7,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.staff,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.members,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(showHuddlesMenu
      ? [
          {
            id: 10,
            name: Loc.currentLang.menu.huddless,
            flag: isHuddlePage,
            fn: handleHuddlesClick,
          },
        ]
      : []),
  ];

  const SeasonsMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.ownedEvents?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.events,
            flag: isEventPage,
            fn: handleEventsClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.players?.length > 0 || isAdminView
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.players,
            flag: isPlayerPage,
            fn: handlePlayersClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.childOrgs?.filter(
      (x) =>
        x?.type !== "Group" && x?.type !== "Channel" && x?.type !== "Collect",
    )?.length > 0 || isAdminView
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.organization,
            flag: isSeasonPage,
            fn: handleSeasonClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 5,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 7,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.parents,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.staff,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(showHuddlesMenu
      ? [
          {
            id: 10,
            name: Loc.currentLang.menu.huddless,
            flag: isHuddlePage,
            fn: handleHuddlesClick,
          },
        ]
      : []),
  ];

  const PerformanceGroupMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.ownedEvents?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.events,
            flag: isEventPage,
            fn: handleEventsClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.players?.length > 0 || isAdminView
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.players,
            flag: isPlayerPage,
            fn: handlePlayersClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.childOrgs?.filter((x) => x?.type == "Group")?.length >
      0 || isAdminView
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.organization,
            flag: isGroup,
            fn: handleGroupClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 5,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 7,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.members,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.staff,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(showHuddlesMenu
      ? [
          {
            id: 10,
            name: Loc.currentLang.menu.huddless,
            flag: isHuddlePage,
            fn: handleHuddlesClick,
          },
        ]
      : []),
  ];

  const TermsMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.ownedEvents?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.events,
            flag: isEventPage,
            fn: handleEventsClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.players?.length > 0 || isAdminView
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.members,
            flag: isPlayerPage,
            fn: handlePlayersClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.childOrgs?.filter((x) => x?.type == "Group")?.length >
      0 || isAdminView
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.organization,
            flag: isGroup,
            fn: handleGroupClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 5,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 7,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.directors,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.parents,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(showHuddlesMenu
      ? [
          {
            id: 10,
            name: Loc.currentLang.menu.huddless,
            flag: isHuddlePage,
            fn: handleHuddlesClick,
          },
        ]
      : []),
  ];

  const TeamClubMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.ownedEvents?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.events,
            flag: isEventPage,
            fn: handleEventsClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "PlayerOrg" && x?.subType === "Term",
    )?.length > 0 || isAdminView
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.terms,
            flag: isSeasonPage,
            fn: handleSeasonClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.childOrgs?.filter(
      (x) =>
        x?.type !== "PlayerOrg" &&
        x?.subType !== "Term" &&
        x?.type !== "Channel" &&
        x?.type !== "Collect",
    )?.length > 0 || isAdminView
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.organization,
            flag: isGroup,
            fn: handleGroupClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 5,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 7,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.staff,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.members,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(showHuddlesMenu
      ? [
          {
            id: 10,
            name: Loc.currentLang.menu.huddless,
            flag: isHuddlePage,
            fn: handleHuddlesClick,
          },
        ]
      : []),
  ];

  const EliteClubTab = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.ownedEvents?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.events,
            flag: isEventPage,
            fn: handleEventsClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type !== "Channel" && x?.type !== "Collect",
    )?.length > 0 || isAdminView
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.teams,
            flag: isOrganization,
            fn: handleOrganizationClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 4,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 5,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 7,
            name: Loc.currentLang.menu.staff,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.members,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(showHuddlesMenu
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.huddless,
            flag: isHuddlePage,
            fn: handleHuddlesClick,
          },
        ]
      : []),
  ];

  const SchoolMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.ownedEvents?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.events,
            flag: isEventPage,
            fn: handleEventsClick,
          },
        ]
      : []),
    {
      id: 3,
      name: Loc.currentLang.menu.teams,
      flag: isSchoolTeamsPage,
      fn: handleSchoolTeamsClick,
    },
    {
      id: 4,
      name: Loc.currentLang.menu.years,
      flag: isSchoolYearsPage,
      fn: handleSchoolYearsClick,
    },
    {
      id: 5,
      name: Loc.currentLang.menu.alumni,
      flag: isSchoolAlumniPage,
      fn: handleSchoolAlumniClick,
    },
    {
      id: 6,
      name: Loc.currentLang.menu.gradClass,
      flag: isSchoolGradClassPage,
      fn: handleSchoolGradClassClick,
    },
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 7,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 10,
            name: Loc.currentLang.menu.staff,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 11,
            name: Loc.currentLang.menu.administration,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(showHuddlesMenu
      ? [
          {
            id: 12,
            name: Loc.currentLang.menu.huddless,
            flag: isHuddlePage,
            fn: handleHuddlesClick,
          },
        ]
      : []),
  ];

  const SchoolAlumniMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.childOrgs?.filter((x) => x.type === "PlayerOrg")?.length >
      0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.gradClass,
            flag: isSchoolAlumniGradClassPage,
            fn: handleSchoolAlumniGradClassClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.staff,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 5,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
  ];

  const SchoolYearMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.ownedEvents?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.events,
            flag: isEventPage,
            fn: handleEventsClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type !== "Channel" && x?.type !== "Collect",
    )?.length > 0 || isAdminView
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.organization,
            flag: isOrganization,
            fn: handleOrganizationClick,
          },
        ]
      : []),
    {
      id: 4,
      name: Loc.currentLang.menu.gradClass,
      flag: isSchoolYearGradClassPage,
      fn: handleSchoolYearGradClassClick,
    },
    {
      id: 5,
      name: Loc.currentLang.menu.students,
      flag: isPlayerPage,
      fn: handlePlayersClick,
    },
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.parents,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 7,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
  ];

  const SchoolGradClassMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.players?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.students,
            flag: isPlayerPage,
            fn: handlePlayersClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.parents,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.staff,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 5,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 7,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
  ];

  const GradClassMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.ownedEvents?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.events,
            flag: isEventPage,
            fn: handleEventsClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.players?.length > 0 || isAdminView
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.students,
            flag: isPlayerPage,
            fn: handlePlayersClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.childOrgs?.filter((x) => x?.type == "Group")?.length >
      0 || isAdminView
      ? [
          {
            id: 4,
            name:
              leagueTeamFK?.subType == "GradClass"
                ? Loc.currentLang.menu.organizations
                : Loc.currentLang.menu.organization,
            flag: isGroup,
            fn: handleGroupClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 5,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 7,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.staff,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.parents,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(showHuddlesMenu
      ? [
          {
            id: 10,
            name: Loc.currentLang.menu.huddless,
            flag: isHuddlePage,
            fn: handleHuddlesClick,
          },
        ]
      : []),
  ];

  const ClassMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.ownedEvents?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.events,
            flag: isEventPage,
            fn: handleEventsClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.players?.length > 0 || isAdminView
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.students,
            flag: isPlayerPage,
            fn: handlePlayersClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.childOrgs?.filter((x) => x?.type == "Group")?.length >
      0 || isAdminView
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.organization,
            flag: isGroup,
            fn: handleGroupClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 5,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 7,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.staff,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.parents,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(showHuddlesMenu
      ? [
          {
            id: 10,
            name: Loc.currentLang.menu.huddless,
            flag: isHuddlePage,
            fn: handleHuddlesClick,
          },
        ]
      : []),
  ];

  const GroupMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.ownedEvents?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.events,
            flag: isEventPage,
            fn: handleEventsClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.members,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.childOrgs?.filter((x) => x?.type == "Group")?.length >
      0 || isAdminView
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.organization,
            flag: isGroup,
            fn: handleGroupClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 5,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 7,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.staff,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(showHuddlesMenu
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.huddless,
            flag: isHuddlePage,
            fn: handleHuddlesClick,
          },
        ]
      : []),
  ];

  const orgsMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.ownedEvents?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.events,
            flag: isEventPage,
            fn: handleEventsClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.employees,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type !== "Channel" && x?.type !== "Collect",
    )?.length > 0 || isAdminView
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.organization,
            flag: isOrganization,
            fn: handleOrganizationClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 5,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 7,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.staff,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(showHuddlesMenu
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.huddless,
            flag: isHuddlePage,
            fn: handleHuddlesClick,
          },
        ]
      : []),
  ];

  const neighborhoodMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.ownedEvents?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.events,
            flag: isEventPage,
            fn: handleEventsClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.neighbors,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type !== "Channel" && x?.type !== "Collect",
    )?.length > 0 || isAdminView
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.organization,
            flag: isOrganization,
            fn: handleOrganizationClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 5,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 7,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.staff,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(showHuddlesMenu
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.huddless,
            flag: isHuddlePage,
            fn: handleHuddlesClick,
          },
        ]
      : []),
  ];

  const communityMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(leagueTeamFK?.ownedEvents?.length > 0 || isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.events,
            flag: isEventPage,
            fn: handleEventsClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.members?.length > 0 || isAdminView
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.members,
            flag: isMembersPage,
            fn: handleMembersClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type !== "Channel" && x?.type !== "Collect",
    )?.length > 0 || isAdminView
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.organization,
            flag: isOrganization,
            fn: handleOrganizationClick,
          },
        ]
      : []),
    ...(isAdminView ||
    leagueTeamFK?.childOrgs?.filter(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    )?.length > 0
      ? [
          {
            id: 5,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.albums?.length > 0 || isAdminView
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(isFilesView || isAdminView
      ? [
          {
            id: 7,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
    ...(leagueTeamFK?.staff?.length > 0 || isAdminView
      ? [
          {
            id: 8,
            name: Loc.currentLang.menu.staff,
            flag: isStaffPage,
            fn: handleStaffClick,
          },
        ]
      : []),
    ...(showHuddlesMenu
      ? [
          {
            id: 9,
            name: Loc.currentLang.menu.huddless,
            flag: isHuddlePage,
            fn: handleHuddlesClick,
          },
        ]
      : []),
  ];

  const collectMenu = [
    ...(leagueTeamFK?.profile?.text
      ? [
          {
            id: 1,
            name: Loc.currentLang.feeCollect.about,
            flag: isCollectAboutPage,
            fn: handleCollectAboutClick,
          },
        ]
      : []),

    ...(isAdminView
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.members,
            flag: isCollectMembersPage,
            fn: handleCollectMembersClick,
          },
        ]
      : []),
  ];

  useEffect(() => {
    console.log("useEffect11");
    if (
      leagueTeamFK?.type === "Collect" &&
      !leagueTeamFK?.profile?.text &&
      isAdminView
    ) {
      handleCollectMembersClick();
    }
  }, [leagueTeamFK?.profile?.text, isAdminView]);

  const curSeriesEvent = leagueTeamFK?.seriesEvents?.find(
    (x) => x.id === params.seriesId,
  );
  const isSeriesActive = curSeriesEvent?.status !== "Canceled";
  const isTeamActive = curSeriesEvent?.status !== "Canceled";

  const showParticipants =
    leagueTeamFK?.participants?.length > 0 ||
    isAdminView ||
    participantList?.length > 0;
  const showFeeCollecion =
    (isAdminView && isTeamActive && isSeriesActive) ||
    leagueTeamFK?.childOrgs?.some(
      (x) => x?.type === "Collect" && x?.type !== "Channel",
    );

  const currentEvt =
    currentUser?.events?.find((x) => x?.id === leagueTeamFK?.id) ?? {};
  const eventsLength = currentEvt?.events?.length ?? 0;
  const seriesLength = leagueTeamFK?.seriesEvents?.length ?? 0;
  const showOccurence =
    (leagueTeamFK?.eventType === "Meeting" ||
      leagueTeamFK?.eventType === "Practice") &&
    (eventsLength > 1 || (eventsLength !== 0 && eventsLength === seriesLength));

  let showResources = false;
  let showAlbums = false;
  let showFiles = false;

  if (leagueTeamFK?.participants?.some((x) => x?.id === currentUser?.id)) {
    showResources =
      (leagueTeamFK?.resources?.length > 0 ||
        curSeriesEvent?.resources?.length > 0 ||
        isAdminView) &&
      isTeamActive &&
      isSeriesActive;

    showAlbums =
      (leagueTeamFK?.albums?.length > 0 || isAdminView) &&
      isTeamActive &&
      isSeriesActive;

    showFiles =
      (leagueTeamFK?.files?.length > 0 || isAdminView) &&
      isTeamActive &&
      isSeriesActive;
  }

  const eventsMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...(showParticipants
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.participants,
            flag: isparticipantspage,
            fn: handleParicipantsClick,
          },
        ]
      : []),
    ...(showResources
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.resources,
            flag: isResourses,
            fn: handleResourcesClick,
          },
        ]
      : []),
    ...(showOccurence
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.occurrence,
            flag: isOccurencePage,
            fn: handleOccurenceClick,
          },
        ]
      : []),
    ...(showFeeCollecion
      ? [
          {
            id: 5,
            name: Loc.currentLang.feeCollect.feeCollection,
            flag: isFeeCollectionPage,
            fn: handleFeeCollectionClick,
          },
        ]
      : []),
    ...(showAlbums
      ? [
          {
            id: 6,
            name: Loc.currentLang.menu.albums,
            flag: isPhotoPage,
            fn: handleAblumClick,
          },
        ]
      : []),
    ...(showFiles
      ? [
          {
            id: 7,
            name: Loc.currentLang.menu.files,
            flag: isDocumentPage,
            fn: handleFileClick,
          },
        ]
      : []),
  ];

  const GroupListItem = ({
    item,
    isAdminView,
    handleRemoveGroup,
    navigate,
  }) => {
    let cacheItem = entitydatalist?.find((x: any) => x?.id == item?.id);
    if (cacheItem || currentUser?.id == item?.id)
      item =
        currentUser?.id == item?.id
          ? AV.AVEntity.getLink(currentUser)
          : AV.AVEntity.getLink(cacheItem);
    return (
      <Box
        key={item.id}
        bgColor={"#fff"}
        borderWidth={"1px"}
        borderColor={"AVColor.hovercolor2"}
        minWidth={130}
        minHeight={175}
        borderRadius={5}
        m={2}
        shadow={1}
      >
        {isAdminView && (
          <Pressable
            key={item.id}
            padding={1.5}
            rounded={"full"}
            position={"absolute"}
            right={-10}
            top={-10}
            zIndex={999}
            _hover={{ backgroundColor: "AVColor.hovercolor2" }}
            backgroundColor={"AVColor.buttonBg"}
            onPress={() => handleRemoveGroup(item)}
          >
            <CloseIcon size={"12px"} color={"AVColor.secondaryText"} />
          </Pressable>
        )}

        <VStack alignItems={"center"} height={"100%"} width={"100%"}>
          <Pressable
            key={item.id}
            height={"100%"}
            justifyContent={"center"}
            width={"100%"}
            _hover={{ bgColor: "#EEEEEE" }}
            onPress={() => {
              item?.type == "Person" || item?.type == "Pet"
                ? navigate(`/profile/${item?.id}/${item?.region}`, {
                    state: {
                      user: {
                        id: item?.id,
                        pk: item?.pk,
                        region: item?.region,
                        type: item?.type,
                        name: item?.title,
                      },
                    },
                  })
                : item?.type == "PlayerOrg"
                  ? navigate(`/season/${item?.id}/${item?.region}`, {
                      state: { isCreate: false, team: item },
                    })
                  : item?.type == "Group"
                    ? navigate(`/teams/${item?.id}/${item?.region}`, {
                        state: { isCreate: false, team: item },
                      })
                    : navigate(
                        `/organizations/${item?.id}/${item?.region}/${item?.type}`,
                        {
                          state: {
                            isCreate: false,
                            orgType: item?.type,
                            org: item,
                          },
                        },
                      );
            }}
          >
            {item?.thumb && (
              <Box
                bgColor={"#FF6600"}
                borderRadius={["full"]}
                width={"70px"}
                height={"70px"}
                alignSelf={"center"}
                p={0}
              >
                <Image
                  source={{
                    uri: AV.Media.getThumb(item),
                  }}
                  borderRadius={["full"]}
                  //top={ "2" }
                  width={"100%"}
                  height={["100%"]}
                />
              </Box>
            )}

            {!item?.thumb && (
              <Box alignItems={"center"}>
                {/*<Profile height={ '70' } width={ '70' } color={ "#32AE78" } />*/}
                <EntityProfilePic height={"70"} width={"70"} link={item} />
              </Box>
            )}

            <Tooltip label={item.title} openDelay={500}>
              <Pressable
                onPress={() => {
                  item?.type == "Person" || item?.type == "Pet"
                    ? navigate(`/profile/${item?.id}/${item?.region}`, {
                        state: {
                          user: {
                            id: item?.id,
                            pk: item?.pk,
                            region: item?.region,
                            type: item?.type,
                            name: item?.title,
                          },
                        },
                      })
                    : item?.type == "PlayerOrg"
                      ? navigate(`/season/${item?.id}/${item?.region}`, {
                          state: { isCreate: false, team: item },
                        })
                      : item?.type == "Group"
                        ? navigate(`/teams/${item?.id}/${item?.region}`, {
                            state: { isCreate: false, team: item },
                          })
                        : navigate(
                            `/organizations/${item?.id}/${item?.region}/${item?.type}`,
                            {
                              state: {
                                isCreate: false,
                                orgType: item?.type,
                                org: item,
                              },
                            },
                          );
                }}
              >
                <Text
                  marginTop={2}
                  left={"2px"}
                  alignItems="center"
                  width="120px"
                  numberOfLines={2}
                  textAlign="center"
                >
                  {item.title}
                </Text>
              </Pressable>
            </Tooltip>
          </Pressable>
        </VStack>
      </Box>
    );
  };

  const handledocument = async (item) => {
    let val = await AV.Media.getFile(item?.mListId, item.id, item?.storeId);
    if (val) {
      var blobUrl = val;
      var fileName = item?.orgFile;
      var a = document.createElement("a");
      a.href = blobUrl.toString();
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      // window.open(val);
    }
  };

  const filterParticipants = (status) => {
    if (status === "ALL") {
      return participantList;
    }
    if (status === "ALL" || status === "RSVP") {
      return participantList.filter((item) => item.status == undefined);
    } else if (status === "Yes") {
      return participantList.filter((item) => item.status === "Yes");
    } else if (status === "No") {
      return participantList.filter((item) => item.status === "No");
    } else if (status === "Maybe") {
      return participantList.filter((item) => item.status === "Maybe");
    }
    return participantList;
  };

  const setAllStatus = () => {
    setStatus("All");
    const filteredParticipantsALL = filterParticipants("All");
    setFilteredParticipantList(filteredParticipantsALL);
  };

  const setRsvpStatus = () => {
    setStatus("RSVP");
    const filteredParticipantRSVP = filterParticipants("RSVP");
    setFilteredParticipantList(filteredParticipantRSVP);
  };

  const setYesStatus = () => {
    setStatus("Yes");
    const filteredParticipantYes = filterParticipants("Yes");
    setFilteredParticipantList(filteredParticipantYes);
  };

  const setNoStatus = () => {
    setStatus("No");
    const filteredParticipantNo = filterParticipants("No");
    setFilteredParticipantList(filteredParticipantNo);
  };

  const setMaybeStatus = () => {
    setStatus("Maybe");
    const filteredParticipantMayBe = filterParticipants("Maybe");
    setFilteredParticipantList(filteredParticipantMayBe);
  };

  const HandleRemoveStaffs = (item) => {
    setisConfirmDelete(true);
    setConfirmationtext(
      leagueTeamFK?.type == "School"
        ? "Are You Sure? You Want to Delete Your Adminstration"
        : "Are You Sure? You Want to Delete Your Staff",
    );
    setItemSelect(item);
    setselectType("DeleteStaff");
  };

  const RemoveSeason = async () => {
    setLoader(true);
    let removeSeason: any = await AV.Team.removeSeason(
      AVEntity.getFk(leagueTeamFK),
      {
        id: itemSelect.id,
        pk: itemSelect.pk,
        type: "Person",
        /*role: item.role,*/
      },
    );
    if (removeSeason !== null) {
      setLeagueTeamFK(removeSeason);
    }
    setLoader(false);
    setisConfirmDelete(false);
  };

  const RemoveStaffs = async () => {
    setLoader(true);
    let LeagueTeam = await AV.OrgBase.removeStaff(
      AVEntity.getFk(leagueTeamFK),
      {
        id: itemSelect.id,
        pk: itemSelect.pk,
        type: "Person",
        role: itemSelect.role,
      },
    );
    if (LeagueTeam) {
      setLeagueTeamFK(LeagueTeam);
      setStaffList(LeagueTeam?.staff);
    }
    setLoader(false);
    setisConfirmDelete(false);
  };

  //GroupChat
  const HandleGroupChat = async (type: string) => {
    setIsLoad(true);

    if (type !== "A") {
      const isStaff = leagueTeamFK?.staff?.some(
        (x) => x.id === currentUser?.id,
      );
      const isPlayer = leagueTeamFK?.players?.some(
        (x) => x.id === currentUser?.id,
      );
      const isMember = leagueTeamFK?.members?.some(
        (x) => x.id === currentUser?.id,
      );

      const isParticipant = leagueTeamFK?.participants?.some(
        (x) => x.id === currentUser?.id,
      );

      if (!isStaff && !isPlayer && !isMember && !isParticipant) {
        setIsLoad(false);
        let clientError = {
          message: Loc.currentLang.menu.notAuthorizedGroupChat,
        };
        CustomToast({ clientError });
        return;
      }

      switch (true) {
        case isMembersPage:
          if (isStaff) type = "W";
          //else if (isMember && (leagueTeamFK as AV.IOrgBase)) type = "M";
          else if (isMember && (leagueTeamFK as AV.IPlayerOrg)) type = "M";
          else if (isMember && !(leagueTeamFK as AV.IPlayerOrg)) type = "M";
          else if (isPlayer && (leagueTeamFK as AV.IPlayerOrg)) type = "Y";
          break;

        case isPlayerPage:
          if (isStaff) type = "X";
          else if (isMember && (leagueTeamFK as AV.IPlayerOrg)) type = "Y";
          else if (isPlayer && (leagueTeamFK as AV.IPlayerOrg)) type = "P";
          break;

        case isStaffPage:
          if (isStaff) type = "S";
          else if (isMember && (leagueTeamFK as AV.IPlayerOrg)) type = "W";
          else if (isMember && !(leagueTeamFK as AV.IPlayerOrg)) type = "W";
          else if (isPlayer && (leagueTeamFK as AV.IPlayerOrg)) type = "X";
          break;

        case isparticipantspage:
          if (isParticipant && (leagueTeamFK as AV.IEvent)) type = "N";
          break;

        default:
          break;
      }
    }

    const key = convoKeyMap[type];
    const validation = checkConvoExitorNot(type);

    // If convo already exists
    if (validation?.trim()?.length > 0) {
      const person = await AV.Person.getSelf(true);
      const huddleData = person?.orgs?.find((x) => x?.id === validation);

      navigate(`/huddles/${huddleData?.id ?? 1}`, {
        state: { HuddleData: huddleData },
      });

      setIsLoad(false);
      return;
    }

    // If convo doesn't exist, create
    if (!validation) {
      const response: any = await AV.AVEntity.CreateGroupConvo(target, type);
      console.log("Response", response);
      let Index = entitydatalist?.findIndex((x) => x?.id == response?.id);
      if (Index !== -1) {
        entitydatalist[Index] = response;
        setLeagueTeamFK(response);
      }
      dispatch(setEntitydata(entitydatalist));

      const convoId = key ? response?.[key] : "";
      setIsConvoData(convoId);

      const person = await AV.Person.getSelf(true);
      dispatch(setUser(person));

      setTimeout(() => {
        const huddleData: any = person?.orgs?.find((x) => x?.id === convoId);

        navigate(`/huddles/${huddleData?.id ?? 1}`, {
          state: { HuddleData: huddleData },
        });

        setIshuddleData(huddleData);
      }, 1000);
    }

    setIsLoad(false);
  };

  const EntityDataFinding = async (e: any) => {
    if (e) {
      setisStaffentity(e?.staff?.some((x: any) => x?.id === currentUser?.id));
      setisMemberEntity(
        e?.members?.some((x: any) => x?.id === currentUser?.id),
      );
      setisPlayerEntity(
        e?.players?.some((x: any) => x?.id === currentUser?.id),
      );

      setProfile(e?.profile);
      setIsDeleted(e?.status === "Deleted" ? false : true);
      setIsSuspended(e?.status === "Suspended" ? false : true);

      if (currentUser?.favs?.filter((x) => x?.id === e?.id)[0])
        setMyFavourite(true);

      const isAdmin = e?.staff?.some((x) => x?.id === currentUser?.id);
      let isAdminOrStaff =
        e?.status == "Canceled"
          ? false
          : e?.participants?.some(
              (x) =>
                x?.id === user?.id &&
                (x?.linkType === "Owner" || x?.linkType === "Staff"),
            );

      if (e.type !== "Collect") {
        setIsAdminView(isAdmin ? isAdmin : isAdminOrStaff);
        //setIsFutureEvent(isAdmin ? isAdmin : isAdminOrStaff);
      } else if (e?.type === "Collect") {
        const collectParent = entitydatalist?.find(
          (item) => item?.id === e?.parent?.id,
        );

        if (collectParent) {
          if (
            e?.parent?.type === "Event" &&
            collectParent?.parent?.type === "Person"
          ) {
            setIsAdminView(Boolean(e?.creator?.id === currentUser?.id));
          } else if (
            e?.parent?.type === "Event" &&
            collectParent?.parent?.type !== "Person"
          ) {
            const collectEventParent = entitydatalist?.find(
              (item) => item?.id === collectParent?.parent?.id,
            );

            if (collectEventParent) {
              let isAdminOrStaff = collectEventParent?.staff?.some(
                (x) => x?.id === currentUser?.id,
              );
              setIsAdminView(Boolean(isAdminOrStaff));
            }
          } else {
            const isAdmin = collectParent?.staff?.some(
              (member) => member?.id === currentUser?.id,
            );
            setIsAdminView(Boolean(isAdmin));
          }
        }
      }

      // For Event
      if (e.series) {
        let seriesParentEvent;
        var fk = {
          id: e.series,
          fk: e.series.slice(-4),
          type: e.type,
          region: e.region,
        };

        if (entitydatalist?.filter((x) => x?.id === viewTeam?.id)?.length > 0) {
          seriesParentEvent = entitydatalist?.filter(
            (x) => x?.id === viewTeam?.id,
          )[0];
        } else {
          seriesParentEvent = await AV.AVEntity.get(fk);
        }

        isAdminOrStaff =
          seriesParentEvent?.status == "Canceled"
            ? false
            : seriesParentEvent?.participants?.some(
                (x) =>
                  x?.id === user?.id &&
                  (x?.linkType === "Owner" || x?.linkType === "Staff"),
              );

        const currentEvent = Array.isArray(e?.seriesEvents)
          ? e.seriesEvents.filter((x) => x.id === seriesId)
          : [];

        const isEventCanceled = e?.status === "Canceled";

        //if (!isEventCanceled) {
        const currentEventObj = currentEvent.length > 0 ? currentEvent[0] : e;
        const isCurrentCanceled = currentEventObj?.status === "Canceled";

        const now = new Date();
        const isPast = new Date(currentEventObj?.end) < now;
        const isFuture = new Date(currentEventObj?.start) > now;
        const isOngoing =
          new Date(currentEventObj?.start) <= now &&
          now <= new Date(currentEventObj?.end);

        //if (!isCurrentCanceled) {
        setIsOngoingOrFuture(isFuture || isOngoing);
        setIsAdminView(isAdminOrStaff);
        console.log(
          `Event detected -> isFuture: ${isFuture}, isOngoing: ${isOngoing}, result: ${isFuture || isOngoing}`,
        );
        //} else {
        //  setIsAdminView(false);
        //  setIsOngoingOrFuture(false);
        //  console.log(
        //    "Event detected but canceled - isOngoingOrFuture: fasle",
        //  );
        //}

        // Any future occurrence event exists
        const hasFutureSeriesEvent = e?.seriesEvents.some(
          (evt) => evt.id !== currentEventObj?.id && new Date(evt.start) > now,
        );
        setIsEntireSeriesAvailable(hasFutureSeriesEvent);
        console.log("isEntireSeriesAvailable:", hasFutureSeriesEvent);
        //} else {
        //  setIsAdminView(false);
        //  setIsOngoingOrFuture(false);
        //  setIsEntireSeriesAvailable(false);
        //  console.log("Event detected but canceled - isOngoingOrFuture: fasle");
        //}
      }

      if (e?.url) {
        setLinks(e?.url);
      }
      if (e?.albums) {
        setalbumlist(e?.albums);
      }
      if (e?.files) {
        setfilesList(e?.files);
      }
      if (e?.activity) {
        setActivity(e?.activity);
      }
      if (e?.location?.siteMap) {
        setSiteMap(Media.getURL(e?.location?.siteMap));
      }

      if (e?.childOrgs) {
        if (e.type === "SchoolYear") {
          setOrgList([]);
          setSchoolYearOrgList(
            e?.childOrgs?.filter(
              (x: any) => x?.type !== "Channel" && x?.type !== "Collect",
            ),
          );
        } else if (e.type !== "SchoolYear" /* && e.subType !== "Department"*/) {
          setOrgList(
            e?.childOrgs?.filter(
              (x: any) => x?.type !== "Channel" && x?.type !== "Collect",
            ),
          );
        }

        if (e.subType === "Department") {
          setGroupList(
            e?.childOrgs?.filter(
              (x: any) => x?.type !== "Channel" && x?.type !== "Collect",
            ),
          );
        } else {
          setGroupList(e?.childOrgs?.filter((x: any) => x?.type == "Group"));
        }
      }

      if (e?.parent?.type === "Person" && currentUser?.id == e?.parent?.id) {
        setOwner(currentUser);
      } else if (
        ["Team", "PlayerOrg", "Club", "School"].includes(e?.parent?.type) &&
        currentUser?.orgs?.some((x) => x?.id == e?.parent?.id)
      ) {
        setOwner(currentUser?.orgs?.find((x) => x?.id == e?.parent?.id));
      } else {
        if (e?.parent) {
          if (
            entitydatalist?.filter((x) => x?.id === e?.parent?.id)?.length > 0
          ) {
            let parentEntity = entitydatalist?.filter(
              (x) => x?.id === e?.parent?.id,
            );
            setOwner(parentEntity[0]);
          } else {
            let eventowner: any = await AV.AVEntity.get(
              AV.AVEntity.getFk(e?.parent),
            );
            setOwner(eventowner);
          }
        }
      }

      const memberCheck =
        e?.members?.some((x: any) => x?.id === currentUser?.id) ?? false;

      const guardianCheck =
        e?.guardians?.some((x: any) => x?.id === currentUser?.id) ?? false;

      setisFilesView(memberCheck || guardianCheck || isAdmin);

      if (e?.players) {
        setPlayersList(e?.players);
      }

      if (e?.resources || seriesId?.trim()?.length > 0) {
        setresoursesList(e?.resources);
        let resources;
        if (seriesId?.trim()?.length > 0) {
          let AllResource = e?.seriesEvents?.filter((x) => x?.id === seriesId);
          if (AllResource?.length > 0) {
            AllResource = [...e?.resources, ...AllResource[0]?.resources];
            //AllResource = _.uniqBy( AllResource, 'id' );
            resources = AllResource;
          } else {
            resources = e?.resources;
          }
        } else {
          resources = e?.resources;
        }
        setresoursesList(resources);
      }

      if (e.type !== "Collect" && (e?.participants || e?.type === "Event")) {
        setIsParticipantList(e?.participants);
        let participants;

        if (seriesId?.trim()?.length > 0) {
          if (e?.seriesEvents?.length > 0) {
            const entireParticipants = e?.participants || [];
            const occParticipants =
              e?.seriesEvents?.find((x) => x?.id === seriesId)?.participants ||
              [];
            const occParticipantIds = occParticipants
              .map((p) => p?.id)
              .filter(Boolean);

            // Combine occParticipants and unique participants from entireParticipants
            const uniqueEntireParticipants = entireParticipants.filter(
              (p) => !occParticipantIds.includes(p?.id),
            );

            // Final participant list: occParticipants first, then unique ones from entire
            const finalParticipants = [
              ...occParticipants,
              ...uniqueEntireParticipants,
            ];

            // Set the cleaned participant list
            participants = finalParticipants;

            //// Find common IDs
            //const sameIds = entireParticipants
            //  .map((p) => p?.id)
            //  .filter((id) => id && occParticipants.some((op) => op?.id === id));

            // if (sameIds.length > 0) {
            //  // Get same participants from both arrays
            //  const sameFromEntire = entireParticipants.filter((p) =>
            //    sameIds.includes(p.id)
            //  );
            //  const sameFromOcc = occParticipants.filter((p) => sameIds.includes(p.id));

            //  // Combine and dedupe by id, keeping latest statusDate
            //  const sameParticipantsCombined = [...sameFromEntire, ...sameFromOcc];

            //  // Sort first by statusDate DESC (latest first), then uniqBy id
            //  const sameParticipants = _.uniqBy(
            //    sameParticipantsCombined.sort(
            //      (a, b) =>
            //        new Date(b.statusDate).getTime() - new Date(a.statusDate).getTime()
            //    ),
            //    "id"
            //  );

            //  // Diff participants (only from entireParticipants not present in occParticipants)
            //  const diffParticipants = entireParticipants.filter(
            //    (p) => p?.id && !occParticipantIds.includes(p.id)
            //  );

            //  // Final participants list
            //  participants = [...sameParticipants, ...diffParticipants];
            //} else {
            //     participants = [...entireParticipants, ...occParticipants];
            //}
          } else {
            participants = e?.participants || [];
          }
        } else {
          participants = e?.participants;
        }

        // To sort the array so that items with linkType === 'Owner' or linkType === 'Staff' come first
        participants = participants?.sort((a, b) => {
          const getRank = (type) => {
            if (type === "Owner") return 0;
            if (type === "Staff") return 1;
            return 2; // for Participant or any other
          };
          return getRank(a.linkType) - getRank(b.linkType);
        });

        setFilteredParticipantList(participants);
        setIsParticipantList(participants);
      }

      if (e?.members) {
        setmemberList(e?.members);
      }
      if (e?.staff) {
        setStaffList(e?.staff);
      }

      setisshowteamsList(e?.childOrgs);

      const visifiles = e?.members?.filter((x) => x.id === currentUser?.id);
      setVisible(visifiles?.length > 0 ? true : false);

      const viewadmin: any = e?.id === currentUser?.id;
      setdatas(viewadmin?.length > 0 ? true : false);

      const loc: any = await AV.Media.getMap(e?.location);
      if (loc) {
        setgooglemap(loc);
      }

      if (
        e?.eventType === "Social" ||
        e?.eventType === "Game" ||
        ((e?.eventType === "Meeting" || e?.eventType === "Practice") &&
          e?.seriesEvents?.length === 0)
      ) {
        const now = new Date();
        const isPast = new Date(e?.end) < now;
        const isFuture = new Date(e?.start) > now;
        const isOngoing = new Date(e?.start) <= now && now <= new Date(e?.end);
        setIsOngoingOrFuture(isFuture || isOngoing);
        console.log(
          `Event detected -> isFuture: ${isFuture}, isOngoing: ${isOngoing}, result: ${isFuture || isOngoing}`,
        );
      }

      /* ---------------- TOUR GUIDE FLOW DETECTION ---------------- */
      for (const flow of flows) {
        const key = flowKeyMap[flow];
        const shouldShow = localStorage.getItem(key) === "true";

        if (!shouldShow) continue;

        switch (flow) {
          /* ---------- TEAM ---------- */
          case "teamMember":
            if (e?.type === "Team") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "teamSeasonPlayer":
            if (
              e?.type === "PlayerOrg" &&
              e?.parent?.type === "Team" &&
              e?.subType === undefined
            ) {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "clubMember":
            if (e?.type === "Team" && e?.subType == "Club") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "clubTermMember":
            if (e?.type === "PlayerOrg" && e?.parent?.type === "Team") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "eliteClubMember":
            if (e?.type === "Club") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "schoolStaff":
            if (e?.type === "School") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "schoolYearStudent":
            if (e?.type === "SchoolYear") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "groupMember":
            if (e?.type === "Group" && e?.subType === undefined) {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            } else if (e?.type === "Group" && e?.subType === "Department") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "classStudent":
            if (e?.subType === "Class") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "gradClassStudent":
            if (e?.subType === "GradClass") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "organizationEmployee":
            if (e?.type === "Organization") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "neighborhoodNeighbors":
            if (e?.type === "Neighborhood") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "communityMember":
            if (e?.type === "Community") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "performancePlayer":
            if (e?.type === "PlayerOrg" && e?.subType === "MusicGroup") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;
        }
      }

      //let pastMeeting = false;
      //if (
      //  e.eventType === "Social" ||
      //  ((e.eventType === "Meeting" || e?.eventType === "Practice") &&
      //    e.seriesEvents?.length > 0)
      //) {
      //  pastMeeting = e.seriesEvents?.some((x) => new Date(x.end) < new Date());
      //}
      //setPastMeeting(pastMeeting);

      //if (e?.type !== "Event") {
      //  setIsFutureEvent(true);
      //  console.log("Event not detected - isOngoingOrFuture: true");
      //}
    }
  };

  const handleSwitchTab = async (e) => {
    const CurrentParentTab1: any = null;
    if (leagueTeamFK?.type === "Collect") {
      handleCollectAboutClick();
      return;
    } else {
      handleHomeClick();
    }
    //return;
    //}
    switch (CurrentParentTab1?.tab) {
      case "HomePage":
        await handleHomeClick();
        break;
      case "EventPage":
        await handleEventsClick();
        break;
      case "SeasonPage":
        await handleSeasonClick();
        break;
      case "MemberPage":
        await handleMembersClick();
        break;
      case "AlbumPage":
        await handleAblumClick();
        break;
      case "FilePage":
        await handleFileClick();
        break;
      case "OccurancePage":
        await handleOccurenceClick();
        break;
      case "PlayerPage":
        await handlePlayersClick();
        break;
      case "GroupPage":
        await handleGroupClick();
        break;
      case "OrganizationPage":
        await handleOrganizationClick();
        break;
      case "ParticipantPage":
        await handleParicipantsClick();
        break;
      case "ResourcePage":
        await handleResourcesClick();
        break;
      case "CollectPage":
        await handleCollectAboutClick();
        break;
      default:
        await handleHomeClick();
        break;
    }
  };

  useEffect(() => {
    console.log("useEffect3");
    setEventsList(leagueTeamFK?.ownedEvents);
  }, [isEventPage]);

  const HandeFeedBackNavigate = (item) => {
    setIsFeedBackGroup(false);
    navigate(`/teams/${item?.id}/${item?.region}`, {
      state: { isCreate: false, team: item, type: "Feedback" },
    });
  };

  const handleEventType = (type) => {
    setActivityType(type);
    if (type == "Practice" || type == "Meeting") {
      setIsPractice(true);
      setRepeatWeek(true);
      setShowAddEventsModal(!showAddEventsModal);
      setIsActives(!isActives);
    } else if (type == "Social") {
      setIsGame(false);
      setIsPractice(false);
      setShowAddEventsModal(!showAddEventsModal);
      setRepeatWeek(false);
    } else {
      setRepeatWeek(false);
      setShowAddEventsModal(!showAddEventsModal);
      setIsActives(!isActives);
    }
  };

  /*HandleHelptext*/
  const handlePersonTapHelpText = async () => {
    if (isEventPage) {
      sethelptext(Loc.currentLang.helpText.person.eventTab);
      sethelptype(Loc.currentLang.menu.event);
    } else if (isMembersPage) {
      sethelptext(Loc.currentLang.helpText.person.friendTab);
      sethelptype(Loc.currentLang.menu.friends);
    } else if (isSeasonPage) {
      sethelptext(Loc.currentLang.helpText.person.organizationTab);
      sethelptype(Loc.currentLang.menu.organizations);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.person.photoTab);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.person.documentTab);
      sethelptype(Loc.currentLang.menu.files);
    }
  };

  const handleTeamTapHelpText = async () => {
    if (isSeasonPage) {
      sethelptext(Loc.currentLang.helpText.team.seasonTab);
      sethelptype(Loc.currentLang.menu.season);
    } else if (isStaffPage) {
      sethelptext(Loc.currentLang.helpText.team.staffTab);
      sethelptype(Loc.currentLang.menu.staff);
    } else if (isEventPage) {
      sethelptext(Loc.currentLang.helpText.team.eventTab);
      sethelptype(Loc.currentLang.menu.event);
    } else if (isGroup) {
      sethelptext(Loc.currentLang.helpText.team.groupTab);
      sethelptype(Loc.currentLang.menu.Group);
    } else if (isMembersPage) {
      sethelptext(Loc.currentLang.helpText.team.memberTab);
      sethelptype(Loc.currentLang.menu.members);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.team.photoTab);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.team.documentTab);
      sethelptype(Loc.currentLang.menu.files);
    }
  };

  const handleLeagueTeamTapHelpText = async () => {
    if (isPlayerPage) {
      sethelptext(Loc.currentLang.helpText.season.playersTab);
      sethelptype(Loc.currentLang.menu.players);
    } else if (isStaffPage) {
      sethelptext(Loc.currentLang.helpText.season.staffTab);
      sethelptype(Loc.currentLang.menu.staff);
    } else if (isEventPage) {
      sethelptext(Loc.currentLang.helpText.season.eventTab);
      sethelptype(Loc.currentLang.menu.event);
    } else if (isGroup) {
      sethelptext(Loc.currentLang.helpText.season.groupTab);
      sethelptype(Loc.currentLang.menu.Group);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.season.photoTab);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.season.documentTab);
      sethelptype(Loc.currentLang.menu.files);
    } else if (isMembersPage) {
      sethelptext(Loc.currentLang.helpText.season.parentTab);
      sethelptype(Loc.currentLang.menu.parents);
    } else if (isSeasonPage) {
      sethelptext(Loc.currentLang.helpText.season.subTeamTab);
      sethelptype(Loc.currentLang.menu.parents);
    }
  };

  const handlePerformanceTapHelpText = async () => {
    if (isPlayerPage) {
      sethelptext(Loc.currentLang.helpText.season.playersTab);
      sethelptype(Loc.currentLang.menu.players);
    } else if (isStaffPage) {
      sethelptext(Loc.currentLang.helpText.season.staffTab);
      sethelptype(Loc.currentLang.menu.staff);
    } else if (isEventPage) {
      sethelptext(Loc.currentLang.helpText.season.eventTab);
      sethelptype(Loc.currentLang.menu.event);
    } else if (isGroup) {
      sethelptext(Loc.currentLang.helpText.person.organizationTxt);
      sethelptype(Loc.currentLang.menu.organization);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.season.photoTabPerformance);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.season.documentTabPerformance);
      sethelptype(Loc.currentLang.menu.files);
    } else if (isMembersPage) {
      sethelptext(Loc.currentLang.helpText.club.memberTab);
      sethelptype(Loc.currentLang.menu.parents);
    } else if (isSeasonPage) {
      sethelptext(Loc.currentLang.helpText.season.subTeamTab);
      sethelptype(Loc.currentLang.menu.parents);
    }
  };

  const handleEventTapHelpText = async () => {
    if (isparticipantspage && !isResourses) {
      sethelptext(Loc.currentLang.helpText.event.participantTab);
      sethelptype(Loc.currentLang.menu.participants);
    } else if (isResourses && !isparticipantspage) {
      sethelptext(Loc.currentLang.helpText.event.resourcesTab);
      sethelptype(Loc.currentLang.menu.resources);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.event.photoTab);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.event.documentTab);
      sethelptype(Loc.currentLang.menu.files);
    }
  };

  const handleClubTapHelpText = async () => {
    if (isStaffPage) {
      sethelptext(Loc.currentLang.helpText.club.staffTab);
      sethelptype(Loc.currentLang.menu.staff);
    } else if (isSeasonPage) {
      sethelptext(Loc.currentLang.helpText.club.termTab);
      sethelptype(Loc.currentLang.menu.Terms);
    } else if (isEventPage) {
      sethelptext(Loc.currentLang.helpText.club.eventTab);
      sethelptype(Loc.currentLang.menu.event);
    } else if (isGroup) {
      sethelptext(Loc.currentLang.helpText.club.groupTab);
      sethelptype(Loc.currentLang.menu.Group);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.club.photoTab);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.club.documentTab);
      sethelptype(Loc.currentLang.menu.files);
    } else if (isMembersPage) {
      sethelptext(Loc.currentLang.helpText.club.memberTab);
      sethelptype(Loc.currentLang.menu.members);
    }
  };

  const handleEliteClubTapHelpText = async () => {
    if (isStaffPage) {
      sethelptext(Loc.currentLang.helpText.eliteClub.staffTab);
      sethelptype(Loc.currentLang.menu.staff);
    } else if (isSeasonPage) {
      sethelptext(Loc.currentLang.helpText.eliteClub.organizationTab);
      sethelptype(Loc.currentLang.menu.organizations);
    } else if (isOrganization) {
      sethelptext(Loc.currentLang.helpText.eliteClub.teamsTab);
      sethelptype(Loc.currentLang.menu.organizations);
    } else if (isEventPage) {
      sethelptext(Loc.currentLang.helpText.eliteClub.eventTab);
      sethelptype(Loc.currentLang.menu.event);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.eliteClub.photoTab);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.eliteClub.documentTab);
      sethelptype(Loc.currentLang.menu.files);
    } else if (isMembersPage) {
      sethelptext(Loc.currentLang.helpText.eliteClub.memberTab);
      sethelptype(Loc.currentLang.menu.members);
    }
  };

  const handleSchoolTapHelpText = async () => {
    if (isStaffPage) {
      sethelptext(Loc.currentLang.helpText.school.administrationTab);
      sethelptype(Loc.currentLang.menu.Administration);
    } else if (isMembersPage) {
      sethelptext(Loc.currentLang.helpText.school.staffTab);
      sethelptype(Loc.currentLang.menu.staff);
    } else if (isEventPage) {
      sethelptext(Loc.currentLang.helpText.school.eventTab);
      sethelptype(Loc.currentLang.menu.event);
    } else if (isSeasonPage) {
      sethelptext(Loc.currentLang.helpText.school.organizationTab);
      sethelptype(Loc.currentLang.menu.organizations);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.school.photoTab);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.school.documentTab);
      sethelptype(Loc.currentLang.menu.files);
    } else if (isOrganization) {
      sethelptext(
        isSchoolYearOrgPage
          ? Loc.currentLang.helpText.school.yearOrganizationTab
          : Loc.currentLang.helpText.school.organizationTab,
      );
      sethelptype(Loc.currentLang.menu.organizations);
    }
  };

  const handleGroupTapHelpText = async () => {
    if (isStaffPage) {
      sethelptext(Loc.currentLang.helpText.group.staffTab);
      sethelptype(Loc.currentLang.menu.staff);
    } else if (isMembersPage) {
      sethelptext(Loc.currentLang.helpText.group.memberTab);
      sethelptype(Loc.currentLang.menu.members);
    } else if (isEventPage) {
      sethelptext(Loc.currentLang.helpText.group.eventTab);
      sethelptype(Loc.currentLang.menu.event);
    } else if (isSeasonPage) {
      sethelptext(Loc.currentLang.helpText.group.organizationTab);
      sethelptype(Loc.currentLang.menu.organizations);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.group.photoTab);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.group.documentTab);
      sethelptype(Loc.currentLang.menu.files);
    } else if (isGroup) {
      sethelptext(Loc.currentLang.helpText.group.groupTab);
      sethelptype(Loc.currentLang.menu.files);
    }
  };

  const handleClassTapHelpText = async () => {
    if (isStaffPage) {
      sethelptext(Loc.currentLang.helpText.class.staffTab);
      sethelptype(Loc.currentLang.menu.staff);
    } else if (isPlayerPage) {
      sethelptext(Loc.currentLang.helpText.class.studentTab);
      sethelptype(Loc.currentLang.menu.students);
    } else if (isEventPage) {
      sethelptext(Loc.currentLang.helpText.class.eventTab);
      sethelptype(Loc.currentLang.menu.event);
    } else if (isGroup) {
      sethelptext(Loc.currentLang.helpText.group.groupTab);
      sethelptype(Loc.currentLang.menu.Group);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.class.photoTab);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.class.documentTab);
      sethelptype(Loc.currentLang.menu.files);
    } else if (isMembersPage) {
      sethelptext(Loc.currentLang.helpText.class.parentTab);
      sethelptype(Loc.currentLang.menu.parents);
    }
  };

  const handleGradClassTapHelpText = async () => {
    if (isStaffPage) {
      sethelptext(Loc.currentLang.helpText.gradClass.staffTab);
      sethelptype(Loc.currentLang.menu.staff);
    } else if (isMembersPage) {
      sethelptext(Loc.currentLang.helpText.class.parentTab);
      sethelptype(Loc.currentLang.menu.parents);
    } else if (isEventPage) {
      sethelptext(Loc.currentLang.helpText.gradClass.eventTab);
      sethelptype(Loc.currentLang.menu.event);
    } else if (isGroup) {
      sethelptext(Loc.currentLang.helpText.gradClass.groupTab);
      sethelptype(Loc.currentLang.menu.Group);
    } else if (isPlayerPage) {
      sethelptext(Loc.currentLang.helpText.class.studentTab);
      sethelptype(Loc.currentLang.menu.students);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.gradClass.photoTab);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.gradClass.documentTab);
      sethelptype(Loc.currentLang.menu.files);
    }
  };

  const handleCommunityTapHelpText = async () => {
    if (isStaffPage) {
      sethelptext(Loc.currentLang.helpText.community.staffTab);
      sethelptype(Loc.currentLang.menu.staff);
    } else if (isMembersPage) {
      sethelptext(Loc.currentLang.helpText.community.memberTab);
      sethelptype(Loc.currentLang.menu.members);
    } else if (isEventPage) {
      sethelptext(Loc.currentLang.helpText.community.eventTab);
      sethelptype(Loc.currentLang.menu.event);
    } else if (isSeasonPage) {
      sethelptext(Loc.currentLang.helpText.community.organizationTab);
      sethelptype(Loc.currentLang.menu.organizations);
    } else if (isOrganization) {
      sethelptext(Loc.currentLang.helpText.community.organizationTab);
      sethelptype(Loc.currentLang.menu.organizations);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.community.photoTab);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.community.documentTab);
      sethelptype(Loc.currentLang.menu.files);
    }
  };

  const handleNeighborhoodTapHelpText = async () => {
    if (isStaffPage) {
      sethelptext(Loc.currentLang.helpText.neighborHood.administrationTab);
      sethelptype(Loc.currentLang.menu.Administration);
    } else if (isMembersPage) {
      sethelptext(Loc.currentLang.helpText.neighborHood.neighborTab);
      sethelptype(Loc.currentLang.menu.Neighbors);
    } else if (isEventPage) {
      sethelptext(Loc.currentLang.helpText.neighborHood.eventTab);
      sethelptype(Loc.currentLang.menu.event);
    } else if (isOrganization) {
      sethelptext(Loc.currentLang.helpText.neighborHood.organizationTab);
      sethelptype(Loc.currentLang.menu.organizations);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.neighborHood.photoTab);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.neighborHood.documentTab);
      sethelptype(Loc.currentLang.menu.files);
    }
  };

  const handleOrganizationTapHelpText = async () => {
    if (isStaffPage) {
      sethelptext(Loc.currentLang.helpText.organization.staffTab);
      sethelptype(Loc.currentLang.menu.staff);
    } else if (isMembersPage) {
      sethelptext(Loc.currentLang.helpText.organization.memberTab);
      sethelptype(Loc.currentLang.menu.members);
    } else if (isEventPage) {
      sethelptext(Loc.currentLang.helpText.organization.eventTab);
      sethelptype(Loc.currentLang.menu.event);
    } else if (isOrganization) {
      sethelptext(Loc.currentLang.helpText.organization.organizationTab);
      sethelptype(Loc.currentLang.menu.organizations);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.organization.photoTab);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.organization.documentTab);
      sethelptype(Loc.currentLang.menu.files);
    }
  };

  const handleTermTapHelpText = async () => {
    if (isPlayerPage) {
      sethelptext(Loc.currentLang.helpText.term.memberTab);
      sethelptype(Loc.currentLang.menu.members);
    } else if (isStaffPage) {
      sethelptext(Loc.currentLang.helpText.term.directorTab);
      sethelptype(Loc.currentLang.menu.directors);
    } else if (isEventPage) {
      sethelptext(Loc.currentLang.helpText.term.eventTab);
      sethelptype(Loc.currentLang.menu.event);
    } else if (isGroup) {
      sethelptext(Loc.currentLang.helpText.term.groupTab);
      sethelptype(Loc.currentLang.menu.organizations);
    } else if (isPhotoPage) {
      sethelptext(Loc.currentLang.helpText.term.photoTab);
      sethelptype(Loc.currentLang.menu.albums);
    } else if (isDocumentPage) {
      sethelptext(Loc.currentLang.helpText.term.documentTab);
      sethelptype(Loc.currentLang.menu.files);
    } else if (isMembersPage) {
      sethelptext(Loc.currentLang.helpText.term.parentTab);
      sethelptype(Loc.currentLang.menu.parents);
    }
  };

  const handleHelpText = async () => {
    switch (leagueTeamFK?.type) {
      case "Person":
        await handlePersonTapHelpText();
        break;
      case "Team":
        if (leagueTeamFK?.subType == "Club") await handleClubTapHelpText();
        else await handleTeamTapHelpText();
        break;
      case "PlayerOrg":
        if (leagueTeamFK?.subType == "Term") await handleTermTapHelpText();
        else if (leagueTeamFK?.subType == "Class")
          await handleClassTapHelpText();
        else if (leagueTeamFK?.subType == "MusicGroup")
          await handlePerformanceTapHelpText();
        else if (leagueTeamFK?.subType == "GradClass")
          await handleGradClassTapHelpText();
        else await handleLeagueTeamTapHelpText();
        break;
      case "Event":
        await handleEventTapHelpText();
        break;
      case "Club":
        await handleEliteClubTapHelpText();
        break;
      case "School":
      case "SchoolYear":
        if (
          leagueTeamFK?.type === "SchoolYear" &&
          (isPlayerPage || isPhotoPage || isDocumentPage)
        )
          await handleGradClassTapHelpText();
        else await handleSchoolTapHelpText();
        break;
      case "Group":
        await handleGroupTapHelpText();
        break;
      case "Community":
        await handleCommunityTapHelpText();
        break;
      case "Neighborhood":
        await handleNeighborhoodTapHelpText();
        break;
      case "Organization":
        await handleOrganizationTapHelpText();
        break;
      default:
        sethelptext(Loc.currentLang.helpText.Team);
        sethelptype(Loc.currentLang.menu.help);
        break;
    }
  };

  const openPreview = (item, allImages) => {
    setShowPreview(true);
    setSingleImage(item);
    allImages?.push(item);
    setShowAllImage(allImages);
  };

  const openPreviewprofile = (item, allImages) => {
    setShowPreview(true);
    setSingleImage(item);
    setShowAllImage([item]);
  };

  const findPersonInChats = (conversations, personToCheck) => {
    return conversations.find(
      (convo) =>
        convo?.subject === "" &&
        convo?.people?.some(
          (person) =>
            person?.id === personToCheck?.id &&
            person?.pk === personToCheck?.pk,
        ),
    );
  };

  const handleChat = async (item: any) => {
    setIsMemberTab(item);
    setIsRotate(true);
    let People: any = [];
    People?.push(item);
    let valid = await findPersonInChats(userconvo, item);
    if (valid?.id !== undefined) {
      setIsConvoData(valid?.id);
      setIsRotate(false);
      setIsOpenConvo(true);
      return;
    }
    let chatData = await handleSendSingleChat(People);
    if (chatData) {
      setIsConvoData(chatData?.id);
    }
    setIsRotate(false);
    setIsOpenConvo(true);
    setIsMemberTab(item);
  };

  useEffect(() => {
    console.log("useEffect4");
    resetAllPages();
    if (leagueTeamFK?.type === "Collect") {
      setIsCollectAboutPage(leagueTeamFK?.profile?.text);
      setIsCollectMembersPage(isAdminView && !leagueTeamFK?.profile?.text);
      setIsTeamsPage(false);
      setIsHomePage(false);
    } else {
      setIsTeamsPage(true);
      setIsHomePage(true);
      setIsCollectAboutPage(false);
      setIsCollectMembersPage(false);
    }
  }, [createType, showCreateNewPage]);

  useEffect(() => {
    console.log("useEffect5");
    window.scrollTo(0, 0);
    async function fetchData() {
      if (
        location?.state?.isCreate ||
        EntityId === "Create" ||
        EntityId === "USD" ||
        EntityId === "USC"
      ) {
        setIsCreate(true);
        setLeagueTeamFK(undefined);
        setProfile({
          background: null,
          pic: null,
          thumb: null,
          gallery: null,
          previousPic: null,
          text: null,
        });
        setteamName(
          location?.state?.searchInput ? location?.state?.searchInput : "",
        );
        setIntro("");
        setActivityType(null);
        resetAllPages();
      } else if (
        !location?.state?.isCreate &&
        (isUpdate || EntityId !== "Create")
      ) {
        setIsCreate(false);
        setIsUpdate(false);
        resetAllPages();
        setIsTeamsPage(viewTeam?.type !== "Collect");
        setIsCollectAboutPage(
          viewTeam?.type === "Collect" && leagueTeamFK?.profile?.text,
        );
        setIsCollectMembersPage(
          isAdminView &&
            viewTeam?.type === "Collect" &&
            !leagueTeamFK?.profile?.text,
        );

        //Entity Update Start
        if (
          (entitydatalist?.filter((x) => x?.id === viewTeam?.id)?.length > 0 &&
            viewTeam) ||
          (viewTeam?.type && viewTeam?.type == "Event")
        ) {
          setPageLoader(true);

          if (viewTeam.type == "Event") {
            if (viewTeam.type == "Event" && viewTeam.seriesId) {
              setPageLoader(true);

              if (viewTeam.seriesId) {
                setPageLoader(true);

                let entitydata = entitydatalist?.filter(
                  (x) => x?.id === viewTeam?.id,
                );
                if (entitydata?.length > 0) {
                  setLeagueTeamFK(entitydata[0]);
                  await EntityDataFinding(entitydata[0]);
                  //await handleSwitchTab(entitydata[0]);
                } else {
                  let ActualEvent: any = await getEvent(viewTeam);
                  entitydatalist?.push(ActualEvent);
                  dispatch(setEntitydata(entitydatalist));
                  await EntityDataFinding(ActualEvent);
                  setLeagueTeamFK(ActualEvent);
                  //await handleSwitchTab(ActualEvent);
                }
              }
              setPageLoader(true);
              if (
                entitydatalist?.filter((x) => x?.id === viewTeam?.id)?.length >
                  0 &&
                !viewTeam.seriesId
              ) {
                //let ActualEvent : AV.IAVEntity = await getEvent(viewTeam);
                setLeagueTeamFK(
                  entitydatalist?.filter((x) => x?.id === viewTeam?.id),
                );
                await EntityDataFinding(
                  entitydatalist?.filter((x) => x?.id === viewTeam?.id),
                );
                //await handleSwitchTab(entitydatalist?.filter(x => x?.id === viewTeam?.id));
              } else {
                if (viewTeam && !viewTeam.seriesId) {
                  await AV.AVEntity.get(AV.AVEntity.getFk(viewTeam)).then(
                    (e) => {
                      if (e == null) {
                        setshowunauthorizedDetails(true);
                        return;
                      }

                      if (e) {
                        setLeagueTeamFK(e);
                        EntityDataFinding(e);
                        //handleSwitchTab(e);
                        entitydatalist[
                          entitydatalist.indexOf(
                            entitydatalist?.find((x) => x?.id === viewTeam?.id),
                          )
                        ] = e;
                        dispatch(setEntitydata(entitydatalist));
                      }
                    },
                  );
                }
              }
            } else {
              let IsPass =
                entitydatalist?.filter((x) => x?.id === viewTeam?.id)?.length >
                0
                  ? true
                  : false;
              if (IsPass) {
                const now = new Date();
                const isFuture = new Date(viewTeam?.start) > now;
                const isOngoing =
                  new Date(viewTeam?.start) <= now &&
                  now <= new Date(viewTeam?.end);
                setIsOngoingOrFuture(isFuture || isOngoing);
                console.log(
                  `Event detected -> isFuture: ${isFuture}, isOngoing: ${isOngoing}, result: ${isFuture || isOngoing}`,
                );
                setLeagueTeamFK(
                  entitydatalist?.find((x) => x?.id === viewTeam?.id),
                );
                await EntityDataFinding(
                  entitydatalist?.find((x) => x?.id === viewTeam?.id),
                );
                //await handleSwitchTab(entitydatalist?.find(x => x?.id === viewTeam?.id));
                if (viewTeam) {
                  AV.AVEntity.get(AV.AVEntity.getFk(viewTeam)).then((e) => {
                    if (e == null) {
                      setshowunauthorizedDetails(true);
                      return;
                    }

                    if (e) {
                      setLeagueTeamFK(e);

                      EntityDataFinding(e);
                      //handleSwitchTab(e);
                      entitydatalist[
                        entitydatalist.indexOf(
                          entitydatalist?.find((x) => x?.id === viewTeam?.id),
                        )
                      ] = e;
                      dispatch(setEntitydata(entitydatalist));
                    }
                  });
                }
              } else {
                if (viewTeam) {
                  await AV.AVEntity.get(AV.AVEntity.getFk(viewTeam)).then(
                    (e) => {
                      if (e == null) {
                        setshowunauthorizedDetails(true);
                        return;
                      }

                      if (e) {
                        setLeagueTeamFK(e);
                        EntityDataFinding(e);
                        //handleSwitchTab(e);
                        entitydatalist?.push(e);
                        dispatch(setEntitydata(entitydatalist));
                      }
                    },
                  );
                }
                setPageLoader(false);
              }
            }
          } else {
            console.log("step 02");
            setPageLoader(true);
            setLeagueTeamFK(
              entitydatalist?.find((x) => x?.id === viewTeam?.id),
            );
            await EntityDataFinding(
              entitydatalist?.find((x) => x?.id === viewTeam?.id),
            );
            //await handleSwitchTab(entitydatalist?.find(x => x?.id === viewTeam?.id));
            if (!location?.state?.newEntity) {
              AV.AVEntity.get(AV.AVEntity.getFk(viewTeam)).then((e) => {
                if (e == null) {
                  setshowunauthorizedDetails(true);
                  return;
                }

                if (e) {
                  setLeagueTeamFK(e);

                  EntityDataFinding(e);
                  //handleSwitchTab(e);
                  entitydatalist[
                    entitydatalist.indexOf(
                      entitydatalist?.find((x) => x?.id === viewTeam?.id),
                    )
                  ] = e;
                  dispatch(setEntitydata(entitydatalist));
                }
              });
            }
          }
          setPageLoader(false);
        } else {
          console.log("step 03");
          setPageLoader(true);
          if (viewTeam && !viewTeam.seriesId) {
            console.log("step 04");
            await AV.AVEntity.get(AV.AVEntity.getFk(viewTeam)).then((e) => {
              if (e == null) {
                setshowunauthorizedDetails(true);
                return;
              }

              if (e) {
                setLeagueTeamFK(e);
                EntityDataFinding(e);
                //handleSwitchTab(e);
                entitydatalist?.push(e);
                dispatch(setEntitydata(entitydatalist));
              }
            });
          } else if (viewTeam && viewTeam.seriesId) {
            let e = await getEvent(viewTeam);
            if (e) {
              setLeagueTeamFK(e);
              EntityDataFinding(e);
              //handleSwitchTab(e);
              entitydatalist?.push(e);
              dispatch(setEntitydata(entitydatalist));
            }
          } else {
            if (EntityId !== "Create") {
              console.log("step 05");
              setPageLoader(true);
              var teamValue = currentUser?.orgs?.filter(
                (x) => x?.id === EntityId,
              );
              if (teamValue?.length == 0) {
                teamValue = currentUser?.events?.filter(
                  (x) => x?.id === EntityId,
                );
              }
              if (teamValue?.length == 0) {
                teamValue = currentUser?.ownedEvents?.filter(
                  (x) => x?.id === EntityId,
                );
              }
              if (teamValue?.length == 0) {
                teamValue = entitydatalist?.filter((x) => x?.id === EntityId);
              }
              let targetFK = {
                Id: EntityId,
                Pk: EntityId?.substr(-4),
                Region: region,
                Type: "Team",
              };

              if (entityToken?.type) {
                console.log("useEffect5 entityToken", entityToken);
                targetFK = entityToken;
                dispatch(setEntityToken([]));
              }

              let e: any = await AV.AVEntity.get(
                AV.AVEntity.getFk(
                  teamValue?.length > 0 ? teamValue[0] : targetFK,
                ),
              );

              if (e == null) {
                setshowunauthorizedDetails(true);
                return;
              }

              if (e) {
                if (e.eventType === "Meeting" || e.eventType === "Practice") {
                  const currentEvent = Array.isArray(e?.seriesEvents)
                    ? e.seriesEvents.filter((x) => x.id === seriesId)
                    : [];
                  const currentEventObj =
                    currentEvent.length > 0 ? currentEvent[0] : e;
                  const now = new Date();
                  const isFuture = new Date(currentEventObj?.start) > now;
                  const isOngoing =
                    new Date(currentEventObj?.start) <= now &&
                    now <= new Date(currentEventObj?.end);
                  setIsOngoingOrFuture(isFuture || isOngoing);
                  console.log(
                    `Event detected -> isFuture: ${isFuture}, isOngoing: ${isOngoing}, result: ${isFuture || isOngoing}`,
                  );
                } else {
                  //const isFuture = new Date(e?.start) > new Date();
                  //setIsFutureEvent(isFuture);
                  //console.log("Event detected - isOngoingOrFuture:", isFuture);

                  if (e?.type !== "Event") {
                    setIsOngoingOrFuture(true);
                    console.log("Event not detected - isOngoingOrFuture: true");
                  }
                }

                //await handleSwitchTab(e);
                setLeagueTeamFK(e);
                EntityDataFinding(e);
                entitydatalist?.push(e);
                dispatch(setEntitydata(entitydatalist));
              }
              //AV.AVEntity.checkLinks(currentUser, e).then((x) => {
              //  dispatch(setUser(x));
              //  AV.Person.checkIfSelf(x);
              //});
              if (
                e?.id == "78b5b063-fd3e-4925-92bd-2a1888c6a46a" ||
                e?.id == "b495d4e0-bf52-4690-8dc0-677db954aa7f" ||
                e?.id == "b495d4e0-bf52-4690-8dc0-677db954aa71" ||
                e?.id == "b495d4e0-bf52-4690-8dc0-677db954aa72"
              ) {
                navigate(`/teams/${e?.id}/${currentUser?.region}`, {
                  state: {
                    team: {
                      id: e?.id,
                      pk: "a46a",
                      region: currentUser?.region,
                      type: "Organization",
                      name: "Actavivo",
                    },
                    type: "Feedback",
                  },
                });
              } else {
                if (e) {
                  setLeagueTeamFK(e);
                  EntityDataFinding(e);
                  //await handleSwitchTab(e);
                }
              }
            }
          }
          setPageLoader(false);
        }
      }
    }

    let isMounted = true;
    if (isMounted) {
      fetchData();
    }

    return () => {
      isMounted = false;
    };
  }, [EntityId, viewTeam, /*entitydatalist,*/ restoreRefresh]);

  useEffect(() => {
    console.log("useEffect6");
    if (leagueTeamFK?.type === "Collect") {
      setIsCollectAboutPage(leagueTeamFK?.profile?.text);
      setIsCollectMembersPage(isAdminView && !leagueTeamFK?.profile?.text);
      setIsHomePage(false);
      setIsTeamsPage(false);
    } else {
      setIsHomePage(true);
      setIsCollectAboutPage(false);
      setIsCollectMembersPage(false);
    }
  }, [showCreateNewPage]);

  useEffect(() => {
    console.log("useEffect8");
    let isMounted = true;
    if (isMounted) {
      handleHelpText();
    }
    return () => {
      isMounted = false;
    };
  }, [
    isHomePage,
    isTeamsPage,
    isEventPage,
    isMembersPage,
    isStaffPage,
    isPlayerPage,
    isPhotoPage,
    isGroup,
    isOrganization,
    isSeasonPage,
  ]);

  useEffect(() => {
    console.log("useEffect9");
    let isMounted = true;
    if (isMounted) {
      const following = user?.follows;
      const requests = user?.myRequests;
      const Participant: any =
        leagueTeamFK?.status == "Canceled"
          ? false
          : leagueTeamFK?.participants?.some(
              (x) =>
                x?.id === user?.id &&
                (x?.linkType === "Owner" || x?.linkType === "Staff"),
            );
      following?.filter((item) => item?.id === leagueTeamFK?.id).length > 0
        ? setIsFollowing(true)
        : setIsFollowing(false);
      requests?.filter((item) => item?.target?.id === leagueTeamFK?.id).length >
      0
        ? setRequestSent(true)
        : setRequestSent(false);

      if (leagueTeamFK?.type === "Collect") {
        setIsCollectAboutPage(leagueTeamFK?.profile?.text);
        setIsCollectMembersPage(isAdminView && !leagueTeamFK?.profile?.text);
        setIsTeamsPage(false);
        setIsHomePage(false);
      } else {
        setIsTeamsPage(true);
        setIsHomePage(true);
        setIsCollectAboutPage(false);
        setIsCollectMembersPage(false);
      }
    }
    return () => {
      isMounted = false;
    };
  }, [leagueTeamFK?.id, user?.id]);

  //Outside click to close
  const menuRefs = useRef<HTMLDivElement | null>(null);
  useOutsideAlerter(menuRefs);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      console.log("useEffect10");
      let isMounted = true;
      if (isMounted) {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setIsActiveRole(false);
            setOrgOpen(false);
            setIsActive(false);
            setIsActives(false);
            setOrgOpen(false);
            setIsOpen(false);
            setIsShowEditOccurence(false);
            setIsShowEditEntireSeries(false);
            setIsSchoolYearsOrgTabOption(false);
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }
      return () => {
        isMounted = false; // Set the flag to false when the component is unmounted
        // Cancel subscriptions or perform any cleanup tasks here
      };
    }, [ref]);
  }

  return (
    <>
      <AVBody
        setShowCreateNewPage={setShowCreateNewPage}
        isOpenConvo={isOpenConvo}
        setIsOpenConvo={setIsOpenConvo}
        setIsShowEdit={setIsShowEdit}
        showCreateNewPage={showCreateNewPage}
        setCreateType={setCreateType}
        createType={createType}
        passEntity={passEntity}
        setPassEntity={setPassEntity}
        setIsConvoData={setIsConvoData}
        isConvoData={isConvoData}
        setIshuddleData={setIshuddleData}
      >
        {pageLoader &&
        !isCreate &&
        (leagueTeamFK?.length === 0 ||
          leagueTeamFK == undefined ||
          leagueTeamFK == null) ? (
          <PageLoader />
        ) : (
          <>
            <HStack flex={1} width={"100%"} space={[0, 0, 3, 4]}>
              <HStack flex={[1, 1, 3]}>
                <VStack flex={1}>
                  <Box
                    height={"auto"}
                    borderRadius={5}
                    backgroundColor={"AVColor.white"}
                    shadow={1}
                    borderTopLeftRadius={10}
                    borderTopRightRadius={10}
                    marginBottom={"12px"}
                  >
                    {/*ProfileHeader*/}
                    <ProfileHeader
                      setIshuddleData={setIshuddleData}
                      isCreate={isCreate}
                      setIsCreateDependents={undefined}
                      isCreateDependents={undefined}
                      isShowEdit={isShowEdit}
                      Entity={leagueTeamFK}
                      handleUpload={handleUpload}
                      EntityType={viewTeam ? viewTeam : leagueTeamFK}
                      type={Feedbacktype}
                      setIsShowEdit={setIsShowEdit}
                      profile={profile}
                      setProfile={setProfile}
                      googlemap={googlemap}
                      isAdminView={isAdminView}
                      weatherURL={weatherURL}
                      weather={weather}
                      Owner={Owner}
                      setIsImagePopup={setIsImagePopup}
                      setEntity={setLeagueTeamFK}
                      editAccess={isOngoingOrFuture}
                      isEntireSeriesAvailable={isEntireSeriesAvailable}
                      setIsStaffReq={setIsStaffReq}
                      setIsChildOrgReq={setIsChildOrgReq}
                      isDeleted={isDeleted}
                      HandleBlockUser={undefined}
                      setIsConvoData={setIsConvoData}
                      HandleUnBlockUser={undefined}
                      HandleRestoreAccount={HandleRestoreAccount}
                      HandleUnFollowUser={undefined}
                      setIsOpenConvo={setIsOpenConvo}
                      setIsEditEntireSeries={setIsEditEntireSeries}
                      isEditEntireSeries={isEditEntireSeries}
                      seriesEvent={seriesEvent}
                      isRequestAgain={false}
                      setIsRequestAgain={undefined}
                      openPreview={openPreviewprofile}
                      isShowPayPopup={isShowPayPopup}
                      setIsShowPayPopup={setIsShowPayPopup}
                      setClickedUrl={setClickedUrl}
                      setShowConfirmLinkPopup={setShowConfirmLinkPopup}
                    />

                    {/*Create and Edit All entity*/}
                    {(isCreate || isShowEdit) && (
                      <AVCreateTeam
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        type={
                          location?.state?.type
                            ? location?.state?.type
                            : leagueTeamFK?.type
                        }
                        profile={profile}
                        isShowEdit={isShowEdit}
                        setIsShowEdit={setIsShowEdit}
                        teamType={teamType}
                        Entity={leagueTeamFK}
                        setEntity={setLeagueTeamFK}
                        EntityDataFinding={EntityDataFinding}
                        setgooglemap={setgooglemap}
                        setProfile={setProfile}
                        handleUpload={handleUpload}
                        setShowCreateNewPage={setShowCreateNewPage}
                        setCreateType={setCreateType}
                        setPassEntity={setPassEntity}
                        passEntity={passEntity}
                        isEditEntireSeries={isEditEntireSeries}
                        setIsEditEntireSeries={setIsEditEntireSeries}
                        seriesEvent={currentItem}
                      />
                    )}

                    {/* TabHeader and feedback*/}
                    {!isCreate && !isShowEdit && isDeleted && (
                      <HStack
                        height={
                          Feedbacktype === "Feedback" &&
                          FeedBackId === "78b5b063-fd3e-4925-92bd-2a1888c6a46a"
                            ? "auto"
                            : FeedBackId ===
                                "b495d4e0-bf52-4690-8dc0-677db954aa72"
                              ? "0px"
                              : "61px"
                        }
                        width={"100%"}
                      >
                        {Feedbacktype !== "Feedback" && (
                          <TabHeader
                            menu={
                              leagueTeamFK?.type == "Collect"
                                ? collectMenu
                                : leagueTeamFK?.subType == "Club"
                                  ? TeamClubMenu
                                  : leagueTeamFK?.type == "Club"
                                    ? EliteClubTab
                                    : leagueTeamFK?.subType == "Class"
                                      ? ClassMenu
                                      : (leagueTeamFK?.parent?.type ===
                                            "School" ||
                                            leagueTeamFK?.parent?.subType ===
                                              "Alumni") &&
                                          leagueTeamFK?.subType == "GradClass"
                                        ? SchoolGradClassMenu
                                        : leagueTeamFK?.subType == "GradClass"
                                          ? GradClassMenu
                                          : leagueTeamFK?.type == "Neighborhood"
                                            ? neighborhoodMenu
                                            : leagueTeamFK?.type == "Community"
                                              ? communityMenu
                                              : leagueTeamFK?.type === "School"
                                                ? SchoolMenu
                                                : leagueTeamFK?.type ===
                                                    "SchoolYear"
                                                  ? SchoolYearMenu
                                                  : leagueTeamFK?.type == "Team"
                                                    ? TeamsMenu
                                                    : leagueTeamFK?.type ==
                                                          "PlayerOrg" &&
                                                        leagueTeamFK?.subType !==
                                                          "Term" &&
                                                        leagueTeamFK?.subType !==
                                                          "MusicGroup"
                                                      ? SeasonsMenu
                                                      : leagueTeamFK?.type ==
                                                            "PlayerOrg" &&
                                                          leagueTeamFK?.subType ===
                                                            "Term"
                                                        ? TermsMenu
                                                        : leagueTeamFK?.type ==
                                                            "Event"
                                                          ? eventsMenu
                                                          : leagueTeamFK?.type ==
                                                                "PlayerOrg" &&
                                                              leagueTeamFK?.subType ===
                                                                "MusicGroup"
                                                            ? PerformanceGroupMenu
                                                            : leagueTeamFK?.type ==
                                                                  "Group" &&
                                                                leagueTeamFK?.subType ===
                                                                  "Alumni"
                                                              ? SchoolAlumniMenu
                                                              : leagueTeamFK?.type ==
                                                                  "Group"
                                                                ? GroupMenu
                                                                : orgsMenu
                            }
                            MoreMenu={
                              leagueTeamFK?.type == "Collect"
                                ? collectMenu
                                : leagueTeamFK?.subType == "Club"
                                  ? TeamClubMenu
                                  : leagueTeamFK?.type == "Club"
                                    ? EliteClubTab
                                    : leagueTeamFK?.subType == "Class"
                                      ? ClassMenu
                                      : (leagueTeamFK?.parent?.type ===
                                            "School" ||
                                            leagueTeamFK?.parent?.subType ===
                                              "Alumni") &&
                                          leagueTeamFK?.subType == "GradClass"
                                        ? SchoolGradClassMenu
                                        : leagueTeamFK?.subType == "GradClass"
                                          ? GradClassMenu
                                          : leagueTeamFK?.type == "Neighborhood"
                                            ? neighborhoodMenu
                                            : leagueTeamFK?.type == "Community"
                                              ? communityMenu
                                              : leagueTeamFK?.type === "School"
                                                ? SchoolMenu
                                                : leagueTeamFK?.type ===
                                                    "SchoolYear"
                                                  ? SchoolYearMenu
                                                  : leagueTeamFK?.type == "Team"
                                                    ? TeamsMenu
                                                    : leagueTeamFK?.type ==
                                                          "PlayerOrg" &&
                                                        leagueTeamFK?.subType !==
                                                          "Term" &&
                                                        leagueTeamFK?.subType !==
                                                          "MusicGroup"
                                                      ? SeasonsMenu
                                                      : leagueTeamFK?.type ==
                                                            "PlayerOrg" &&
                                                          leagueTeamFK?.subType ===
                                                            "Term"
                                                        ? TermsMenu
                                                        : leagueTeamFK?.type ==
                                                            "Event"
                                                          ? eventsMenu
                                                          : leagueTeamFK?.type ==
                                                                "Group" &&
                                                              leagueTeamFK?.subType ===
                                                                "Alumni"
                                                            ? SchoolAlumniMenu
                                                            : leagueTeamFK?.type ==
                                                                "Group"
                                                              ? GroupMenu
                                                              : leagueTeamFK?.type ==
                                                                    "PlayerOrg" &&
                                                                  leagueTeamFK?.subType ===
                                                                    "MusicGroup"
                                                                ? PerformanceGroupMenu
                                                                : orgsMenu
                            }
                            isDropDown={isDropDown}
                            Entity={leagueTeamFK}
                            setIsDropDown={setIsDropDown}
                            type={leagueTeamFK?.type}
                            onboardingFlow={onboardingFlow}
                            onboardingStep={onboardingStep}
                            setOnboardingStep={setOnboardingStep}
                            clearCurrentTourFlow={clearCurrentTourFlow}
                          />
                        )}

                        {Feedbacktype === "Feedback" && (
                          <VStack
                            paddingY={"24px"}
                            paddingLeft={"24px"}
                            paddingRight={"12px"}
                            width={"100%"}
                          >
                            {Feedbacktype === "Feedback" &&
                              FeedBackId ===
                                "78b5b063-fd3e-4925-92bd-2a1888c6a46a" && (
                                <HStack marginBottom={"24px"}>
                                  <Text fontSize={"16px"} fontWeight={400}>
                                    {
                                      Loc.currentLang.menu
                                        .toStartAPostPleaseSelectACategory
                                    }
                                  </Text>
                                </HStack>
                              )}

                            {Feedbacktype === "Feedback" &&
                              (FeedBackId ===
                                "b495d4e0-bf52-4690-8dc0-677db954aa7f" ||
                                FeedBackId ===
                                  "b495d4e0-bf52-4690-8dc0-677db954aa7f") && (
                                <HStack marginBottom={"24px"} space={4}>
                                  <Text fontSize={"16px"} fontWeight={400}>
                                    {
                                      Loc.currentLang.menu
                                        .shareYourFeedbackLetUsKnowWhatIsGoingOnYourMind
                                    }
                                  </Text>
                                </HStack>
                              )}

                            {Feedbacktype === "Feedback" &&
                              (FeedBackId ===
                                "b495d4e0-bf52-4690-8dc0-677db954aa71" ||
                                FeedBackId ===
                                  "b495d4e0-bf52-4690-8dc0-677db954aa71") && (
                                <HStack marginBottom={"24px"}>
                                  <Text fontSize={"16px"} fontWeight={400}>
                                    {
                                      Loc.currentLang.menu
                                        .shareYourFeedbackLetUsKnowWhatIsGoingOnYourMind
                                    }
                                  </Text>
                                </HStack>
                              )}

                            {type === "Feedback" &&
                              (FeedBackId ===
                                "b495d4e0-bf52-4690-8dc0-677db954aa72" ||
                                FeedBackId ===
                                  "b495d4e0-bf52-4690-8dc0-677db954aa72") && (
                                <HStack marginBottom={"24px"}>
                                  <Text fontSize={"16px"} fontWeight={400}>
                                    {
                                      Loc.currentLang.menu
                                        .shareYourFeedbackLetUsKnowWhatIsGoingOnYourMind
                                    }
                                  </Text>
                                </HStack>
                              )}

                            {FeedBackId !==
                              "b495d4e0-bf52-4690-8dc0-677db954aa72" &&
                              FeedBackId !==
                                "b495d4e0-bf52-4690-8dc0-677db954aa71" &&
                              FeedBackId !==
                                "b495d4e0-bf52-4690-8dc0-677db954aa7f" && (
                                <HStack
                                  flexWrap={"wrap"}
                                  zIndex={-2}
                                  alignSelf={"center"}
                                  space={"24px"}
                                >
                                  {isshowteamsList?.length > 0 &&
                                    isshowteamsList?.map((item: any, i) => (
                                      <Box
                                        key={item.id + i}
                                        bgColor={"#fff"}
                                        borderWidth={"1px"}
                                        borderColor={"gray.100"}
                                        shadow={3}
                                        width={"235px"}
                                        marginY={"5px"}
                                        height={"208px"}
                                        borderRadius={8}
                                      >
                                        <VStack
                                          key={item?.id}
                                          alignItems={"center"}
                                          padding={2}
                                          height={"100%"}
                                          width={"100%"}
                                        >
                                          <Pressable
                                            key={item.id}
                                            _hover={{ bgColor: "gray.100" }}
                                            p={2}
                                            height={"100%"}
                                            alignItems={"center"}
                                            width={"100%"}
                                            borderRadius={5}
                                            minWidth={120}
                                            onPress={() =>
                                              HandeFeedBackNavigate(item)
                                            }
                                          >
                                            {item?.thumb && (
                                              <Box
                                                bgColor={"#FF6600"}
                                                borderRadius={["full"]}
                                                width={"100px"}
                                                height={"100px"}
                                                alignSelf={"center"}
                                              >
                                                <Image
                                                  source={{
                                                    uri: AV.Media.getThumb(
                                                      item,
                                                    ),
                                                  }}
                                                  borderRadius={["full"]}
                                                  width={"100%"}
                                                  height={["100%"]}
                                                />
                                              </Box>
                                            )}
                                            {item.title === "Feedback" && (
                                              <FeedbackIcon
                                                height={"100"}
                                                width={"100"}
                                              />
                                            )}
                                            {item.title === "Bug Reports" && (
                                              <BugReportIcon
                                                height={"100"}
                                                width={"100"}
                                              />
                                            )}
                                            {item.title ===
                                              "Feature Requests" && (
                                              <FeatureRequestIcon
                                                height={"100"}
                                                width={"100"}
                                              />
                                            )}
                                            <Tooltip
                                              label={item.title}
                                              openDelay={500}
                                            >
                                              <Pressable
                                                paddingTop={"24px"}
                                                onPress={() =>
                                                  HandeFeedBackNavigate(item)
                                                }
                                              >
                                                <Text
                                                  numberOfLines={1}
                                                  alignSelf={"center"}
                                                  fontWeight={500}
                                                >
                                                  {item.title === "Feedback"
                                                    ? Loc.currentLang.menu
                                                        .feedback
                                                    : item.title ===
                                                        "Bug Reports"
                                                      ? Loc.currentLang.menu
                                                          .bugReports
                                                      : item.title ===
                                                          "Feature Requests"
                                                        ? Loc.currentLang.menu
                                                            .featureRequests
                                                        : item.title}
                                                </Text>
                                              </Pressable>
                                            </Tooltip>
                                          </Pressable>
                                        </VStack>
                                      </Box>
                                    ))}
                                </HStack>
                              )}
                          </VStack>
                        )}
                      </HStack>
                    )}
                  </Box>

                  {/*Suspended POPUP*/}
                  {leagueTeamFK?.status === "Suspended" &&
                    !isSuspended &&
                    !isAdminView &&
                    !isCreate &&
                    !isShowEdit && (
                      <Box
                        position={"fixed"}
                        top={0}
                        bottom={0}
                        left={0}
                        right={0}
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        backgroundColor={"rgba(0, 0, 0, 0.25)"}
                        zIndex={9999}
                      >
                        <div className={`customModal`}>
                          <div className={`show_unauthorized_details`}>
                            <VStack alignItems={"center"} width={"100%"}>
                              <HStack
                                position={"absolute"}
                                justifyContent={"flex-end"}
                                right={"15px"}
                                top={"13px"}
                                width={"100%"}
                              >
                                <AVCancel
                                  color={undefined}
                                  size={undefined}
                                  callback={() => setIsSuspended(true)}
                                />
                              </HStack>

                              <img
                                src={suspend}
                                alt="image"
                                height={"220px"}
                                width={"240px"}
                              />

                              <HStack paddingBottom={"8px"}>
                                <Text fontWeight={400} fontSize={"24px"}>
                                  {Loc.currentLang.menu.temporaryTakingaBreak}
                                </Text>
                              </HStack>

                              <HStack>
                                <Text>
                                  {Loc.currentLang.menu.restrictPostTxt}
                                </Text>
                              </HStack>

                              <HStack marginTop={"15px"}>
                                <Button
                                  rounded="full"
                                  backgroundColor={"#EEEEEE"}
                                  height={"30px"}
                                  width={"60px"}
                                  onPress={() => setIsSuspended(true)}
                                >
                                  <Text
                                    fontSize={"14px"}
                                    color={"rgba(0,0,0,0.5)"}
                                    fontWeight={"bold"}
                                  >
                                    {Loc.currentLang.menu.ok}
                                  </Text>
                                </Button>
                              </HStack>
                            </VStack>
                          </div>
                        </div>
                      </Box>
                    )}

                  <VStack zIndex={isDropDown || isShowPayPopup ? -3 : ""}>
                    {/* Event page*/}
                    {isEventPage && !isShowEdit && (
                      <AVCardList
                        tab={"Events"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={leagueTeamFK}
                        setEntity={setLeagueTeamFK}
                        menuRefs={menuRefs}
                        allEventData={allEventData}
                        isLoadingEvent={isLoadingEvent}
                        handleCreateEvent={handleCreateEvent}
                      />
                    )}

                    {/* season page*/}
                    {isSeasonPage && !isShowEdit && (
                      <AVCardList
                        tab={"Season"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={leagueTeamFK}
                        setEntity={setLeagueTeamFK}
                        onboardingFlow={onboardingFlow}
                        onboardingStep={onboardingStep}
                        setOnboardingStep={setOnboardingStep}
                        clearCurrentTourFlow={clearCurrentTourFlow}
                      />
                    )}

                    {/* staff page*/}
                    {isStaffPage && !isShowEdit && (
                      <>
                        <Box
                          width={"100%"}
                          minHeight={"340px"}
                          h="auto"
                          paddingTop={"10px"}
                          bgColor="#fff"
                          rounded="lg"
                        >
                          <VStack zIndex={-3}>
                            <HStack
                              alignItems={"center"}
                              justifyContent={"space-between"}
                            >
                              <Text
                                fontWeight={"500"}
                                marginLeft={"15px"}
                                fontSize={"22px"}
                                color={"AVColor.primary"}
                                py={"12px"}
                              >
                                {leagueTeamFK?.type == "School"
                                  ? Loc.currentLang.menu.administration
                                  : leagueTeamFK?.subType == "Term"
                                    ? "Directors"
                                    : Loc.currentLang.menu.staff}
                              </Text>

                              <HStack alignItems={"center"} zIndex={-3}>
                                <Tooltip
                                  label={helptext}
                                  w={200}
                                  openDelay={500}
                                >
                                  <Box
                                    marginRight={"10px"}
                                    p={"9px"}
                                    shadow={1}
                                    zIndex={-3}
                                    backgroundColor={"AVColor.liteBg"}
                                    rounded={"full"}
                                  >
                                    <img
                                      src={helping}
                                      height={"17px"}
                                      width={"17px"}
                                      style={{ zIndex: -3 }}
                                    />
                                  </Box>
                                </Tooltip>
                                {isAdminView && (
                                  <Tooltip
                                    label={Loc.currentLang.menu.editRoles}
                                    openDelay={500}
                                  >
                                    <Pressable
                                      backgroundColor={"AVColor.liteBg"}
                                      rounded={"full"}
                                      p={"10px"}
                                      marginRight={"10px"}
                                      _hover={{
                                        backgroundColor: "AVColor.hovercolor",
                                      }}
                                      onPress={() => {
                                        navigate(
                                          `/accountsettings/${leagueTeamFK?.id}/${leagueTeamFK?.region}`,
                                          {
                                            state: {
                                              page: pathName,
                                              Entity: leagueTeamFK,
                                              isEdit: true,
                                            },
                                          },
                                        );
                                      }}
                                    >
                                      <EditIcon size="20px" />
                                    </Pressable>
                                  </Tooltip>
                                )}

                                {
                                  //(isAdminView || checkConvoExitorNot("S")) &&
                                  staffList?.length > 0 && (
                                    <Offline>
                                      {({ isOffline }) => (
                                        <Button
                                          isDisabled={isOffline}
                                          p={"10px"}
                                          shadow={1}
                                          bgColor={
                                            isLoad ? "#32AE78" : "gray.100"
                                          }
                                          _hover={{ bgColor: "gray.50" }}
                                          isLoading={isLoad}
                                          rounded={"full"}
                                          marginRight={"3px"}
                                          onPress={() => HandleGroupChat("S")}
                                        >
                                          {
                                            <GroupChatIcon
                                              size={23}
                                              color={"rgba(0, 0, 0, 0.5)"}
                                            />
                                          }
                                        </Button>
                                      )}
                                    </Offline>
                                  )
                                }

                                {isAdminView && (
                                  <Offline>
                                    {({ isOffline }) => (
                                      <Button
                                        isDisabled={isOffline}
                                        p={"10px"}
                                        shadow={1}
                                        bgColor={"gray.100"}
                                        _hover={{ bgColor: "gray.50" }}
                                        rounded={"full"}
                                        marginRight={"3px"}
                                        onPress={() =>
                                          handleProfileType("Staff")
                                        }
                                      >
                                        <AddIcon
                                          size={"20px"}
                                          color={"#32AE78"}
                                        />
                                      </Button>
                                    )}
                                  </Offline>
                                )}
                              </HStack>
                            </HStack>
                          </VStack>
                          <Divider my={2} zIndex={-3} />

                          <HStack flexWrap={"wrap"} width={"100%"}>
                            <FlatList
                              width={"100%"}
                              data={staffList}
                              scrollEnabled={true}
                              ListEmptyComponent={
                                <Center height={200}>
                                  {Loc.currentLang.menu.noStaffsFound}
                                </Center>
                              }
                              renderItem={(item: any) => (
                                <StaffsCard
                                  leagueTeam={leagueTeamFK}
                                  data={item}
                                  {...props}
                                  key={item?.id}
                                  item={item}
                                  setStaffList={setStaffList}
                                  Editstaffitem={Editstaffitem}
                                  setEditstaffitem={setEditstaffitem}
                                  staffList={staffList}
                                  setIsStaffEdit={setIsStaffEdit}
                                  setstaffemail={setstaffemail}
                                  setstaffphone={setstaffphone}
                                  setStaffRole={setStaffRole}
                                  setstaffpic={setstaffpic}
                                  HandleRemoveStaffs={HandleRemoveStaffs}
                                  setIsOpenConvo={setIsOpenConvo}
                                  setIsConvoData={setIsConvoData}
                                />
                              )}
                              showsVerticalScrollIndicator={false}
                              numColumns={isMobile ? 1 : isTab ? 2 : 3}
                            />
                          </HStack>
                        </Box>

                        {isStaffEdit && (
                          <Box
                            position="fixed"
                            bgColor={"AVColor.overlay2"}
                            bottom={0}
                            right={0}
                            top={0}
                            left={0}
                            zIndex={99}
                          >
                            <div
                              style={{
                                position: "fixed",
                                top: "58%",
                                left: "53%",
                                width: "90%",
                                transform: "translate(-53%, -50%)",
                                background: "#ffffff",
                                boxShadow:
                                  "0 12px 28px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(255, 255, 255, 0.5)",
                                minWidth: isMobile
                                  ? "320px"
                                  : isLMobile
                                    ? "480px"
                                    : "600px",
                                maxWidth: "1000px",
                                borderRadius: "8px",
                                minHeight: "300px",
                              }}
                            >
                              <VStack
                                flex={1}
                                minHeight={isMobile ? "600px" : "450px"}
                                maxHeight={"625px"}
                              >
                                <HStack
                                  alignItems={"center"}
                                  justifyContent={"space-between"}
                                  borderBottomColor={"AVColor.grey"}
                                  px={5}
                                  zIndex={99}
                                  marginTop={"10px"}
                                >
                                  <Text fontSize={24}>
                                    {Loc.currentLang.menu.editStaffMember}
                                  </Text>
                                  <HStack justifyContent={"flex-end"}>
                                    <AVCancel
                                      color={undefined}
                                      size={undefined}
                                      callback={() => setIsStaffEdit(false)}
                                    />
                                  </HStack>
                                </HStack>
                                <Pressable zIndex={-3}>
                                  <Box p={1} borderRadius={"full"}>
                                    <HStack space={2} px={2}>
                                      {Editstaffitem?.thumb ||
                                      Editstaffitem?.linkPic ? (
                                        <Box
                                          bgColor={"#FF6600"}
                                          borderRadius={["full"]}
                                          width={"70px"}
                                          height={"70px"}
                                          left={"1px"}
                                          p={0}
                                        >
                                          <Image
                                            source={{
                                              uri: Editstaffitem?.linkPic
                                                ? AV.Media.getURL(
                                                    Editstaffitem?.linkPic,
                                                  )
                                                : AV.Media.getThumb(
                                                    Editstaffitem,
                                                  ),
                                            }}
                                            borderRadius={["full"]}
                                            //top={ "2" }
                                            width={"100%"}
                                            height={["100%"]}
                                          />
                                          <Button
                                            bgColor={"AVColor.white"}
                                            position={"absolute"}
                                            top={"45px"}
                                            right={"-6px"}
                                            p={0}
                                            rounded={"full"}
                                            _hover={{
                                              backgroundColor:
                                                "AVColor.hovercolor",
                                            }}
                                            shadow={1}
                                            zIndex={99}
                                            isLoading={isPicLoader}
                                            _spinner={{
                                              color: "AVColor.black",
                                            }}
                                          >
                                            <Box
                                              {...getStaffProfilePicFile({
                                                className: "dropzone",
                                              })}
                                            >
                                              <input
                                                {...getStaffProfileInputProps()}
                                              />
                                              <AddPhotoIcon size={18} p={1} />
                                            </Box>
                                          </Button>
                                        </Box>
                                      ) : (
                                        <Box alignItems={"center"}>
                                          <Profile
                                            height={"70"}
                                            width={"70"}
                                            color={"#32AE78"}
                                          />

                                          <Button
                                            bgColor={"AVColor.white"}
                                            position={"absolute"}
                                            top={"45px"}
                                            right={"-6px"}
                                            p={0}
                                            rounded={"full"}
                                            _hover={{
                                              backgroundColor:
                                                "AVColor.hovercolor",
                                            }}
                                            shadow={1}
                                            zIndex={99}
                                            isLoading={isPicLoader}
                                            _spinner={{
                                              color: "AVColor.black",
                                            }}
                                          >
                                            <Box
                                              {...getStaffProfilePicFile({
                                                className: "dropzone",
                                              })}
                                            >
                                              <input
                                                {...getStaffProfileInputProps()}
                                              />
                                              <AddPhotoIcon size={18} p={1} />
                                            </Box>
                                          </Button>
                                        </Box>
                                      )}
                                      <Text
                                        marginTop={"20px"}
                                        left={"2px"}
                                        marginLeft={"35px"}
                                        alignItems="center"
                                        width="300px"
                                        numberOfLines={1}
                                        textAlign="center"
                                        zIndex={-3}
                                        fontSize={24}
                                      >
                                        {Editstaffitem?.title}
                                      </Text>
                                    </HStack>
                                  </Box>
                                </Pressable>
                                <HStack
                                  alignItems={"center"}
                                  display={"block"}
                                  borderBottomColor={"AVColor.grey"}
                                  px={5}
                                  py={5}
                                  zIndex={99}
                                >
                                  <VStack marginTop={"15px"}>
                                    <FormControl fullWidth>
                                      <InputLabel id="demo-simple-select-label">
                                        {Loc.currentLang.menu.assignRoleReq}
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={staffRole}
                                        label={
                                          Loc.currentLang.menu.assignRoleReq
                                        }
                                        onChange={handleStaffRole}
                                      >
                                        {leagueTeamFK?.roles?.map((option) => (
                                          <MenuItem
                                            key={option?.name}
                                            value={option?.name}
                                          >
                                            {option?.name}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </VStack>
                                  <VStack marginTop={"15px"}>
                                    <AVInputtext
                                      type={"text"}
                                      onChange={(e) =>
                                        setstaffphone(
                                          e.target.value.replace(/[^0-9]/g, ""),
                                        )
                                      }
                                      value={staffphone}
                                      label={Loc.currentLang.menu.phone}
                                      height={"15px"}
                                      width={isMobile ? "245px" : "200px"}
                                      maxLength={50}
                                      defaultValue={undefined}
                                      minRows={undefined}
                                      multiline={undefined}
                                      placeholder={undefined}
                                      size={undefined}
                                    />
                                  </VStack>
                                  <VStack marginTop={"15px"}>
                                    <AVInputtext
                                      type={"text"}
                                      onChange={(e) =>
                                        setstaffemail(e.target.value)
                                      }
                                      value={staffemail}
                                      label={
                                        Loc.currentLang.menu.emailAddressNotReq
                                      }
                                      height={"15px"}
                                      width={isMobile ? "245px" : "200px"}
                                      maxLength={50}
                                      defaultValue={undefined}
                                      minRows={undefined}
                                      multiline={undefined}
                                      placeholder={undefined}
                                      size={undefined}
                                    />
                                  </VStack>
                                </HStack>
                                <HStack
                                  width={"100%"}
                                  height="100%"
                                  space={5}
                                  flex={1}
                                  justifyContent={"center"}
                                  px={5}
                                  m={3}
                                  zIndex={-1}
                                >
                                  <Button
                                    rounded="full"
                                    backgroundColor={"#EEEEEE"}
                                    paddingX={"20px"}
                                    width={isMobile ? "40%" : "24%"}
                                    height={"40px"}
                                    onPress={() => {
                                      setIsStaffEdit(false);
                                    }}
                                  >
                                    <Text
                                      fontSize={"14px"}
                                      color={"rgba(0,0,0,0.5)"}
                                      fontWeight={"bold"}
                                    >
                                      {Loc.currentLang.menu.cancel}
                                    </Text>
                                  </Button>
                                  <Button
                                    rounded="full"
                                    backgroundColor={"#32AE78"}
                                    paddingX={"20px"}
                                    onPress={() => {
                                      handleEditStaff(Editstaffitem);
                                    }}
                                    isLoading={isLoading}
                                    isLoadingText={
                                      Loc.currentLang.menu.saveLoad
                                    }
                                    width={isMobile ? "40%" : "24%"}
                                    height={"40px"}
                                  >
                                    <Text fontSize={"14px"} color={"white"}>
                                      {Loc.currentLang.menu.save}
                                    </Text>
                                  </Button>
                                </HStack>
                                {error && (
                                  <HStack
                                    justifyContent={"center"}
                                    marginBottom={"10px"}
                                  >
                                    <Text color={"red.500"} fontWeight={400}>
                                      {error}
                                    </Text>
                                  </HStack>
                                )}
                              </VStack>
                            </div>
                          </Box>
                        )}
                      </>

                      //<AVCardList
                      //  tab={"Staff"}
                      //  isAdminView={isAdminView}
                      //  isCreate={isCreate}
                      //  setIsCreate={setIsCreate}
                      //  entity={leagueTeamFK}
                      //  setEntity={setLeagueTeamFK}
                      //  handleChat={handleChat}
                      //  createConvoKey={"S"}
                      //  handleGroupChat={HandleGroupChat}
                      //  handleRemoveGroup={HandleRemoveStaffs}
                      //  handleProfileType={handleProfileType}
                      ///>
                    )}

                    {/* huddles Page*/}
                    {isHuddlePage && !isShowEdit && (
                      <AVCardList
                        tab={"Huddles"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={leagueTeamFK}
                        setEntity={setLeagueTeamFK}
                      />
                    )}

                    {/* player page*/}
                    {isPlayerPage && !isShowEdit && (
                      <Box
                        width={"100%"}
                        minHeight={"340px"}
                        marginRight={4}
                        p={2}
                        h="auto"
                        shadow={1}
                        bgColor="#fff"
                        rounded="lg"
                      >
                        <VStack>
                          <HStack
                            alignItems={"center"}
                            justifyContent={"space-between"}
                          >
                            <Text
                              fontWeight={"500"}
                              marginLeft={"15px"}
                              fontSize={"22px"}
                              color={"AVColor.primary"}
                              py={"12px"}
                            >
                              {leagueTeamFK?.subType == "Class" ||
                              leagueTeamFK?.subType == "GradClass" ||
                              leagueTeamFK?.type == "SchoolYear"
                                ? Loc.currentLang.menu.students
                                : leagueTeamFK?.subType == "Term"
                                  ? Loc.currentLang.menu.members
                                  : Loc.currentLang.menu.players}
                            </Text>

                            <HStack alignItems="center" space="10px">
                              {playersList?.length > 0 && (
                                <Tooltip
                                  label={helptext}
                                  w={200}
                                  openDelay={100}
                                >
                                  <Box
                                    rounded="full"
                                    bg="gray.100"
                                    shadow={1}
                                    p="10px"
                                    minW="40px"
                                    h="40px"
                                  >
                                    <img
                                      src={helping}
                                      height="20px"
                                      width="20px"
                                    />
                                  </Box>
                                </Tooltip>
                              )}

                              {
                                //(isAdminView ||
                                // checkConvoExitorNot(
                                //   staffToPlayer ? "X" : "P",
                                // )) &&
                                !(
                                  leagueTeamFK?.type === "SchoolYear" &&
                                  isAdminView
                                ) &&
                                  playersList?.length > 0 && (
                                    <Offline>
                                      {({ isOffline }) => (
                                        <Button
                                          isDisabled={isOffline}
                                          rounded="full"
                                          bg={isLoad ? "#32AE78" : "gray.100"}
                                          _hover={{ bg: "AVColor.hovercolor" }}
                                          shadow={1}
                                          p="10px"
                                          minW="40px"
                                          h="40px"
                                          isLoading={isLoad}
                                          onPress={() => HandleGroupChat("P")}
                                        >
                                          <GroupChatIcon
                                            size={23}
                                            color="rgba(0,0,0,0.6)"
                                          />
                                        </Button>
                                      )}
                                    </Offline>
                                  )
                              }

                              {isAdminView && (
                                <Offline>
                                  {({ isOffline }) => (
                                    <div ref={addPlayerBtnRef}>
                                      <Button
                                        isDisabled={isOffline}
                                        rounded="full"
                                        bg="gray.100"
                                        _hover={{ bg: "AVColor.hovercolor" }}
                                        shadow={1}
                                        p="10px"
                                        minW="40px"
                                        h="40px"
                                        onPress={() =>
                                          handleProfileType("Player")
                                        }
                                      >
                                        <AddIcon size="20px" color="#32AE78" />
                                      </Button>
                                    </div>
                                  )}
                                </Offline>
                              )}
                            </HStack>
                          </HStack>
                        </VStack>
                        <Divider my={2} zIndex={-3} />

                        <HStack>
                          <FlatList
                            height={dimensions.height - 110}
                            width={"100%"}
                            data={playersList}
                            scrollEnabled={true}
                            ListEmptyComponent={
                              <HStack
                                width={"100%"}
                                top={isMobile ? "20px" : "0px"}
                                padding={isMobile ? "10px" : "10px"}
                                marginTop={isMobile ? "-10px" : "0px"}
                                space={isMobile ? 2 : 2}
                              >
                                <img
                                  src={inform}
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                  }}
                                />
                                <Text
                                  fontSize={"16px"}
                                  fontWeight="400"
                                  numberOfLines={4}
                                  ellipsizeMode={"tail"}
                                >
                                  {helptext}
                                </Text>
                              </HStack>
                            }
                            renderItem={(item: any) => (
                              <PlayersCard
                                leagueTeam={leagueTeamFK}
                                data={item}
                                {...props}
                                key={item.id}
                                item={item}
                                playersList={playersList}
                                setPlayersList={setPlayersList}
                                HandleRemoveplayers={HandleRemoveplayers}
                                isRotate={isRotate}
                                handleChat={handleChat}
                                isMemberTab={isMemberTab}
                                isAdminView={isAdminView}
                                handleConfirmToggleSilence={
                                  handleConfirmToggleSilence
                                }
                              />
                            )}
                            showsVerticalScrollIndicator={false}
                            numColumns={3}
                          />
                        </HStack>
                      </Box>
                    )}

                    {/* participant page*/}
                    {isparticipantspage &&
                      (!isShowEdit ||
                        isOngoingOrFuture ||
                        isEntireSeriesAvailable) && (
                        <Box
                          pb={5}
                          zIndex={isDropDown ? -3 : ""}
                          minHeight={"340px"}
                          borderRadius={5}
                          backgroundColor={"AVColor.white"}
                          overflow={"hidden"}
                          shadow={1}
                          width={"100%"}
                        >
                          <HStack justifyContent={"space-between"}>
                            <Text
                              fontWeight={"500"}
                              marginLeft={"15px"}
                              fontSize={"22px"}
                              color={"AVColor.primary"}
                              py={"12px"}
                              width={"150px"}
                            >
                              {Loc.currentLang.menu.participants}
                            </Text>

                            {/* RIGHT SIDE ACTIONS */}
                            <HStack
                              alignItems="center"
                              space={3}
                              left={
                                isShowEditOccurence || isShowEditEntireSeries
                                  ? "0px"
                                  : "-10px"
                              }
                            >
                              {/* HELP ICON */}
                              {participantList?.length > 0 && (
                                <Tooltip
                                  label={
                                    Loc.currentLang.helpText.event
                                      .participantTab
                                  }
                                  w={200}
                                  openDelay={500}
                                >
                                  <Box
                                    p="9px"
                                    shadow={1}
                                    bg="gray.100"
                                    rounded="full"
                                  >
                                    <img
                                      src={helping}
                                      height="17px"
                                      width="17px"
                                    />
                                  </Box>
                                </Tooltip>
                              )}

                              {/* GROUP CHAT ICON */}
                              {
                                // Ongoing or Future, participants must exist
                                ((isOngoingOrFuture &&
                                  participantList?.length > 0) ||
                                  // Past Event, only if convo exists
                                  (!isOngoingOrFuture &&
                                    checkConvoExitorNot("N"))) && (
                                  <Offline>
                                    {({ isOffline }) => (
                                      <Button
                                        isDisabled={isOffline}
                                        p="8px"
                                        rounded="full"
                                        shadow={1}
                                        bg={isLoad ? "#32AE78" : "gray.100"}
                                        _hover={{ bg: "gray.50" }}
                                        isLoading={isLoad}
                                        onPress={() => HandleGroupChat("N")}
                                      >
                                        <GroupChatIcon
                                          size={23}
                                          color="rgba(0,0,0,0.5)"
                                        />
                                      </Button>
                                    )}
                                  </Offline>
                                )
                              }

                              {/* ADD BUTTON */}
                              {(isOngoingOrFuture || isEntireSeriesAvailable) &&
                                isAdminView && (
                                  <Offline>
                                    {({ isOffline }) => (
                                      <Pressable
                                        isDisabled={isOffline}
                                        p={2}
                                        rounded="full"
                                        bg="gray.100"
                                        _hover={{ bg: "gray.50" }}
                                        shadow={1}
                                        onPress={() => {
                                          if (
                                            leagueTeamFK?.seriesEvents?.length >
                                              1 &&
                                            params?.seriesId
                                          ) {
                                            setIsShowEditOccurence(
                                              isOngoingOrFuture,
                                            );
                                            setIsShowEditEntireSeries(
                                              isOngoingOrFuture ||
                                                isEntireSeriesAvailable,
                                            );
                                          } else {
                                            handleProfileType("Participant");
                                          }
                                        }}
                                      >
                                        <AddIcon color="#32AE78" size="20px" />
                                      </Pressable>
                                    )}
                                  </Offline>
                                )}

                              {(isShowEditOccurence ||
                                isShowEditEntireSeries) &&
                                seriesId && (
                                  <VStack
                                    ref={menuRefs}
                                    width={"125px"}
                                    height="auto"
                                    right={"10px"}
                                    shadow={2}
                                    background={"#FFFFFF"}
                                    position={"absolute"}
                                    top={"52px"}
                                    zIndex={999}
                                    borderRadius={"6px"}
                                  >
                                    {isShowEditOccurence && (
                                      <Pressable
                                        ref={menuRefs}
                                        width={"100%"}
                                        height={"36px"}
                                        paddingX={"10px"}
                                        alignItems={"flex-start"}
                                        justifyContent={"center"}
                                        onPress={() => {
                                          setIsOpen(false);
                                          setIsEditEntireSeries(false);
                                          setIsShowEditOccurence(false);
                                          setIsShowEditEntireSeries(false);
                                          handleProfileType("Participant");
                                        }}
                                        _hover={{
                                          backgroundColor: "gray.100",
                                        }}
                                      >
                                        <Text
                                          fontSize={"14px"}
                                          fontFamily={"Roboto"}
                                        >
                                          {Loc.currentLang.menu.thisOccurrence}
                                        </Text>
                                      </Pressable>
                                    )}

                                    {isShowEditOccurence && <Divider />}

                                    {isShowEditEntireSeries && (
                                      <Pressable
                                        ref={menuRefs}
                                        width={"100%"}
                                        height={"36px"}
                                        paddingX={"10px"}
                                        alignItems={"flex-start"}
                                        justifyContent={"center"}
                                        onPress={() => {
                                          setIsOpen(false);
                                          setIsEditEntireSeries(true);
                                          setIsShowEditOccurence(false);
                                          setIsShowEditEntireSeries(false);
                                          handleProfileType("Participant");
                                        }}
                                        _hover={{
                                          backgroundColor: "gray.100",
                                        }}
                                      >
                                        <Text
                                          fontSize={"14px"}
                                          fontFamily={"Roboto"}
                                        >
                                          {Loc.currentLang.menu.entireSeries}
                                        </Text>
                                      </Pressable>
                                    )}
                                  </VStack>
                                )}
                            </HStack>
                          </HStack>
                          <Divider my={2} zIndex={-3} />

                          <VStack p={1} zIndex={-3}>
                            <div className="custom-scrollbar">
                              <HStack
                                marginY={"24px"}
                                overflowY={isMobile ? "auto" : undefined}
                                backgroundColor={"rgba(0,0,0,0.05)"}
                                borderRadius={"18px"}
                                marginLeft={"24px"}
                                height={"36px"}
                                width={isMobile ? "" : "500px"}
                              >
                                <PariticipantFilter
                                  statusKey="All"
                                  Type={status}
                                  SetType={setAllStatus}
                                  Name={Loc.currentLang.menu.all}
                                  length={participantList?.length}
                                />
                                <PariticipantFilter
                                  statusKey="RSVP"
                                  Type={status}
                                  SetType={setRsvpStatus}
                                  Name={Loc.currentLang.menu.rsvp}
                                  length={
                                    participantList?.filter(
                                      (x) => x?.status === undefined,
                                    )?.length
                                  }
                                />
                                <PariticipantFilter
                                  statusKey="Yes"
                                  Type={status}
                                  SetType={setYesStatus}
                                  Name={Loc.currentLang.menu.yes}
                                  length={
                                    participantList?.filter(
                                      (x) => x.status === "Yes",
                                    )?.length
                                  }
                                />
                                <PariticipantFilter
                                  statusKey="No"
                                  Type={status}
                                  SetType={setNoStatus}
                                  Name={Loc.currentLang.menu.no}
                                  length={
                                    participantList?.filter(
                                      (x) => x.status === "No",
                                    )?.length
                                  }
                                />
                                <PariticipantFilter
                                  statusKey="Maybe"
                                  Type={status}
                                  SetType={setMaybeStatus}
                                  Name={Loc.currentLang.menu.maybe}
                                  length={
                                    participantList?.filter(
                                      (x) => x.status === "Maybe",
                                    )?.length
                                  }
                                />
                              </HStack>
                            </div>

                            {filteredParticipantList?.length > 0 ? (
                              <HStack
                                alignItems="center"
                                px={5}
                                flexWrap="nowrap"
                                space={2}
                              >
                                <HStack
                                  flexWrap="wrap"
                                  maxWidth="100%"
                                  alignSelf="flex-start"
                                >
                                  {filteredParticipantList.map((item, i) => (
                                    <ParticipantsCard
                                      key={i}
                                      index={i}
                                      item={item}
                                      status={status}
                                      editAccess={isOngoingOrFuture}
                                      isAdminView={isAdminView}
                                      setisConfirmDelete={setisConfirmDelete}
                                      setConfirmationtext={setConfirmationtext}
                                      setItemSelect={setItemSelect}
                                      setselectType={setselectType}
                                      filteredParticipantList={
                                        filteredParticipantList
                                      }
                                      setIsOpenConvo={setIsOpenConvo}
                                      isRotate={isRotate}
                                      setIsRotate={setIsRotate}
                                      isMemberTab={isMemberTab}
                                      handleChat={handleChat}
                                    />
                                  ))}
                                </HStack>
                              </HStack>
                            ) : (
                              <VStack paddingX={"15px"} space={3}>
                                <HStack
                                  width={"100%"}
                                  top={isMobile ? "20px" : "0px"}
                                  padding={isMobile ? "10px" : "10px"}
                                  marginTop={isMobile ? "-10px" : "0px"}
                                  space={2}
                                >
                                  <img
                                    src={inform}
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                  <Text
                                    fontSize={"16px"}
                                    fontWeight="400"
                                    numberOfLines={4}
                                    ellipsizeMode={"tail"}
                                  >
                                    {
                                      Loc.currentLang.helpText.event
                                        .participantTab
                                    }
                                  </Text>
                                </HStack>
                              </VStack>
                            )}
                          </VStack>
                        </Box>
                      )}

                    {/* resource page*/}
                    {isResourses &&
                      (!isShowEdit ||
                        isOngoingOrFuture ||
                        isEntireSeriesAvailable) && (
                        <Box
                          pb={5}
                          zIndex={isDropDown ? -3 : ""}
                          minHeight={"340px"}
                          borderRadius={5}
                          backgroundColor={"AVColor.white"}
                          overflow={"hidden"}
                          shadow={1}
                        >
                          <HStack>
                            <Text
                              fontWeight={"500"}
                              marginLeft={"15px"}
                              fontSize={"22px"}
                              color={"AVColor.primary"}
                              py={"12px"}
                              width={"150px"}
                            >
                              {Loc.currentLang.menu.resources}
                            </Text>

                            {(isOngoingOrFuture || isEntireSeriesAvailable) &&
                              isAdminView && (
                                <Offline>
                                  {({ isOffline }) => (
                                    <Pressable
                                      isDisabled={isOffline}
                                      position={"absolute"}
                                      right={"5px"}
                                      top={"5px"}
                                      p={[1, 2]}
                                      rounded={"full"}
                                      bgColor={"gray.100"}
                                      _hover={{ bgColor: "gray.50" }}
                                      shadow={1}
                                      onPress={() => {
                                        if (
                                          leagueTeamFK?.seriesEvents?.length >
                                            1 &&
                                          params?.seriesId
                                        ) {
                                          setIsShowEditOccurence(
                                            isOngoingOrFuture,
                                          );
                                          setIsShowEditEntireSeries(
                                            isOngoingOrFuture ||
                                              isEntireSeriesAvailable,
                                          );
                                        } else {
                                          handleAddResourcePopup();
                                        }
                                      }}
                                    >
                                      <AddIcon
                                        color={"#32AE78"}
                                        size={"20px"}
                                      />
                                    </Pressable>
                                  )}
                                </Offline>
                              )}

                            {(isShowEditOccurence ||
                              isShowEditEntireSeries) && (
                              <VStack
                                ref={menuRefs}
                                width={"125px"}
                                height="auto"
                                left={"500px"}
                                shadow={2}
                                background={"#FFFFFF"}
                                position={"relative"}
                                top={"30px"}
                                zIndex={999}
                                borderRadius={"6px"}
                              >
                                {isShowEditOccurence && (
                                  <Pressable
                                    ref={menuRefs}
                                    width={"100%"}
                                    height={"36px"}
                                    paddingX={"10px"}
                                    alignItems={"flex-start"}
                                    justifyContent={"center"}
                                    onPress={() => {
                                      setIsOpen(false);
                                      setIsEditEntireSeries(false);
                                      setIsShowEditOccurence(false);
                                      setIsShowEditEntireSeries(false);
                                      handleAddResourcePopup();
                                    }}
                                    _hover={{
                                      backgroundColor: "gray.100",
                                    }}
                                  >
                                    <Text
                                      fontSize={"14px"}
                                      fontFamily={"Roboto"}
                                    >
                                      {Loc.currentLang.menu.thisOccurrence}
                                    </Text>
                                  </Pressable>
                                )}

                                {isShowEditOccurence && <Divider />}

                                {isShowEditEntireSeries && (
                                  <Pressable
                                    ref={menuRefs}
                                    width={"100%"}
                                    height={"36px"}
                                    paddingX={"10px"}
                                    alignItems={"flex-start"}
                                    justifyContent={"center"}
                                    onPress={() => {
                                      setIsOpen(false);
                                      setIsEditEntireSeries(true);
                                      setIsShowEditOccurence(false);
                                      setIsShowEditEntireSeries(false);
                                      handleAddResourcePopup();
                                    }}
                                    _hover={{
                                      backgroundColor: "gray.100",
                                    }}
                                  >
                                    <Text
                                      fontSize={"14px"}
                                      fontFamily={"Roboto"}
                                    >
                                      {Loc.currentLang.menu.entireSeries}
                                    </Text>
                                  </Pressable>
                                )}
                              </VStack>
                            )}
                          </HStack>
                          <Divider my={2} zIndex={-3} />

                          {resoursesList?.length > 0 && (
                            <ScrollView
                              style={{ maxHeight: 300 }}
                              showsVerticalScrollIndicator={true}
                            >
                              <VStack paddingX={"15px"}>
                                {resoursesList?.length > 0 &&
                                  resoursesList?.map(
                                    (item: any, index: number) => (
                                      <HStack
                                        key={item?.id || index}
                                        alignItems={"center"}
                                        p={2}
                                        backgroundColor={"#F5F5F5"}
                                        borderStyle={"solid"}
                                        borderColor={"rgba(0, 0, 0, 0.05)"}
                                        borderRadius={"5px"}
                                        width={"98%"}
                                        height={"36px"}
                                        marginTop={"12px"}
                                      >
                                        <HStack width={"40%"}>
                                          <Tooltip
                                            label={item?.resource}
                                            openDelay={500}
                                          >
                                            <Text
                                              fontWeight="500"
                                              numberOfLines={1}
                                              text-overflow={"ellipsis"}
                                              fontSize={"16px"}
                                              textAlign={"left"}
                                              color={"#000000"}
                                              textTransform={"capitalize"}
                                            >
                                              {item?.resource}
                                            </Text>
                                          </Tooltip>
                                        </HStack>
                                        <HStack width={"10%"}>
                                          <Tooltip
                                            label={item?.quantity}
                                            openDelay={500}
                                          >
                                            <Text
                                              fontSize={"16px"}
                                              numberOfLines={1}
                                              text-overflow={"ellipsis"}
                                              textAlign={"left"}
                                              fontWeight={"medium"}
                                              paddingLeft={"2px"}
                                              color={"#000000"}
                                            >
                                              {item?.quantity}
                                            </Text>
                                          </Tooltip>
                                        </HStack>
                                        <HStack></HStack>

                                        {participantList?.filter(
                                          (x) => x?.id === item?.id,
                                        )?.length > 0 ? (
                                          <HStack width={"40%"}>
                                            <HStack
                                              textAlign={"left"}
                                              paddingLeft={"15px"}
                                            >
                                              <Pressable
                                                onPress={() =>
                                                  navigate(
                                                    `/profile/${item?.id}/${item?.region}`,
                                                    {
                                                      state: { user: item },
                                                    },
                                                  )
                                                }
                                              >
                                                <EntityProfilePic
                                                  width={30}
                                                  height={30}
                                                  link={
                                                    entitydatalist?.filter(
                                                      (x: any) =>
                                                        x?.id == item?.id,
                                                    )?.length > 0
                                                      ? AV.AVEntity.getLink(
                                                          entitydatalist?.find(
                                                            (x: any) =>
                                                              x?.id == item?.id,
                                                          ),
                                                        )
                                                      : participantList?.filter(
                                                          (x) =>
                                                            x?.id === item?.id,
                                                        )[0]
                                                  }
                                                />
                                              </Pressable>
                                              {participantList?.filter(
                                                (x) => x?.id === item?.id,
                                              )[0]?.id !== currentUser?.id ? (
                                                <Pressable
                                                  onPress={() =>
                                                    navigate(
                                                      `/profile/${item?.id}/${item?.region}`,
                                                      {
                                                        state: { user: item },
                                                      },
                                                    )
                                                  }
                                                >
                                                  <Text
                                                    textAlign={"left"}
                                                    marginTop={"3px"}
                                                    paddingLeft={"6px"}
                                                    textTransform={"capitalize"}
                                                    numberOfLines={1}
                                                    text-overflow={"ellipsis"}
                                                  >
                                                    {
                                                      participantList?.filter(
                                                        (x) =>
                                                          x?.id === item?.id,
                                                      )[0]?.title
                                                    }
                                                  </Text>
                                                </Pressable>
                                              ) : (
                                                <Pressable
                                                  onPress={() =>
                                                    navigate(
                                                      `/profile/${item?.id}/${item?.region}`,
                                                      {
                                                        state: { user: item },
                                                      },
                                                    )
                                                  }
                                                >
                                                  <Text
                                                    textAlign={"left"}
                                                    marginTop={"3px"}
                                                    paddingLeft={"6px"}
                                                    textTransform={"capitalize"}
                                                  >
                                                    {"You"}
                                                  </Text>
                                                </Pressable>
                                              )}
                                            </HStack>
                                          </HStack>
                                        ) : (
                                          <HStack width={"40%"}>
                                            <Text
                                              numberOfLines={1}
                                              text-overflow={"ellipsis"}
                                              paddingLeft={"2px"}
                                              textTransform={"capitalize"}
                                            ></Text>
                                          </HStack>
                                        )}
                                        <HStack space={"15px"}>
                                          {isAdminView && isOngoingOrFuture && (
                                            <Pressable
                                              onPress={() =>
                                                handleEditProfileType(item)
                                              }
                                            >
                                              <EditIcon size={"20px"} />
                                            </Pressable>
                                          )}
                                          {isAdminView && isOngoingOrFuture && (
                                            <Pressable
                                              onPress={() =>
                                                handleRemoveResourcePopup(item)
                                              }
                                            >
                                              <DeleteIcon size={"20px"} />
                                            </Pressable>
                                          )}
                                          {(!isAdminView ||
                                            !isOngoingOrFuture) && (
                                            <Pressable
                                              onPress={() =>
                                                handleShowResourcePopup(item)
                                              }
                                            >
                                              <ViewIcon size={"20px"} />
                                            </Pressable>
                                          )}
                                        </HStack>
                                      </HStack>
                                    ),
                                  )}
                              </VStack>
                            </ScrollView>
                          )}

                          <VStack paddingX={"15px"} space={3}>
                            {resoursesList?.length < 1 && (
                              <HStack
                                width={"100%"}
                                top={isMobile ? "20px" : "0px"}
                                padding={isMobile ? "10px" : "10px"}
                                marginTop={isMobile ? "-10px" : "0px"}
                                space={isMobile ? 2 : 2}
                              >
                                <img
                                  src={inform}
                                  style={{ width: "20px", height: "20px" }}
                                />
                                <Text
                                  fontSize={"16px"}
                                  fontWeight="400"
                                  numberOfLines={4}
                                  ellipsizeMode={"tail"}
                                >
                                  {Loc.currentLang.helpText.event.resourcesTab}
                                </Text>
                              </HStack>
                            )}
                          </VStack>
                        </Box>
                      )}

                    {/* group page*/}
                    {isGroup && !isShowEdit && (
                      <>
                        <Box
                          minHeight={"340px"}
                          borderRadius={5}
                          backgroundColor={"AVColor.white"}
                          shadow={1}
                          flex={1}
                          mb={3}
                        >
                          <VStack>
                            <HStack
                              alignItems={"center"}
                              justifyContent={"space-between"}
                            >
                              <Text
                                fontWeight={"500"}
                                marginLeft={"15px"}
                                fontSize={"22px"}
                                color={"AVColor.primary"}
                                py={"12px"}
                              >
                                {Loc.currentLang.menu.organization}
                              </Text>

                              <HStack alignItems={"center"} pr={2}>
                                <HStack space={3}>
                                  <Tooltip
                                    label={helptext}
                                    w={200}
                                    openDelay={500}
                                  >
                                    <Box
                                      marginTop={"5px"}
                                      height={"36px"}
                                      marginRight={"10px"}
                                      p={"9px"}
                                      display={
                                        GroupList?.length > 0 ? "" : "none"
                                      }
                                      shadow={1}
                                      backgroundColor={"AVColor.liteBg"}
                                      rounded={"full"}
                                    >
                                      <img
                                        src={helping}
                                        height={"17px"}
                                        width={"17px"}
                                      />
                                    </Box>
                                  </Tooltip>

                                  {isAdminView ? (
                                    leagueTeamFK?.subType === "Department" ||
                                    leagueTeamFK?.subType === "GradClass" ? (
                                      <AVComDropdonwn
                                        dropdownValues={
                                          leagueTeamFK?.subType === "Department"
                                            ? dropdownSchlDeptValues
                                            : dropdownComEventValues
                                        }
                                      />
                                    ) : (
                                      <Offline>
                                        {({ isOffline }) => (
                                          <Button
                                            isDisabled={isOffline}
                                            p={"10px"}
                                            shadow={1}
                                            bgColor={"gray.100"}
                                            _hover={{ bgColor: "gray.50" }}
                                            rounded={"full"}
                                            marginRight={"3px"}
                                            onPress={() => HandleCreateGroup()}
                                          >
                                            <AddIcon
                                              size={"20px"}
                                              color={"#32AE78"}
                                            />
                                          </Button>
                                        )}
                                      </Offline>
                                    )
                                  ) : null}

                                  {isAdminView && (
                                    <VStack
                                      height={"40px"}
                                      width={"40px"}
                                      ref={menuRefs}
                                    >
                                      <Pressable
                                        p={"10px"}
                                        shadow={1}
                                        bgColor={"gray.100"}
                                        _hover={{ bgColor: "gray.50" }}
                                        rounded={"full"}
                                        marginRight={"3px"}
                                        height={"36px"}
                                        top={"4px"}
                                        onPress={() => setOrgOpen(!isOrgOpen)}
                                      >
                                        <MoreHorizontalIcon
                                          height={"4px"}
                                          width={"16px"}
                                          size={"md"}
                                          color={"#000000"}
                                          style={{
                                            transform: [{ rotate: "90deg" }],
                                          }}
                                        />
                                      </Pressable>
                                      {isOrgOpen && (
                                        <Pressable
                                          backgroundColor={"gray.100"}
                                          shadow={9}
                                          width={"100px"}
                                          height={"40px"}
                                          padding={"10px"}
                                          position={"absolute"}
                                          _hover={{ bgColor: "gray.50" }}
                                          top={"47px"}
                                          right={"25px"}
                                          onPress={() =>
                                            handleProfileType("Group")
                                          }
                                        >
                                          <Text
                                            color={"black"}
                                            textAlign={"center"}
                                          >
                                            {Loc.currentLang.menu.add}
                                          </Text>
                                        </Pressable>
                                      )}
                                    </VStack>
                                  )}
                                </HStack>
                                <Pressable
                                  onPress={() => {
                                    //handleEditPopup();
                                    //setShowEditPopup(!showEditPopup);
                                  }}
                                ></Pressable>
                                {/*{showEditPopup && (*/}
                                {/*  <Box*/}
                                {/*    position={"absolute"}*/}
                                {/*    right={0}*/}
                                {/*    top={"43px"}*/}
                                {/*    background={"#f2f2f2"}*/}
                                {/*    borderRadius={"5px"}*/}
                                {/*    height="40px"*/}
                                {/*    width="150px"*/}
                                {/*  >*/}
                                {/*<Pressable*/}
                                {/*    onPress={handleRole}*/}
                                {/*    top='5px'*/}
                                {/*>*/}
                                {/*    <Text margin={'5px'} alignSelf='center'>*/}
                                {/*        {Loc.currentLang.menu.manageRoles}*/}
                                {/*    </Text>*/}
                                {/*</Pressable>*/}
                                {/*  </Box>*/}
                                {/*)}*/}
                              </HStack>
                            </HStack>
                          </VStack>
                          <Divider my={2} zIndex={-3} />

                          <HStack
                            flexWrap={"wrap"}
                            alignSelf={"flex-start"}
                            space={3}
                            p={2}
                            zIndex={-3}
                          >
                            {GroupList?.length > 0 &&
                              GroupList?.map((item) => (
                                <GroupListItem
                                  key={item.id}
                                  item={item}
                                  isAdminView={isAdminView}
                                  handleRemoveGroup={handleRemoveGroup}
                                  navigate={navigate}
                                />
                              ))}
                          </HStack>

                          {(GroupList?.length == 0 ||
                            GroupList?.length == undefined) && (
                            <HStack
                              zIndex={-3}
                              width={"100%"}
                              top={isMobile ? "20px" : "0px"}
                              padding={isMobile ? "10px" : "10px"}
                              marginTop={isMobile ? "-10px" : "0px"}
                              space={isMobile ? 2 : 1}
                              marginLeft={isMobile ? "3px" : "5px"}
                            >
                              <img
                                src={inform}
                                style={{
                                  width: "20px",
                                  height: "20px",
                                }}
                              />
                              <Text
                                fontSize={"16px"}
                                fontWeight="400"
                                numberOfLines={4}
                                ellipsizeMode={"tail"}
                              >
                                {helptext}
                              </Text>
                            </HStack>
                          )}
                        </Box>
                      </>

                      //<AVCardList
                      //  tab={"Organization"}
                      //  isAdminView={isAdminView}
                      //  isCreate={isCreate}
                      //  setIsCreate={setIsCreate}
                      //  entity={leagueTeamFK}
                      //  setEntity={setLeagueTeamFK}
                      //  menuRefs={menuRefs}
                      //  handleCreateOrg={handleCreateOrg}
                      //  handleProfileType={handleProfileType}
                      ///>
                    )}

                    {/* organization page*/}
                    {isOrganization && !isShowEdit && (
                      <>
                        <Box
                          minHeight={"340px"}
                          borderRadius={5}
                          backgroundColor={"AVColor.white"}
                          shadow={1}
                          flex={1}
                          mb={3}
                        >
                          <VStack>
                            <HStack
                              alignItems={"center"}
                              justifyContent={"space-between"}
                            >
                              <Text
                                fontWeight={"500"}
                                marginLeft={"15px"}
                                fontSize={"22px"}
                                color={"AVColor.primary"}
                                py={"12px"}
                              >
                                {leagueTeamFK?.type === "Club"
                                  ? Loc.currentLang.menu.teams
                                  : Loc.currentLang.menu.organization}
                              </Text>

                              <HStack alignItems={"center"} pr={2}>
                                <HStack zIndex={-3} space={3}>
                                  <Tooltip
                                    label={helptext}
                                    openDelay={500}
                                    w={200}
                                  >
                                    <Box
                                      marginRight={"10px"}
                                      p={"9px"}
                                      display={
                                        orgList?.length > 0 ||
                                        schoolYearOrgList?.length > 0
                                          ? ""
                                          : "none"
                                      }
                                      shadow={1}
                                      backgroundColor={"AVColor.liteBg"}
                                      rounded={"full"}
                                    >
                                      <img
                                        src={helping}
                                        height={"17px"}
                                        width={"17px"}
                                      />
                                    </Box>
                                  </Tooltip>
                                  {isAdminView && (
                                    <AVComDropdonwn
                                      dropdownValues={
                                        leagueTeamFK?.type === "SchoolYear"
                                          ? dropdownSchlYearsOrgValues
                                          : dropdownComOrgValues
                                      }
                                    />
                                  )}
                                  {isAdminView && (
                                    <VStack
                                      height={"40px"}
                                      width={"40px"}
                                      ref={menuRefs}
                                    >
                                      <Pressable
                                        p={"10px"}
                                        shadow={1}
                                        bgColor={"gray.100"}
                                        _hover={{ bgColor: "gray.50" }}
                                        rounded={"full"}
                                        marginRight={"3px"}
                                        height={"36px"}
                                        top={"4px"}
                                        onPress={() =>
                                          leagueTeamFK?.type === "SchoolYear"
                                            ? setIsSchoolYearsOrgTabOption(
                                                !isSchoolYearsOrgTabOption,
                                              )
                                            : setOrgOpen(!isOrgOpen)
                                        }
                                      >
                                        <MoreHorizontalIcon
                                          height={"4px"}
                                          width={"16px"}
                                          size={"md"}
                                          color={"#000000"}
                                          style={{
                                            transform: [{ rotate: "90deg" }],
                                          }}
                                        />
                                      </Pressable>

                                      {(isOrgOpen ||
                                        isSchoolYearsOrgTabOption) && (
                                        <Button
                                          backgroundColor={"gray.100"}
                                          shadow={9}
                                          width={"100px"}
                                          position={"absolute"}
                                          top={"47px"}
                                          right={"25px"}
                                          onPress={() =>
                                            handleProfileType("Organization")
                                          }
                                        >
                                          <Text color={"black"}>
                                            {Loc.currentLang.menu.add}
                                          </Text>
                                        </Button>
                                      )}
                                    </VStack>
                                  )}
                                </HStack>
                              </HStack>
                            </HStack>
                          </VStack>
                          <Divider my={2} zIndex={-3} />

                          <HStack
                            flexWrap={"wrap"}
                            zIndex={-3}
                            alignSelf={"flex-start"}
                            space={3}
                            p={2}
                          >
                            {[
                              ...new Map(
                                (isOrganization && orgList?.length > 0
                                  ? orgList
                                  : isSchoolYearOrgPage
                                    ? schoolYearOrgList
                                    : []
                                ).map((item) => [item.id, item]),
                              ).values(),
                            ].map((item: any) => (
                              <Box
                                key={item.id}
                                zIndex={-3}
                                bgColor={"#fff"}
                                borderWidth={"1px"}
                                borderColor={"AVColor.hovercolor2"}
                                minWidth={130}
                                minHeight={150}
                                borderRadius={5}
                                m={2}
                                shadow={1}
                              >
                                {isAdminView && (
                                  <Pressable
                                    key={item.id}
                                    padding={1.5}
                                    rounded={"full"}
                                    position={"absolute"}
                                    right={-10}
                                    top={-10}
                                    zIndex={999}
                                    _hover={{
                                      backgroundColor: "AVColor.hovercolor2",
                                    }}
                                    backgroundColor={"AVColor.buttonBg"}
                                    onPress={() =>
                                      isSchoolYearOrgPage
                                        ? HandleConfirmRemoveSchoolOrgs(
                                            "RemoveSchoolSeason",
                                            item,
                                          )
                                        : handleRemove("Season", item)
                                    }
                                  >
                                    <CloseIcon
                                      size={"12px"}
                                      color={"AVColor.secondaryText"}
                                    />
                                  </Pressable>
                                )}
                                <VStack
                                  alignItems={"center"}
                                  height={"100%"}
                                  width={"100%"}
                                >
                                  <Pressable
                                    key={item.id}
                                    height={"100%"}
                                    justifyContent={"center"}
                                    width={"100%"}
                                    _hover={{ bgColor: "#EEEEEE" }}
                                    onPress={() => {
                                      item?.type == "Person"
                                        ? navigate(
                                            `/profile/${item?.id}/${item?.region}`,
                                            {
                                              state: {
                                                user: {
                                                  id: item?.id,
                                                  pk: item?.pk,
                                                  region: item?.region,
                                                  type: item?.type,
                                                  name: item?.title,
                                                },
                                              },
                                            },
                                          )
                                        : item?.type == "PlayerOrg"
                                          ? navigate(
                                              `/season/${item?.id}/${item?.region}`,
                                              {
                                                state: {
                                                  isCreate: false,
                                                  team: item,
                                                },
                                              },
                                            )
                                          : item?.type == "Group"
                                            ? navigate(
                                                `/teams/${item?.id}/${item?.region}`,
                                                {
                                                  state: {
                                                    isCreate: false,
                                                    team: item,
                                                  },
                                                },
                                              )
                                            : item?.type == "Team"
                                              ? navigate(
                                                  `/teams/${item?.id}/${item?.region}`,
                                                  {
                                                    state: {
                                                      isCreate: false,
                                                      team: item,
                                                    },
                                                  },
                                                )
                                              : navigate(
                                                  `/teams/${item?.id}/${item?.region}`,
                                                  {
                                                    state: {
                                                      isCreate: false,
                                                      team: item,
                                                    },
                                                  },
                                                );
                                      setIsOrganization(false);
                                    }}
                                  >
                                    {item?.thumb && (
                                      <Box
                                        bgColor={"#FF6600"}
                                        borderRadius={["full"]}
                                        width={"70px"}
                                        height={"70px"}
                                        alignSelf={"center"}
                                        p={0}
                                      >
                                        <Image
                                          source={{
                                            uri: AV.Media.getThumb(item),
                                          }}
                                          borderRadius={["full"]}
                                          //top={ "2" }
                                          width={"100%"}
                                          height={["100%"]}
                                        />
                                      </Box>
                                    )}
                                    {!item?.thumb && (
                                      <Box alignItems={"center"}>
                                        <EntityProfilePic
                                          height={"70"}
                                          width={"70"}
                                          link={item}
                                        />
                                      </Box>
                                    )}
                                    <Tooltip label={item.title} openDelay={500}>
                                      <Pressable
                                        onPress={() => {
                                          item?.type == "Person"
                                            ? navigate(
                                                `/profile/${item?.id}/${item?.region}`,
                                                {
                                                  state: {
                                                    user: {
                                                      id: item?.id,
                                                      pk: item?.pk,
                                                      region: item?.region,
                                                      type: item?.type,
                                                      name: item?.title,
                                                    },
                                                  },
                                                },
                                              )
                                            : item?.type == "PlayerOrg"
                                              ? navigate(
                                                  `/season/${item?.id}/${item?.region}`,
                                                  {
                                                    state: {
                                                      isCreate: false,
                                                      team: item,
                                                    },
                                                  },
                                                )
                                              : item?.type == "Group"
                                                ? navigate(
                                                    `/teams/${item?.id}/${item?.region}`,
                                                    {
                                                      state: {
                                                        isCreate: false,
                                                        team: item,
                                                      },
                                                    },
                                                  )
                                                : item?.type == "Team"
                                                  ? navigate(
                                                      `/teams/${item?.id}/${item?.region}`,
                                                      {
                                                        state: {
                                                          isCreate: false,
                                                          team: item,
                                                        },
                                                      },
                                                    )
                                                  : navigate(
                                                      `/teams/${item?.id}/${item?.region}`,
                                                      {
                                                        state: {
                                                          isCreate: false,
                                                          team: item,
                                                        },
                                                      },
                                                    );
                                          setIsOrganization(false);
                                        }}
                                      >
                                        <Text
                                          marginTop={2}
                                          left={"2px"}
                                          alignItems="center"
                                          width="120px"
                                          numberOfLines={2}
                                          textAlign="center"
                                        >
                                          {item.title}
                                        </Text>
                                      </Pressable>
                                    </Tooltip>
                                  </Pressable>
                                </VStack>
                              </Box>
                            ))}
                          </HStack>

                          {(!isSchoolYearOrgPage
                            ? !orgList || orgList.length === 0
                            : !schoolYearOrgList ||
                              schoolYearOrgList.length === 0) && (
                            <HStack
                              zIndex={-3}
                              width="100%"
                              top={isMobile ? "20px" : "0px"}
                              padding="10px"
                              marginTop={isMobile ? "-10px" : "0px"}
                              space={2}
                            >
                              <img
                                src={inform}
                                alt="info"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                }}
                              />
                              <Text
                                fontSize={"16px"}
                                fontWeight="400"
                                numberOfLines={4}
                                ellipsizeMode={"tail"}
                              >
                                {helptext}
                              </Text>
                            </HStack>
                          )}
                        </Box>
                      </>

                      //<AVCardList
                      //  tab={"Organization"}
                      //  isAdminView={isAdminView}
                      //  isCreate={isCreate}
                      //  setIsCreate={setIsCreate}
                      //  entity={leagueTeamFK}
                      //  setEntity={setLeagueTeamFK}
                      //  menuRefs={menuRefs}
                      //  handleCreateOrg={handleCreateOrg}
                      //  handleCreateSchoolChilds={HandleCreateSchoolChilds}
                      //  handleProfileType={handleProfileType}
                      //  handleRemove={handleRemove}
                      //  handleConfirmRemoveSchoolOrgs={HandleConfirmRemoveSchoolOrgs}
                      ///>
                    )}

                    {/* School Teams page*/}
                    {isSchoolTeamsPage && !isShowEdit && (
                      <AVCardList
                        tab={"Organization"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={leagueTeamFK}
                        setEntity={setLeagueTeamFK}
                        menuRefs={menuRefs}
                        handleCreateOrg={handleCreateOrg}
                        handleCreateSchoolChilds={HandleCreateSchoolChilds}
                        handleProfileType={handleProfileType}
                        handleConfirmRemoveSchoolOrgs={
                          HandleConfirmRemoveSchoolOrgs
                        }
                      />
                    )}

                    {/* School Years page*/}
                    {isSchoolYearsPage && !isShowEdit && (
                      <AVCardList
                        tab={"Group"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={leagueTeamFK}
                        setEntity={setLeagueTeamFK}
                        menuRefs={menuRefs}
                        handleCreateSchoolChilds={HandleCreateSchoolChilds}
                        handleConfirmRemoveSchoolOrgs={
                          HandleConfirmRemoveSchoolOrgs
                        }
                      />
                    )}

                    {/* School Alumni page*/}
                    {isSchoolAlumniPage && !isShowEdit && (
                      <AVCardList
                        tab={"Season"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={leagueTeamFK}
                        setEntity={setLeagueTeamFK}
                        menuRefs={menuRefs}
                      />
                    )}

                    {/* School/Alumni/SchoolYear GradClass page*/}
                    {(isSchoolGradClassPage ||
                      isSchoolAlumniGradClassPage ||
                      isSchoolYearGradClassPage) &&
                      !isShowEdit && (
                        <AVCardList
                          tab={"GradClass"}
                          isAdminView={isAdminView}
                          isCreate={isCreate}
                          setIsCreate={setIsCreate}
                          entity={leagueTeamFK}
                          setEntity={setLeagueTeamFK}
                          handleCreateSchoolChilds={HandleCreateSchoolChilds}
                          handleConfirmRemoveSchoolOrgs={
                            HandleConfirmRemoveSchoolOrgs
                          }
                        />
                      )}

                    {/* Fee Collection page*/}
                    {isFeeCollectionPage && !isShowEdit && (
                      <AVFeeCollection
                        entity={leagueTeamFK}
                        setEntity={setLeagueTeamFK}
                        seriesId={seriesId}
                        isAdminView={isAdminView}
                        isOngoingOrFuture={
                          isOngoingOrFuture || isEntireSeriesAvailable
                        }
                      />
                    )}

                    {/* Fee Collection About page */}
                    {isCollectAboutPage &&
                      leagueTeamFK?.profile?.text &&
                      !isShowEdit && (
                        <AVFeeCollectAbout entity={leagueTeamFK} />
                      )}

                    {/* Fee Collection Member page*/}
                    {isCollectMembersPage && !isShowEdit && (
                      <AVFeeCollectMembers
                        entity={leagueTeamFK}
                        setEntity={setLeagueTeamFK}
                        isAdminView={isAdminView}
                        handleProfileType={handleProfileType}
                      />
                    )}

                    {/* feedback page*/}
                    {isFeebackGroup && !isShowEdit && (
                      <Box
                        zIndex={isDropDown ? -3 : ""}
                        minHeight={"340px"}
                        borderRadius={5}
                        backgroundColor={"AVColor.white"}
                        shadow={1}
                        flex={1}
                        mb={3}
                      >
                        <VStack>
                          <HStack
                            flexWrap={"wrap"}
                            zIndex={-2}
                            alignSelf={"flex-start"}
                            space={3}
                            p={2}
                          >
                            {isshowteamsList?.length > 0 &&
                              isshowteamsList?.map((item, i) => (
                                <Box
                                  key={item.id + i}
                                  bgColor={"#fff"}
                                  borderWidth={"1px"}
                                  borderColor={"AVColor.hovercolor2"}
                                  minWidth={130}
                                  minHeight={175}
                                  borderRadius={5}
                                  marginLeft={2}
                                  marginY={2}
                                  py={3}
                                  shadow={1}
                                >
                                  <VStack
                                    key={item?.id}
                                    alignItems={"flex-start"}
                                    padding={2}
                                    height={"100%"}
                                    width={"100%"}
                                  >
                                    <Pressable
                                      height={"100%"}
                                      width={"100%"}
                                      key={item.id}
                                      _hover={{ bgColor: "gray.100" }}
                                      p={2}
                                      borderRadius={5}
                                      minWidth={120}
                                      onPress={() => {
                                        navigate(
                                          `/teams/${item?.id}/${item?.region}`,
                                          {
                                            state: {
                                              isCreate: false,
                                              team: item,
                                              type: "Group",
                                            },
                                          },
                                        );
                                        setIsFeedBackGroup(false);
                                      }}
                                    >
                                      {item?.thumb && (
                                        <Box
                                          bgColor={"#FF6600"}
                                          borderRadius={["full"]}
                                          width={"60px"}
                                          height={"60px"}
                                          alignSelf={"center"}
                                        >
                                          <Image
                                            source={{
                                              uri: AV.Media.getThumb(item),
                                            }}
                                            borderRadius={["full"]}
                                            width={"100%"}
                                            height={["100%"]}
                                          />
                                        </Box>
                                      )}
                                      {!item?.thumb && (
                                        <Box alignItems={"center"}>
                                          <Profile
                                            height={"60"}
                                            width={"60"}
                                            color={"#32AE78"}
                                          />
                                        </Box>
                                      )}
                                      <Tooltip
                                        label={item.title}
                                        openDelay={500}
                                      >
                                        <Pressable
                                          onPress={() => {
                                            navigate(
                                              `/teams/${item?.id}/${item?.region}`,
                                              {
                                                state: {
                                                  isCreate: false,
                                                  team: item,
                                                },
                                              },
                                            );
                                          }}
                                        >
                                          <Text
                                            numberOfLines={1}
                                            maxWidth={"100px"}
                                            alignSelf={"center"}
                                            fontWeight={"500"}
                                          >
                                            {item.title}
                                          </Text>
                                        </Pressable>
                                      </Tooltip>
                                    </Pressable>
                                  </VStack>
                                </Box>
                              ))}
                          </HStack>
                        </VStack>
                      </Box>
                    )}

                    {/* member page*/}
                    {isMembersPage && !isShowEdit && (
                      <AVCardList
                        tab={"Members"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={leagueTeamFK}
                        setEntity={setLeagueTeamFK}
                        handleChat={handleChat}
                        createConvoKey={"M"}
                        handleGroupChat={HandleGroupChat}
                        handleRemoveGroup={HandleRemoveMembers}
                        handleProfileType={handleProfileType}
                        setIsMoreMenuDrp={setIsDropDown}
                        handleHomeClick={handleHomeClick}
                        onboardingFlow={onboardingFlow}
                        onboardingStep={onboardingStep}
                        setOnboardingStep={setOnboardingStep}
                        clearCurrentTourFlow={clearCurrentTourFlow}
                      />
                    )}

                    {/* photo page*/}
                    {isPhotoPage && !isShowEdit && (
                      <Createalbumpopup
                        isDocumentPage={isDocumentPage}
                        Parentdata={leagueTeamFK}
                        isOwner={isAdminView}
                        isPhotoPage={isPhotoPage}
                        albumlist={albumlist}
                        setalbumlist={setalbumlist}
                        filesList={filesList}
                        setfilesList={setfilesList}
                        filesListany={undefined}
                        editAccess={
                          isOngoingOrFuture || isEntireSeriesAvailable
                        }
                        helpText={helptext}
                      />
                    )}

                    {/* document page*/}
                    {isDocumentPage && !isShowEdit && !isCreate && (
                      <Createalbumpopup
                        isDocumentPage={isDocumentPage}
                        Parentdata={leagueTeamFK}
                        isPhotoPage={isPhotoPage}
                        albumlist={albumlist}
                        isOwner={isAdminView}
                        setalbumlist={setalbumlist}
                        filesList={filesList}
                        setfilesList={setfilesList}
                        filesListany={undefined}
                        editAccess={
                          isOngoingOrFuture || isEntireSeriesAvailable
                        }
                        helpText={helptext}
                      />
                    )}

                    {/* occurence page*/}
                    {isOccurencePage && !isShowEdit && (
                      <Box
                        width={"100%"}
                        minHeight={"340px"}
                        marginRight={4}
                        p={2}
                        h="auto"
                        shadow={1}
                        bgColor="#fff"
                        rounded="lg"
                      >
                        <HStack flexWrap={"wrap"}>
                          {/* <AVEvents data={filteredEvents} allEventData={allEventData} /> */}
                          <RenderSeriesEvents
                            seriesEventsList={seriesEventsList}
                            event={leagueTeamFK}
                            setEntity={setLeagueTeamFK}
                            setEntityDatas={setEntitydata}
                          />
                        </HStack>
                      </Box>
                    )}

                    {/* feeds page*/}
                    {/*<Box*/}
                    {/*  mt={[5]}*/}
                    {/*  justifyContent={"space-between"}*/}
                    {/*  maxWidth={[1063]}*/}
                    {/*  paddingRight={0}*/}
                    {/*  height={"auto"}*/}
                    {/*  marginBottom={"30px"}*/}
                    {/*>*/}
                    {/*  {!isShowEdit &&*/}
                    {/*    isTeamsPage &&*/}
                    {/*    leagueTeamFK &&*/}
                    {/*    leagueTeamFK?.status !== "Deleted" && (*/}
                    {/*      <>*/}
                    {/*        <VStack*/}
                    {/*          borderRadius={12}*/}
                    {/*          bgColor={"#fff"}*/}
                    {/*          maxWidth={[1052]}*/}
                    {/*          flex={1}*/}
                    {/*          ref={rightRef}*/}
                    {/*        >*/}
                    {/*          <VStack alignItems={"spece-around"} marginTop={"-20px"}>*/}
                    {/*            <AVFeeds*/}
                    {/*              page={"Profile"}*/}
                    {/*              userInfo={leagueTeamFK}*/}
                    {/*              iscommentAccess={*/}
                    {/*                isStaffentity || isMemberEntity || isPlayerEntity*/}
                    {/*              }*/}
                    {/*              isOwner={*/}
                    {/*                isAdminView*/}
                    {/*                  ? isAdminView*/}
                    {/*                  : leagueTeamFK?.staff?.filter(*/}
                    {/*                        (x) => x?.id === currentUser?.id,*/}
                    {/*                      )?.length > 0*/}
                    {/*                    ? true*/}
                    {/*                    : false*/}
                    {/*              }*/}
                    {/*              id={leagueTeamFK?.id}*/}
                    {/*              isFollowing={isFollowing}*/}
                    {/*              Postdata={leagueTeamFK}*/}
                    {/*              offW={fixedWidth}*/}
                    {/*              isShowCreatePost={*/}
                    {/*                !(*/}
                    {/*                  leagueTeamFK?.status === "Canceled" ||*/}
                    {/*                  leagueTeamFK?.seriesEvents?.find((x) => x.id === seriesId)*/}
                    {/*                    ?.status === "Canceled" ||*/}
                    {/*                  isPastMeeting*/}
                    {/*                )*/}
                    {/*              }*/}
                    {/*              {...props}*/}
                    {/*            />*/}
                    {/*          </VStack>*/}
                    {/*        </VStack>*/}
                    {/*      </>*/}
                    {/*    )}*/}
                    {/*</Box>*/}

                    <Box
                      mt={[5]}
                      justifyContent={"space-between"}
                      maxWidth={[1063]}
                      paddingRight={0}
                      height={"auto"}
                      marginBottom={"30px"}
                    >
                      {!isShowEdit &&
                        isTeamsPage &&
                        leagueTeamFK &&
                        leagueTeamFK?.status !== "Deleted" &&
                        leagueTeamFK?.status !== "Collect" && (
                          <>
                            <VStack
                              borderRadius={12}
                              bgColor={"#fff"}
                              maxWidth={[1052]}
                              flex={1}
                              ref={rightRef}
                            >
                              <VStack
                                alignItems={"spece-around"}
                                marginTop={"-20px"}
                              >
                                <AVFeedsProfile
                                  Entity={leagueTeamFK}
                                  iscommentAccess={
                                    isStaffentity ||
                                    isMemberEntity ||
                                    isPlayerEntity
                                  }
                                  isOwner={
                                    isAdminView
                                      ? isAdminView
                                      : leagueTeamFK?.staff?.filter(
                                            (x) => x?.id === currentUser?.id,
                                          )?.length > 0
                                        ? true
                                        : false
                                  }
                                  id={leagueTeamFK?.id}
                                  isFollowing={isFollowing}
                                  Postdata={leagueTeamFK}
                                  offW={fixedWidth}
                                  isShowCreatePost={
                                    !(
                                      (
                                        leagueTeamFK?.status === "Canceled" ||
                                        leagueTeamFK?.seriesEvents?.find(
                                          (x) => x.id === seriesId,
                                        )?.status === "Canceled"
                                      )
                                      //|| isOngoingOrFuture
                                    )
                                  }
                                  entityType={leagueTeamFK?.type}
                                  isOngoingOrFuture={
                                    isOngoingOrFuture || isEntireSeriesAvailable
                                  }
                                  //isEntireSeriesAvailable={isEntireSeriesAvailable}
                                  {...props}
                                />
                              </VStack>
                            </VStack>
                          </>
                        )}
                    </Box>
                  </VStack>
                </VStack>
              </HStack>
            </HStack>
          </>
        )}
      </AVBody>

      {showFileuploadModal && (
        /* FileUploadModal Popup*/
        <Box
          position="fixed"
          bgColor={"AVColor.overlay2"}
          bottom={0}
          right={0}
          top={0}
          left={0}
          zIndex={99}
        >
          <Modal.Content
            bgColor={"#fff"}
            maxWidth={"100%"}
            width={"50%"}
            padding={"24px"}
            minHeight={[500]}
            left={"22%"}
            top={"20%"}
          >
            <HStack fontSize={"24px"} fontWeight={400} marginBottom={"24px"}>
              {isStaff
                ? Loc.currentLang.menu.staff
                : isPlayer &&
                    (leagueTeamFK?.subType == "Class" ||
                      leagueTeamFK?.subType == "GradClass")
                  ? Loc.currentLang.menu.addStudents
                  : isPlayer
                    ? Loc.currentLang.menu.players
                    : leagueTeamFK?.type == "PlayerOrg" ||
                        leagueTeamFK?.subType == "Class"
                      ? Loc.currentLang.menu.parents
                      : leagueTeamFK?.type == "Event"
                        ? Loc.currentLang.menu.participants
                        : Loc.currentLang.menu.members}
            </HStack>

            <VStack
              marginTop={"10px"}
              space={4}
              width={"auto"}
              overflowY={"auto"}
              height={"334px"}
              justifyContent={"flex-start"}
            >
              <HStack
                flexWrap={"wrap"}
                alignSelf={"flex-start"}
                space={6}
                zIndex={-1}
                justifyContent={"center"}
                height={"100px"}
                width={"98%"}
              >
                {contactList?.map((item) => (
                  <>
                    <HStack
                      alignItems={"center"}
                      borderStyle={"solid"}
                      borderColor={"rgba(0, 0, 0, 0.05)"}
                      borderRadius={"5px"}
                      width={"100%"}
                    >
                      <VStack
                        width={"100%"}
                        space={
                          item?.parentName ||
                          item?.parentEmail ||
                          item?.parentPhone
                            ? 8
                            : 4
                        }
                      >
                        <HStack width={"85%"}>
                          <HStack marginRight={"10px"} width={"30%"}>
                            {!isEditPlayerDetails || menu !== item ? (
                              <Text
                                fontWeight="500"
                                numberOfLines={1}
                                ellipsizeMode={"tail"}
                                fontSize={"16px"}
                                textAlign={"left"}
                                color={"#000000"}
                                width={"100%"}
                                textTransform={"capitalize"}
                              >
                                {item?.name}
                              </Text>
                            ) : (
                              <Box width={"80%"} marginTop={"3px"}>
                                <Input
                                  textAlign={"left"}
                                  fontSize={"16px"}
                                  paddingLeft={"0px"}
                                  paddingRight={"0px"}
                                  value={newname}
                                  defaultValue={menu?.name}
                                  onChangeText={(e) => setnewname(e)}
                                />
                              </Box>
                            )}
                          </HStack>

                          <HStack width={"48%"} marginRight={"10px"}>
                            {!isEditPlayerDetails || menu !== item ? (
                              <Text
                                fontSize={"16px"}
                                width={"100%"}
                                numberOfLines={1}
                                ellipsizeMode={"tail"}
                                textAlign={"left"}
                              >
                                {item?.email}
                              </Text>
                            ) : (
                              <Box width={"80%"} marginTop={"3px"}>
                                <Input
                                  textAlign={"left"}
                                  fontSize={"16px"}
                                  paddingLeft={"0px"}
                                  paddingRight={"0px"}
                                  value={newmail}
                                  defaultValue={menu?.email}
                                  onChangeText={(e) => setnewmail(e)}
                                />
                              </Box>
                            )}
                          </HStack>

                          {isStaff && (
                            <HStack width={"16%"} marginRight={"10px"}>
                              {!isEditPlayerDetails || menu !== item ? (
                                <Text
                                  fontSize={"16px"}
                                  width={"100%"}
                                  textAlign={"left"}
                                  color={"#000000"}
                                >
                                  {isStaff
                                    ? item?.role?.name
                                      ? item?.role?.name
                                      : leagueTeamFK?.roles[0]?.name
                                    : ""}
                                </Text>
                              ) : (
                                <HStack width={"65%"} marginTop={"10px"}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      {Loc.currentLang.menu.roles}
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={staffRole}
                                      label={Loc.currentLang.menu.roles}
                                      onChange={(e) =>
                                        setStaffRole(e.target.value)
                                      }
                                      style={
                                        isMobile
                                          ? customSelectStyle
                                          : customSelectStyleeeess
                                      }
                                    >
                                      {leagueTeamFK?.roles?.map((option) => (
                                        <MenuItem
                                          key={option?.name}
                                          value={option?.name}
                                        >
                                          {option?.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </HStack>
                              )}
                            </HStack>
                          )}

                          {item?.phone && (
                            <HStack width={"16%"} marginRight={"10px"}>
                              {!isEditPlayerDetails || menu !== item ? (
                                <Text
                                  fontSize={"16px"}
                                  width={"100%"}
                                  textAlign={"left"}
                                  color={"#000000"}
                                >
                                  {item?.phone}
                                </Text>
                              ) : (
                                <HStack width={"65%"} marginTop={"10px"}>
                                  <Input
                                    textAlign={"left"}
                                    fontSize={"16px"}
                                    paddingLeft={"0px"}
                                    paddingRight={"0px"}
                                    value={newPhone}
                                    defaultValue={menu?.phone}
                                    onChangeText={(e) => setNewPhone(e)}
                                  />
                                </HStack>
                              )}
                            </HStack>
                          )}
                        </HStack>

                        {(item?.parentName ||
                          item?.parentEmail ||
                          item?.parentPhone) && (
                          <HStack width={"85%"}>
                            {item?.parentName && (
                              <HStack marginRight={"10px"} width={"30%"}>
                                {!isEditPlayerDetails || menu !== item ? (
                                  <Text
                                    fontWeight="500"
                                    numberOfLines={1}
                                    ellipsizeMode={"tail"}
                                    fontSize={"16px"}
                                    textAlign={"left"}
                                    color={"#000000"}
                                    width={"100%"}
                                    textTransform={"capitalize"}
                                  >
                                    {item?.parentName}
                                  </Text>
                                ) : (
                                  <Box width={"80%"} marginTop={"3px"}>
                                    <Input
                                      textAlign={"left"}
                                      fontSize={"16px"}
                                      paddingLeft={"0px"}
                                      paddingRight={"0px"}
                                      value={newParentName}
                                      defaultValue={menu?.parentName}
                                      onChangeText={(e) => setNewParentName(e)}
                                    />
                                  </Box>
                                )}
                              </HStack>
                            )}

                            {item?.parentEmail && (
                              <HStack width={"48%"} marginRight={"10px"}>
                                {!isEditPlayerDetails || menu !== item ? (
                                  <Text
                                    fontSize={"16px"}
                                    width={"100%"}
                                    numberOfLines={1}
                                    ellipsizeMode={"tail"}
                                    textAlign={"left"}
                                    //textTransform={ 'capitalize' }
                                  >
                                    {item?.parentEmail}
                                  </Text>
                                ) : (
                                  <Box width={"80%"} marginTop={"3px"}>
                                    <Input
                                      textAlign={"left"}
                                      fontSize={"16px"}
                                      paddingLeft={"0px"}
                                      paddingRight={"0px"}
                                      value={newParentEmail}
                                      defaultValue={menu?.parentEmail}
                                      onChangeText={(e) => setNewParentEmail(e)}
                                    />
                                  </Box>
                                )}
                              </HStack>
                            )}

                            {item?.parentPhone && (
                              <HStack width={"16%"} marginRight={"10px"}>
                                {!isEditPlayerDetails || menu !== item ? (
                                  <Text
                                    fontSize={"16px"}
                                    width={"100%"}
                                    textAlign={"left"}
                                    color={"#000000"}
                                  >
                                    {item?.parentPhone}
                                  </Text>
                                ) : (
                                  <HStack width={"65%"} marginTop={"10px"}>
                                    <Input
                                      textAlign={"left"}
                                      fontSize={"16px"}
                                      paddingLeft={"0px"}
                                      paddingRight={"0px"}
                                      value={newParentPhone}
                                      defaultValue={menu?.parentPhone}
                                      onChangeText={(e) => setNewParentPhone(e)}
                                    />
                                  </HStack>
                                )}
                              </HStack>
                            )}
                          </HStack>
                        )}

                        <HStack width={"85%"}>
                          {(!isEditPlayerDetails || menu !== item) && (
                            <Button
                              backgroundColor={"white"}
                              width={"50px"}
                              height={
                                item?.parentName ||
                                item?.parentEmail ||
                                item?.parentPhone
                                  ? "20px"
                                  : "40px"
                              }
                              isDisabled={isLoading}
                              onPress={() => {
                                setmenu(item);
                                setnewmail(item?.email);
                                setStaffRole(
                                  item?.role?.name ??
                                    leagueTeamFK?.roles?.[0]?.name ??
                                    "",
                                );
                                setnewname(item?.name);
                                setNewPhone(item?.phone ?? "");
                                setNewParentName(item?.parentName ?? "");
                                setNewParentEmail(item?.parentEmail ?? "");
                                setNewParentPhone(item?.parentPhone ?? "");
                                setIsEditPlayerDetails(true);
                              }}
                            >
                              <HStack>
                                <Text
                                  fontSize={"16px"}
                                  underline
                                  textAlign={"center"}
                                  color={"#00A7BC"}
                                >
                                  {Loc.currentLang.menu.edit}
                                </Text>
                              </HStack>
                            </Button>
                          )}{" "}
                          {isEditPlayerDetails && menu === item && (
                            <Button
                              backgroundColor={"white"}
                              width={"50px"}
                              height={
                                item?.parentName ||
                                item?.parentEmail ||
                                item?.parentPhone
                                  ? "20px"
                                  : "40px"
                              }
                              onPress={() => {
                                handleUpdateStaff(item);
                              }}
                            >
                              <HStack>
                                <Text
                                  fontSize={"16px"}
                                  underline
                                  textAlign={"center"}
                                  color={"#00A7BC"}
                                >
                                  {Loc.currentLang.menu.update}
                                </Text>
                              </HStack>
                            </Button>
                          )}
                          <Button
                            backgroundColor={"white"}
                            height={
                              item?.parentName ||
                              item?.parentEmail ||
                              item?.parentPhone
                                ? "20px"
                                : "40px"
                            }
                            width={"50px"}
                            isDisabled={isLoading}
                            onPress={() => handleRemoveStaff(item)}
                          >
                            <HStack>
                              <Text
                                fontSize={"16px"}
                                underline
                                textAlign={"center"}
                                color={"#DF2827"}
                              >
                                {Loc.currentLang.menu.delete}
                              </Text>
                            </HStack>
                          </Button>
                        </HStack>
                      </VStack>
                    </HStack>
                    <Divider marginTop={"5px"} />
                  </>
                ))}
              </HStack>
            </VStack>

            <HStack
              width={"100%"}
              space={5}
              flex={1}
              justifyContent={"flex-end"}
              alignItems={"top"}
              pr={5}
              top={"88%"}
              position="absolute"
              right="10px"
              maxHeight={"200px"}
              padding={0}
              background={"none"}
            >
              <Button
                background={"#EEEEEE"}
                borderRadius={15}
                px={16}
                height={"40px"}
                width={"40px"}
                rounded="full"
                onPress={() => {
                  setshowFileuploadModal(false);
                }}
              >
                <Text color={"#000000"}>{Loc.currentLang.menu.cancel}</Text>
              </Button>

              <Button
                bgColor={"AVColor.primary"}
                height={"40px"}
                isLoading={isLoading}
                isLoadingText={"Saving.."}
                width={"40px"}
                borderRadius={15}
                px={16}
                rounded="full"
                isDisabled={contactList?.length === 0}
                onPress={handleAddContactList}
              >
                <Text color={"#ffffff"}>{Loc.currentLang.menu.save}</Text>
              </Button>
            </HStack>
          </Modal.Content>
        </Box>
      )}

      {staffReq && (
        /*Staff req popup*/
        <Box
          position="fixed"
          bgColor={"AVColor.overlay2"}
          bottom={0}
          right={0}
          top={0}
          left={0}
          zIndex={9999}
        >
          <div
            className={`create_post_popup ${mobile && "create_post_popup_mobile"}`}
            style={{
              width: mobile ? dimensions.width - 15 : "600px",
              height: "auto",
              marginTop: "12px",
            }}
          >
            <VStack height={"100%"} width={"100%"} padding={"24px"}>
              <HStack>
                <Text fontWeight={400} fontSize={"30px"}>
                  {Loc.currentLang.menu.staffRequest}
                </Text>
              </HStack>
              <HStack marginY={"24px"}>
                <Text fontWeight={500} fontSize={"16px"}>
                  {Loc.currentLang.menu.staffRequestFormSubmission}
                </Text>
              </HStack>

              <Box>
                <AVInputtext
                  type={"text"}
                  minRows="5"
                  size="medium"
                  multiline={true}
                  maxLength={undefined}
                  onChange={(e) => setIsStaffDesc(e?.target?.value)}
                  defaultValue={undefined}
                  width={undefined}
                  value={StaffDesc}
                  height={"60px"}
                  label={`${Loc.currentLang.placeholderText.personalDescription} *`}
                  placeholder={undefined}
                />
              </Box>

              <HStack
                justifyContent={"center"}
                top={"65%"}
                space={"24px"}
                marginTop={"24px"}
              >
                <Button
                  width={"20%"}
                  height={"40px"}
                  borderRadius={"19px"}
                  backgroundColor={"#e5e5e5"}
                  onPress={() => {
                    setIsStaffReq(false);
                    setIsStaffDesc("");
                  }}
                >
                  <Text
                    color={"rgba(0,0,0,0.5)"}
                    fontWeight={500}
                    fontSize={[14, 16]}
                  >
                    {Loc.currentLang.menu.cancelCaps}
                  </Text>
                </Button>

                <Button
                  width={"22%"}
                  height={"40px"}
                  borderRadius={"19px"}
                  backgroundColor={"AVColor.primary"}
                  isLoading={isLoader}
                  isDisabled={!StaffDesc}
                  onPress={() => handlestaffandorgReq()}
                >
                  <Text color={"white"} fontWeight={500} fontSize={[14, 16]}>
                    {Loc.currentLang.menu.submitCaps}
                  </Text>
                </Button>
              </HStack>
            </VStack>
          </div>
        </Box>
      )}

      {childOrgReq && (
        /*Child org req popup*/
        <Box
          position="fixed"
          bgColor={"AVColor.overlay2"}
          bottom={0}
          right={0}
          top={0}
          left={0}
          zIndex={9999}
        >
          <div
            className={`create_post_popup ${mobile && "create_post_popup_mobile"}`}
            style={{
              width: mobile ? dimensions.width - 15 : "600px",
              height: "auto",
              marginTop: "12px",
            }}
          >
            <VStack height={"100%"} width={"100%"} padding={"24px"}>
              <HStack>
                <Text fontWeight={400} fontSize={"30px"}>
                  {Loc.currentLang.menu.addChildOrganization}
                </Text>
              </HStack>
              <HStack marginY={"24px"}>
                <Text fontWeight={500} fontSize={"16px"}>
                  {Loc.currentLang.menu.requestForAddingaChildOrganization}
                </Text>
              </HStack>

              <Box marginBottom={"24px"}>
                <AVInputtext
                  type={"text"}
                  label={"child org One"}
                  maxLength={50}
                  onChange={(e) => searchOrgs(e?.target?.value)}
                  defaultValue={undefined}
                  width={undefined}
                  value={childOrgOne}
                  height={undefined}
                  minRows={undefined}
                  multiline={undefined}
                  size={undefined}
                  placeholder={undefined}
                />
              </Box>

              {childOrgOne?.length > 0 &&
                isDropList &&
                selctChildOrg?.map((item) => (
                  <VStack
                    width={"300px"}
                    height={"auto"}
                    shadow={2}
                    padding={"24px"}
                    background={"#FFFFFF"}
                    position={"absolute"}
                    top={"50%"}
                    zIndex={999}
                    borderRadius={"6px"}
                  >
                    <Pressable
                      width={"250px"}
                      height={"36px"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      onPress={() => {
                        setChildOrg(item?.title);
                        setChildorgId(item);
                        setIsDropList(false);
                      }}
                    >
                      <Text
                        fontSize={"14px"}
                        fontFamily={"Roboto"}
                        numberOfLines={1}
                        width={"250px"}
                      >
                        {item?.title}
                      </Text>
                    </Pressable>
                  </VStack>
                ))}

              <Box>
                <AVInputtext
                  type={"text"}
                  minRows="5"
                  size="medium"
                  multiline={true}
                  maxLength={undefined}
                  onChange={(e) => setJusti(e?.target?.value)}
                  defaultValue={undefined}
                  width={undefined}
                  value={justi}
                  height={"60px"}
                  label={"Justification"}
                  placeholder={undefined}
                />
              </Box>

              <HStack
                justifyContent={"center"}
                top={"65%"}
                space={"24px"}
                marginTop={"24px"}
              >
                <Button
                  width={"20%"}
                  height={"40px"}
                  borderRadius={"19px"}
                  backgroundColor={"#e5e5e5"}
                  onPress={() => {
                    setIsChildOrgReq(false);
                    setJusti("");
                    setChildOrg("");
                    setChildorgId("");
                  }}
                >
                  <Text
                    color={"rgba(0,0,0,0.5)"}
                    fontWeight={500}
                    fontSize={[14, 16]}
                  >
                    {Loc.currentLang.menu.cancelCaps}
                  </Text>
                </Button>

                <Button
                  width={"22%"}
                  height={"40px"}
                  borderRadius={"19px"}
                  backgroundColor={"AVColor.primary"}
                  isDisabled={!chiledorgId || !justi}
                  isLoading={isLoader}
                  onPress={() => handlestaffandorgReq()}
                >
                  <Text color={"white"} fontWeight={500} fontSize={[14, 16]}>
                    {Loc.currentLang.menu.submitCaps}
                  </Text>
                </Button>
              </HStack>
            </VStack>
          </div>
        </Box>
      )}

      {isImagePopup && (
        /*View Map popup*/
        <Box
          position={"fixed"}
          top={0}
          bottom={0}
          left={0}
          right={0}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          backgroundColor={"rgba(0, 0, 0, 0.25)"}
          zIndex={9999}
        >
          <div className={`show_unauthorized_details`}>
            <HStack
              alignItems={"center"}
              justifyContent={"flex-end"}
              borderBottomColor={"AVColor.grey"}
              px={5}
              py={3}
              zIndex={99}
              width={isMobile ? "85%" : ""}
            >
              <AVCancel
                color={undefined}
                size={undefined}
                callback={() => setIsImagePopup(false)}
              />
            </HStack>

            <HStack width={isMobile ? "90%" : "100%"} height={"100%"} space={3}>
              {leagueTeamFK?.location?.siteMap?.type?.startsWith("image") ? (
                <Pressable
                  width={isMobile ? "90%" : "100%"}
                  height={"80%"}
                  onPress={() => {
                    openPreview(leagueTeamFK?.location?.siteMap, allImages);
                    setIsImagePopup(false);
                  }}
                >
                  <img
                    src={Media.getURL(leagueTeamFK?.location?.siteMap)}
                    alt="sitemap"
                    height={"100%"}
                    width={"100%"}
                    style={{ objectFit: "contain" }}
                  />
                </Pressable>
              ) : (
                <Pressable
                  width={isMobile ? "90%" : "100%"}
                  height={"80%"}
                  onPress={() => {
                    handledocument(leagueTeamFK?.location?.siteMap);
                  }}
                >
                  <img
                    //@ts-ignore
                    src={
                      (leagueTeamFK?.location?.siteMap?.type ===
                        "application/pdf" &&
                        settings.pdf) ||
                      ((leagueTeamFK?.location?.siteMap?.type ===
                        "application/msword" ||
                        leagueTeamFK?.location?.siteMap?.type ===
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document") &&
                        settings.word) ||
                      ((leagueTeamFK?.location?.siteMap?.type ===
                        "application/vnd.ms-powerpoint" ||
                        leagueTeamFK?.location?.siteMap?.type ===
                          "application/vnd.openxmlformats-officedocument.presentationml.presentation") &&
                        settings.powerpoint) ||
                      ((leagueTeamFK?.location?.siteMap?.type?.type ===
                        "application/vnd.ms-excel" ||
                        leagueTeamFK?.location?.siteMap?.type ===
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") &&
                        settings.excel) ||
                      ((leagueTeamFK?.location?.siteMap?.type ===
                        "text/plain" ||
                        leagueTeamFK?.location?.siteMap?.type ===
                          "text/plain") &&
                        settings.file) ||
                      settings.file
                    }
                    style={{
                      margin: "1px",
                      objectFit: "contain",
                      height: "100%",
                      width: "100%",
                    }}
                  />
                </Pressable>
              )}
            </HStack>
          </div>
        </Box>
      )}

      {showAddProfileModal && (
        /*Staff,member,player,participant popup*/
        <AVPersonaModal
          isMember={isMember}
          isParticipant={isParticipant}
          setShowAddProfileModal={setShowAddProfileModal}
          isStaff={isStaff}
          Entity={leagueTeamFK}
          setEntity={setLeagueTeamFK}
          setcontactList={setcontactList}
          setshowFileuploadModal={setshowFileuploadModal}
          setStaffList={setStaffList}
          setmemberList={setmemberList}
          isPlayer={isPlayer}
          setPlayersList={setPlayersList}
          setIsParticipantList={setIsParticipantList}
          setFilteredParticipantList={setFilteredParticipantList}
          setStatus={setStatus}
          showAddProfileModal={showAddProfileModal}
          isTeam={isTeam}
          searchTypes={searchTypes}
          setOrgList={setOrgList}
          setGroupList={setGroupList}
          isEditEntireSeries={isEditEntireSeries}
          seriesEvent={seriesEvent}
          isSchoolTeamsPage={isSchoolTeamsPage}
          onboardingFlow={onboardingFlow}
          onboardingStep={onboardingStep}
          setOnboardingStep={setOnboardingStep}
          clearCurrentTourFlow={clearCurrentTourFlow}
        />
      )}

      {isConfirmDelete && (
        /*Confirmation popup*/
        <AVConfirmationModal
          showconfirmationPopup={isConfirmDelete}
          setshowconfirmationPopup={setisConfirmDelete}
          Confirmationtext={Confirmationtext}
          type={selectType}
          item={itemSelect}
          function={
            selectType == "RestoreAccount"
              ? handleRestore
              : selectType == "DeleteSeason"
                ? RemoveSeason
                : selectType == "RemoveSchoolSeason"
                  ? HandleRemoveSchoolOrgs
                  : selectType == "RemoveSchoolGradClass"
                    ? HandleRemoveSchoolOrgs
                    : selectType == "DeleteStaff"
                      ? RemoveStaffs
                      : selectType == "DeleteParticipant"
                        ? RemoveParticiapnt
                        : selectType == "DeletePlayer"
                          ? handleRemoveplayers
                          : selectType == "RemoveResource"
                            ? handleRemoveResourses
                            : selectType == "DeleteMember"
                              ? handleDeleteMember
                              : selectType == "DeleteGroup"
                                ? handleDeleteGroup
                                : selectType == "ToggleSilence"
                                  ? handleToggleSilence
                                  : ""
          }
          isLoader={isLoader}
        />
      )}

      {showAddResourceModal && (
        /*Resources Popup*/
        <Box
          position="fixed"
          bgColor={"AVColor.overlay2"}
          bottom={0}
          top={[`${65 - 1}px`]}
          right={0}
          left={0}
        >
          {/* body */}
          <div
            style={{
              position: "fixed",
              top: "53%",
              left: "50%",
              transform: "translate(-53%, -50%)",
              background: "#ffffff",
              boxShadow:
                "0 12px 28px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(255, 255, 255, 0.5)",
              width: isMobile ? "88%" : "48%",
              borderRadius: "8px",
              minHeight: "400px",
            }}
          >
            <VStack flex={1} minHeight={"450px"} space={3}>
              {/* Header */}
              <HStack
                alignItems={"center"}
                justifyContent={"space-between"}
                borderBottomColor={"AVColor.grey"}
                px={5}
                py={3}
              >
                <Text fontSize={24}>
                  {showResourceModal
                    ? Loc.currentLang.menu.viewItem
                    : editresourses
                      ? Loc.currentLang.menu.editItem
                      : Loc.currentLang.menu.addItem}
                </Text>

                {!editresourses && !showResourceModal && (
                  <Tooltip
                    label={Loc.currentLang.helpText.event.resourcesTab}
                    w={200}
                    openDelay={100}
                  >
                    <Box
                      position={"absolute"}
                      right={"60px"}
                      p={"9px"}
                      backgroundColor={"AVColor.liteBg"}
                      rounded={"full"}
                    >
                      <img src={helping} height={"17px"} width={"17px"} />
                    </Box>
                  </Tooltip>
                )}
                <AVCancel
                  color={undefined}
                  size={undefined}
                  callback={() => handleCancelItem()}
                />
              </HStack>

              <Divider />
              {/* modal-Body */}
              <VStack
                px={5}
                py={3}
                space={3}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <HStack justifyContent={"center"} width={"100%"}>
                  <Box width={"100%"}>
                    <AVInputtext
                      type={"text"}
                      label={Loc.currentLang.menu.itemDescription}
                      onChange={(e) => setdescription(e.target.value)}
                      value={description}
                      width={"100%"}
                      height={"20px"}
                      defaultValue={undefined}
                      maxLength={50}
                      minRows={undefined}
                      multiline={undefined}
                      placeholder={undefined}
                      size={undefined}
                      disabled={showResourceModal}
                    />
                  </Box>
                </HStack>

                <HStack justifyContent={"center"} width={"100%"}>
                  <Box width={"100%"}>
                    <AVInputtext
                      type={"text"}
                      label={Loc.currentLang.menu.quantity}
                      onChange={(e) =>
                        setquantity(e.target.value.replace(/[^0-9]/g, ""))
                      }
                      value={quantity}
                      width={"100%"}
                      height={"20px"}
                      maxLength={6}
                      defaultValue={undefined}
                      minRows={undefined}
                      multiline={undefined}
                      placeholder={undefined}
                      size={undefined}
                      disabled={showResourceModal}
                    />
                  </Box>
                </HStack>

                <HStack justifyContent={"center"} width={"100%"}>
                  <Box width={"100%"}>
                    <AVInputtext
                      type={"text"}
                      label={Loc.currentLang.menu.assignToTeamMember}
                      onChange={(e) => searchPlayerItems(e.target.value)}
                      value={assienTeammember}
                      width={"100%"}
                      height={"20px"}
                      defaultValue={undefined}
                      maxLength={50}
                      minRows={undefined}
                      multiline={undefined}
                      placeholder={undefined}
                      size={undefined}
                      disabled={showResourceModal}
                    />
                  </Box>
                </HStack>

                <HStack width="100%" height="auto" zIndex="9999">
                  {filteredResults?.length > 0 && (
                    <Box
                      width={"94%"}
                      position="absolute"
                      top={"-13"}
                      maxHeight="230px"
                      minHeight="43px"
                      bgColor={["AVColor.white"]}
                      background={"#ffffff"}
                      borderColor={"AVColor.buttonBg"}
                      shadow="2"
                      left={"19px"}
                      borderRadius="8px"
                      overflowY="scroll"
                    >
                      {filteredResults?.map((item, i) => (
                        <Box key={item.id + i}>
                          <Pressable
                            padding={"10px"}
                            _hover={{ bgColor: "AVColor.buttonBg" }}
                            onPress={(e) => handlePlayerName(item)}
                          >
                            <HStack space={2}>
                              <EntityProfilePic
                                width={50}
                                height={50}
                                link={item}
                              />
                              <VStack>
                                <Text fontWeight="bold">{item.title}</Text>
                                {/*<Text fontSize={'12px'}>{item.blurb}</Text>*/}
                              </VStack>
                            </HStack>
                          </Pressable>
                        </Box>
                      ))}
                    </Box>
                  )}
                </HStack>

                <HStack justifyContent={"center"} width={"100%"}>
                  <Box width={"100%"}>
                    <AVInputtext
                      type={"text"}
                      label={Loc.currentLang.menu.additionalNote}
                      onChange={(e) => setnote(e.target.value)}
                      value={note}
                      width={"100%"}
                      height={"38px"}
                      defaultValue={undefined}
                      maxLength={500}
                      minRows={6}
                      multiline={true}
                      placeholder={undefined}
                      size={"medium"}
                      disabled={showResourceModal}
                    />
                  </Box>
                </HStack>

                {!showResourceModal && (
                  <>
                    {/* ERROR MESSAGE */}
                    {error && (
                      <HStack
                        width="100%"
                        px={5}
                        py={2}
                        mb={2}
                        bg="#FFF4F4"
                        borderWidth={1}
                        borderColor="#FCA5A5"
                        borderRadius="6px"
                      >
                        <Text color="#B91C1C" fontSize="sm">
                          {error}
                        </Text>
                      </HStack>
                    )}
                    <HStack
                      width={"100%"}
                      height="100%"
                      space={5}
                      flex={1}
                      justifyContent={"flex-end"}
                      px={5}
                      m={3}
                      zIndex={-1}
                    >
                      <AVButtonRoundInvert
                        btnText={Loc.currentLang.menu.cancel}
                        callback={() => handleCancelItem()}
                        px={undefined}
                        height={undefined}
                        isLoadingText={undefined}
                        isDisabled={undefined}
                        isLoading={undefined}
                        loading={undefined}
                      />
                      {editresourses && (
                        <AVButtonRoundInvert
                          btnText={Loc.currentLang.menu.removeItem}
                          loading={undefined}
                          isLoadingText={Loc.currentLang.menu.removingLoad}
                          callback={handleRemoveResourcePopup}
                          px={undefined}
                          height={undefined}
                          isDisabled={undefined}
                          isLoading={undefined}
                        />
                      )}

                      <AVButtonRoundedFull
                        loading={isLoader}
                        isLoadingText={
                          editresourses
                            ? Loc.currentLang.menu.saveLoad
                            : Loc.currentLang.menu.adding
                        }
                        isDisabled={
                          !quantity ||
                          Number(quantity) <= 0 ||
                          description?.trim()?.length == 0
                        }
                        btnText={
                          editresourses
                            ? Loc.currentLang.menu.save
                            : Loc.currentLang.menu.add
                        }
                        callback={handleAddResources}
                        px={undefined}
                        height={undefined}
                        isLoading={undefined}
                      />
                    </HStack>
                  </>
                )}
              </VStack>
            </VStack>
          </div>
        </Box>
      )}

      {showAddEventsModal && (
        /*CreateEvent Popup*/
        <AVCreateEventModal
          Entity={leagueTeamFK}
          repeatWeek={repeatWeek}
          setRepeatWeek={setRepeatWeek}
          isGame={isGame}
          isPractice={isPractice}
          setShowAddEventsModal={setShowAddEventsModal}
          typeevent={typeevent}
          setlocationaddress={setlocationaddress}
          locationaddress={locationaddress}
          datafield={datafield}
          showFields={showFields}
          setShowFields={setShowFields}
          updateField={updateField}
          setIsUpdateField={setIsUpdateField}
          siteField={siteField}
          setSiteField={setSiteField}
          mapField={mapField}
          setIsMapField={setIsMapField}
          isFieldsName={isFieldsName}
          setIsFieldsName={setIsFieldsName}
          handleupdatelocationfield={handleupdatelocationfield}
          setIsFieldName={setIsFieldName}
          fieldName={fieldName}
          isShowEdit={isShowEdit}
          setIsShowField={undefined}
          isShowField={undefined}
          showAddEventsModal={showAddEventsModal}
          isEditEntireSeries={isEditEntireSeries}
          setClickedUrl={setClickedUrl}
          setShowConfirmLinkPopup={setShowConfirmLinkPopup}
        />
      )}

      {showPreview && (
        <PreviewAlbums
          item={singleImage}
          items={allImages}
          setShowPreview={setShowPreview}
          setShowAllImage={setShowAllImage}
        />
      )}

      {showConfirmLinkPopup && (
        <AVConfirmLinkPopup
          url={clickedUrl}
          handleCancel={() => setShowConfirmLinkPopup(false)}
        />
      )}

      {showunauthorizedDetails && <ErrorHandlerPopup />}
    </>
  );
};

export default React.memo(Teams);
